/* eslint-disable */
// import external dependencies
import "jquery";

var $jscomp = $jscomp || {};
$jscomp.scope = {};
$jscomp.arrayIteratorImpl = function (a) {
  var b = 0;
  return function () {
    return b < a.length ? { done: !1, value: a[b++] } : { done: !0 };
  };
};
$jscomp.arrayIterator = function (a) {
  return { next: $jscomp.arrayIteratorImpl(a) };
};
$jscomp.makeIterator = function (a) {
  var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
  return b ? b.call(a) : $jscomp.arrayIterator(a);
};
$jscomp.arrayFromIterator = function (a) {
  for (var b, c = []; !(b = a.next()).done; ) {
    c.push(b.value);
  }
  return c;
};
$jscomp.arrayFromIterable = function (a) {
  return a instanceof Array
    ? a
    : $jscomp.arrayFromIterator($jscomp.makeIterator(a));
};
$jscomp.ASSUME_ES5 = !1;
$jscomp.ASSUME_NO_NATIVE_MAP = !1;
$jscomp.ASSUME_NO_NATIVE_SET = !1;
$jscomp.SIMPLE_FROUND_POLYFILL = !1;
$jscomp.ISOLATE_POLYFILLS = !1;
$jscomp.defineProperty =
  $jscomp.ASSUME_ES5 || "function" == typeof Object.defineProperties
    ? Object.defineProperty
    : function (a, b, c) {
        if (a == Array.prototype || a == Object.prototype) {
          return a;
        }
        a[b] = c.value;
        return a;
      };
$jscomp.getGlobal = function (a) {
  a = [
    "object" == typeof globalThis && globalThis,
    a,
    "object" == typeof window && window,
    "object" == typeof self && self,
    "object" == typeof global && global,
  ];
  for (var b = 0; b < a.length; ++b) {
    var c = a[b];
    if (c && c.Math == Math) {
      return c;
    }
  }
  throw Error("Cannot find global object");
};
$jscomp.global = $jscomp.getGlobal(this);
$jscomp.IS_SYMBOL_NATIVE =
  "function" === typeof Symbol && "symbol" === typeof Symbol("x");
$jscomp.TRUST_ES6_POLYFILLS =
  !$jscomp.ISOLATE_POLYFILLS || $jscomp.IS_SYMBOL_NATIVE;
$jscomp.polyfills = {};
$jscomp.propertyToPolyfillSymbol = {};
$jscomp.POLYFILL_PREFIX = "$jscp$";
var $jscomp$lookupPolyfilledValue = function (a, b) {
  var c = $jscomp.propertyToPolyfillSymbol[b];
  if (null == c) {
    return a[b];
  }
  c = a[c];
  return void 0 !== c ? c : a[b];
};
$jscomp.polyfill = function (a, b, c, d) {
  b &&
    ($jscomp.ISOLATE_POLYFILLS
      ? $jscomp.polyfillIsolated(a, b, c, d)
      : $jscomp.polyfillUnisolated(a, b, c, d));
};
$jscomp.polyfillUnisolated = function (a, b, c, d) {
  c = $jscomp.global;
  a = a.split(".");
  for (d = 0; d < a.length - 1; d++) {
    var e = a[d];
    e in c || (c[e] = {});
    c = c[e];
  }
  a = a[a.length - 1];
  d = c[a];
  b = b(d);
  b != d &&
    null != b &&
    $jscomp.defineProperty(c, a, { configurable: !0, writable: !0, value: b });
};
$jscomp.polyfillIsolated = function (a, b, c, d) {
  var e = a.split(".");
  a = 1 === e.length;
  d = e[0];
  d = !a && d in $jscomp.polyfills ? $jscomp.polyfills : $jscomp.global;
  for (var f = 0; f < e.length - 1; f++) {
    var g = e[f];
    g in d || (d[g] = {});
    d = d[g];
  }
  e = e[e.length - 1];
  c = $jscomp.IS_SYMBOL_NATIVE && "es6" === c ? d[e] : null;
  b = b(c);
  null != b &&
    (a
      ? $jscomp.defineProperty($jscomp.polyfills, e, {
          configurable: !0,
          writable: !0,
          value: b,
        })
      : b !== c &&
        (($jscomp.propertyToPolyfillSymbol[e] = $jscomp.IS_SYMBOL_NATIVE
          ? $jscomp.global.Symbol(e)
          : $jscomp.POLYFILL_PREFIX + e),
        (e = $jscomp.propertyToPolyfillSymbol[e]),
        $jscomp.defineProperty(d, e, {
          configurable: !0,
          writable: !0,
          value: b,
        })));
};
$jscomp.polyfill(
  "Object.is",
  function (a) {
    return a
      ? a
      : function (a, c) {
          return a === c ? 0 !== a || 1 / a === 1 / c : a !== a && c !== c;
        };
  },
  "es6",
  "es3"
);
$jscomp.polyfill(
  "Array.prototype.includes",
  function (a) {
    return a
      ? a
      : function (a, c) {
          var b = this;
          b instanceof String && (b = String(b));
          var e = b.length;
          c = c || 0;
          for (0 > c && (c = Math.max(c + e, 0)); c < e; c++) {
            var f = b[c];
            if (f === a || Object.is(f, a)) {
              return !0;
            }
          }
          return !1;
        };
  },
  "es7",
  "es3"
);
$jscomp.checkStringArgs = function (a, b, c) {
  if (null == a) {
    throw new TypeError(
      "The 'this' value for String.prototype." +
        c +
        " must not be null or undefined"
    );
  }
  if (b instanceof RegExp) {
    throw new TypeError(
      "First argument to String.prototype." +
        c +
        " must not be a regular expression"
    );
  }
  return a + "";
};
$jscomp.polyfill(
  "String.prototype.includes",
  function (a) {
    return a
      ? a
      : function (a, c) {
          return (
            -1 !==
            $jscomp.checkStringArgs(this, a, "includes").indexOf(a, c || 0)
          );
        };
  },
  "es6",
  "es3"
);
$jscomp.initSymbol = function () {};
$jscomp.polyfill(
  "Symbol",
  function (a) {
    if (a) {
      return a;
    }
    var b = function (a, b) {
      this.$jscomp$symbol$id_ = a;
      $jscomp.defineProperty(this, "description", {
        configurable: !0,
        writable: !0,
        value: b,
      });
    };
    b.prototype.toString = function () {
      return this.$jscomp$symbol$id_;
    };
    var c = 0,
      d = function (a) {
        if (this instanceof d) {
          throw new TypeError("Symbol is not a constructor");
        }
        return new b("jscomp_symbol_" + (a || "") + "_" + c++, a);
      };
    return d;
  },
  "es6",
  "es3"
);
$jscomp.initSymbolIterator = function () {};
$jscomp.polyfill(
  "Symbol.iterator",
  function (a) {
    if (a) {
      return a;
    }
    a = Symbol("Symbol.iterator");
    for (
      var b =
          "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(
            " "
          ),
        c = 0;
      c < b.length;
      c++
    ) {
      var d = $jscomp.global[b[c]];
      "function" === typeof d &&
        "function" != typeof d.prototype[a] &&
        $jscomp.defineProperty(d.prototype, a, {
          configurable: !0,
          writable: !0,
          value: function () {
            return $jscomp.iteratorPrototype($jscomp.arrayIteratorImpl(this));
          },
        });
    }
    return a;
  },
  "es6",
  "es3"
);
$jscomp.initSymbolAsyncIterator = function () {};
$jscomp.iteratorPrototype = function (a) {
  a = { next: a };
  a[Symbol.iterator] = function () {
    return this;
  };
  return a;
};
$jscomp.iteratorFromArray = function (a, b) {
  a instanceof String && (a += "");
  var c = 0,
    d = {
      next: function () {
        if (c < a.length) {
          var e = c++;
          return { value: b(e, a[e]), done: !1 };
        }
        d.next = function () {
          return { done: !0, value: void 0 };
        };
        return d.next();
      },
    };
  d[Symbol.iterator] = function () {
    return d;
  };
  return d;
};
$jscomp.polyfill(
  "Array.prototype.keys",
  function (a) {
    return a
      ? a
      : function () {
          return $jscomp.iteratorFromArray(this, function (a) {
            return a;
          });
        };
  },
  "es6",
  "es3"
);
$jscomp.checkEs6ConformanceViaProxy = function () {
  try {
    var a = {},
      b = Object.create(
        new $jscomp.global.Proxy(a, {
          get: function (c, d, e) {
            return c == a && "q" == d && e == b;
          },
        })
      );
    return !0 === b.q;
  } catch (c) {
    return !1;
  }
};
$jscomp.USE_PROXY_FOR_ES6_CONFORMANCE_CHECKS = !1;
$jscomp.ES6_CONFORMANCE =
  $jscomp.USE_PROXY_FOR_ES6_CONFORMANCE_CHECKS &&
  $jscomp.checkEs6ConformanceViaProxy();
$jscomp.owns = function (a, b) {
  return Object.prototype.hasOwnProperty.call(a, b);
};
$jscomp.polyfill(
  "WeakMap",
  function (a) {
    function b() {
      if (!a || !Object.seal) {
        return !1;
      }
      try {
        var b = Object.seal({}),
          c = Object.seal({}),
          d = new a([
            [b, 2],
            [c, 3],
          ]);
        if (2 != d.get(b) || 3 != d.get(c)) {
          return !1;
        }
        d.delete(b);
        d.set(c, 4);
        return !d.has(b) && 4 == d.get(c);
      } catch (m) {
        return !1;
      }
    }
    function c() {}
    function d(a) {
      var b = typeof a;
      return ("object" === b && null !== a) || "function" === b;
    }
    function e(a) {
      if (!$jscomp.owns(a, g)) {
        var b = new c();
        $jscomp.defineProperty(a, g, { value: b });
      }
    }
    function f(a) {
      var b = Object[a];
      b &&
        (Object[a] = function (a) {
          if (a instanceof c) {
            return a;
          }
          e(a);
          return b(a);
        });
    }
    if ($jscomp.USE_PROXY_FOR_ES6_CONFORMANCE_CHECKS) {
      if (a && $jscomp.ES6_CONFORMANCE) {
        return a;
      }
    } else {
      if (b()) {
        return a;
      }
    }
    var g = "$jscomp_hidden_" + Math.random();
    f("freeze");
    f("preventExtensions");
    f("seal");
    var h = 0,
      k = function (a) {
        this.id_ = (h += Math.random() + 1).toString();
        if (a) {
          a = $jscomp.makeIterator(a);
          for (var b; !(b = a.next()).done; ) {
            (b = b.value), this.set(b[0], b[1]);
          }
        }
      };
    k.prototype.set = function (a, b) {
      if (!d(a)) {
        throw Error("Invalid WeakMap key");
      }
      e(a);
      if (!$jscomp.owns(a, g)) {
        throw Error("WeakMap key fail: " + a);
      }
      a[g][this.id_] = b;
      return this;
    };
    k.prototype.get = function (a) {
      return d(a) && $jscomp.owns(a, g) ? a[g][this.id_] : void 0;
    };
    k.prototype.has = function (a) {
      return d(a) && $jscomp.owns(a, g) && $jscomp.owns(a[g], this.id_);
    };
    k.prototype.delete = function (a) {
      return d(a) && $jscomp.owns(a, g) && $jscomp.owns(a[g], this.id_)
        ? delete a[g][this.id_]
        : !1;
    };
    return k;
  },
  "es6",
  "es3"
);
$jscomp.MapEntry = function () {};
$jscomp.polyfill(
  "Map",
  function (a) {
    function b() {
      if (
        $jscomp.ASSUME_NO_NATIVE_MAP ||
        !a ||
        "function" != typeof a ||
        !a.prototype.entries ||
        "function" != typeof Object.seal
      ) {
        return !1;
      }
      try {
        var b = Object.seal({ x: 4 }),
          c = new a($jscomp.makeIterator([[b, "s"]]));
        if (
          "s" != c.get(b) ||
          1 != c.size ||
          c.get({ x: 4 }) ||
          c.set({ x: 4 }, "t") != c ||
          2 != c.size
        ) {
          return !1;
        }
        var d = c.entries(),
          e = d.next();
        if (e.done || e.value[0] != b || "s" != e.value[1]) {
          return !1;
        }
        e = d.next();
        return e.done ||
          4 != e.value[0].x ||
          "t" != e.value[1] ||
          !d.next().done
          ? !1
          : !0;
      } catch (m) {
        return !1;
      }
    }
    if ($jscomp.USE_PROXY_FOR_ES6_CONFORMANCE_CHECKS) {
      if (a && $jscomp.ES6_CONFORMANCE) {
        return a;
      }
    } else {
      if (b()) {
        return a;
      }
    }
    var c = new WeakMap(),
      d = function (a) {
        this.data_ = {};
        this.head_ = g();
        this.size = 0;
        if (a) {
          a = $jscomp.makeIterator(a);
          for (var b; !(b = a.next()).done; ) {
            (b = b.value), this.set(b[0], b[1]);
          }
        }
      };
    d.prototype.set = function (a, b) {
      a = 0 === a ? 0 : a;
      var c = e(this, a);
      c.list || (c.list = this.data_[c.id] = []);
      c.entry
        ? (c.entry.value = b)
        : ((c.entry = {
            next: this.head_,
            previous: this.head_.previous,
            head: this.head_,
            key: a,
            value: b,
          }),
          c.list.push(c.entry),
          (this.head_.previous.next = c.entry),
          (this.head_.previous = c.entry),
          this.size++);
      return this;
    };
    d.prototype.delete = function (a) {
      a = e(this, a);
      return a.entry && a.list
        ? (a.list.splice(a.index, 1),
          a.list.length || delete this.data_[a.id],
          (a.entry.previous.next = a.entry.next),
          (a.entry.next.previous = a.entry.previous),
          (a.entry.head = null),
          this.size--,
          !0)
        : !1;
    };
    d.prototype.clear = function () {
      this.data_ = {};
      this.head_ = this.head_.previous = g();
      this.size = 0;
    };
    d.prototype.has = function (a) {
      return !!e(this, a).entry;
    };
    d.prototype.get = function (a) {
      return (a = e(this, a).entry) && a.value;
    };
    d.prototype.entries = function () {
      return f(this, function (a) {
        return [a.key, a.value];
      });
    };
    d.prototype.keys = function () {
      return f(this, function (a) {
        return a.key;
      });
    };
    d.prototype.values = function () {
      return f(this, function (a) {
        return a.value;
      });
    };
    d.prototype.forEach = function (a, b) {
      for (var c = this.entries(), d; !(d = c.next()).done; ) {
        (d = d.value), a.call(b, d[1], d[0], this);
      }
    };
    d.prototype[Symbol.iterator] = d.prototype.entries;
    var e = function (a, b) {
        var d = b && typeof b;
        "object" == d || "function" == d
          ? c.has(b)
            ? (d = c.get(b))
            : ((d = "" + ++h), c.set(b, d))
          : (d = "p_" + b);
        var e = a.data_[d];
        if (e && $jscomp.owns(a.data_, d)) {
          for (a = 0; a < e.length; a++) {
            var g = e[a];
            if ((b !== b && g.key !== g.key) || b === g.key) {
              return { id: d, list: e, index: a, entry: g };
            }
          }
        }
        return { id: d, list: e, index: -1, entry: void 0 };
      },
      f = function (a, b) {
        var c = a.head_;
        return $jscomp.iteratorPrototype(function () {
          if (c) {
            for (; c.head != a.head_; ) {
              c = c.previous;
            }
            for (; c.next != c.head; ) {
              return (c = c.next), { done: !1, value: b(c) };
            }
            c = null;
          }
          return { done: !0, value: void 0 };
        });
      },
      g = function () {
        var a = {};
        return (a.previous = a.next = a.head = a);
      },
      h = 0;
    return d;
  },
  "es6",
  "es3"
);
$jscomp.FORCE_POLYFILL_PROMISE = !1;
$jscomp.polyfill(
  "Promise",
  function (a) {
    function b() {
      this.batch_ = null;
    }
    function c(a) {
      return a instanceof e
        ? a
        : new e(function (b, c) {
            b(a);
          });
    }
    if (a && !$jscomp.FORCE_POLYFILL_PROMISE) {
      return a;
    }
    b.prototype.asyncExecute = function (a) {
      if (null == this.batch_) {
        this.batch_ = [];
        var b = this;
        this.asyncExecuteFunction(function () {
          b.executeBatch_();
        });
      }
      this.batch_.push(a);
    };
    var d = $jscomp.global.setTimeout;
    b.prototype.asyncExecuteFunction = function (a) {
      d(a, 0);
    };
    b.prototype.executeBatch_ = function () {
      for (; this.batch_ && this.batch_.length; ) {
        var a = this.batch_;
        this.batch_ = [];
        for (var b = 0; b < a.length; ++b) {
          var c = a[b];
          a[b] = null;
          try {
            c();
          } catch (l) {
            this.asyncThrow_(l);
          }
        }
      }
      this.batch_ = null;
    };
    b.prototype.asyncThrow_ = function (a) {
      this.asyncExecuteFunction(function () {
        throw a;
      });
    };
    var e = function (a) {
      this.state_ = 0;
      this.result_ = void 0;
      this.onSettledCallbacks_ = [];
      var b = this.createResolveAndReject_();
      try {
        a(b.resolve, b.reject);
      } catch (k) {
        b.reject(k);
      }
    };
    e.prototype.createResolveAndReject_ = function () {
      function a(a) {
        return function (d) {
          c || ((c = !0), a.call(b, d));
        };
      }
      var b = this,
        c = !1;
      return { resolve: a(this.resolveTo_), reject: a(this.reject_) };
    };
    e.prototype.resolveTo_ = function (a) {
      if (a === this) {
        this.reject_(new TypeError("A Promise cannot resolve to itself"));
      } else {
        if (a instanceof e) {
          this.settleSameAsPromise_(a);
        } else {
          a: {
            switch (typeof a) {
              case "object":
                var b = null != a;
                break a;
              case "function":
                b = !0;
                break a;
              default:
                b = !1;
            }
          }
          b ? this.resolveToNonPromiseObj_(a) : this.fulfill_(a);
        }
      }
    };
    e.prototype.resolveToNonPromiseObj_ = function (a) {
      var b = void 0;
      try {
        b = a.then;
      } catch (k) {
        this.reject_(k);
        return;
      }
      "function" == typeof b
        ? this.settleSameAsThenable_(b, a)
        : this.fulfill_(a);
    };
    e.prototype.reject_ = function (a) {
      this.settle_(2, a);
    };
    e.prototype.fulfill_ = function (a) {
      this.settle_(1, a);
    };
    e.prototype.settle_ = function (a, b) {
      if (0 != this.state_) {
        throw Error(
          "Cannot settle(" +
            a +
            ", " +
            b +
            "): Promise already settled in state" +
            this.state_
        );
      }
      this.state_ = a;
      this.result_ = b;
      this.executeOnSettledCallbacks_();
    };
    e.prototype.executeOnSettledCallbacks_ = function () {
      if (null != this.onSettledCallbacks_) {
        for (var a = 0; a < this.onSettledCallbacks_.length; ++a) {
          f.asyncExecute(this.onSettledCallbacks_[a]);
        }
        this.onSettledCallbacks_ = null;
      }
    };
    var f = new b();
    e.prototype.settleSameAsPromise_ = function (a) {
      var b = this.createResolveAndReject_();
      a.callWhenSettled_(b.resolve, b.reject);
    };
    e.prototype.settleSameAsThenable_ = function (a, b) {
      var c = this.createResolveAndReject_();
      try {
        a.call(b, c.resolve, c.reject);
      } catch (l) {
        c.reject(l);
      }
    };
    e.prototype.then = function (a, b) {
      function c(a, b) {
        return "function" == typeof a
          ? function (b) {
              try {
                d(a(b));
              } catch (n) {
                f(n);
              }
            }
          : b;
      }
      var d,
        f,
        g = new e(function (a, b) {
          d = a;
          f = b;
        });
      this.callWhenSettled_(c(a, d), c(b, f));
      return g;
    };
    e.prototype.catch = function (a) {
      return this.then(void 0, a);
    };
    e.prototype.callWhenSettled_ = function (a, b) {
      function c() {
        switch (d.state_) {
          case 1:
            a(d.result_);
            break;
          case 2:
            b(d.result_);
            break;
          default:
            throw Error("Unexpected state: " + d.state_);
        }
      }
      var d = this;
      null == this.onSettledCallbacks_
        ? f.asyncExecute(c)
        : this.onSettledCallbacks_.push(c);
    };
    e.resolve = c;
    e.reject = function (a) {
      return new e(function (b, c) {
        c(a);
      });
    };
    e.race = function (a) {
      return new e(function (b, d) {
        for (
          var e = $jscomp.makeIterator(a), f = e.next();
          !f.done;
          f = e.next()
        ) {
          c(f.value).callWhenSettled_(b, d);
        }
      });
    };
    e.all = function (a) {
      var b = $jscomp.makeIterator(a),
        d = b.next();
      return d.done
        ? c([])
        : new e(function (a, e) {
            function f(b) {
              return function (c) {
                g[b] = c;
                h--;
                0 == h && a(g);
              };
            }
            var g = [],
              h = 0;
            do {
              g.push(void 0),
                h++,
                c(d.value).callWhenSettled_(f(g.length - 1), e),
                (d = b.next());
            } while (!d.done);
          });
    };
    return e;
  },
  "es6",
  "es3"
);
$jscomp.polyfill(
  "Array.prototype.entries",
  function (a) {
    return a
      ? a
      : function () {
          return $jscomp.iteratorFromArray(this, function (a, c) {
            return [a, c];
          });
        };
  },
  "es6",
  "es3"
);
$jscomp.polyfill(
  "Array.prototype.values",
  function (a) {
    return a
      ? a
      : function () {
          return $jscomp.iteratorFromArray(this, function (a, c) {
            return c;
          });
        };
  },
  "es8",
  "es3"
);
$jscomp.polyfill(
  "Set",
  function (a) {
    function b() {
      if (
        $jscomp.ASSUME_NO_NATIVE_SET ||
        !a ||
        "function" != typeof a ||
        !a.prototype.entries ||
        "function" != typeof Object.seal
      ) {
        return !1;
      }
      try {
        var b = Object.seal({ x: 4 }),
          c = new a($jscomp.makeIterator([b]));
        if (
          !c.has(b) ||
          1 != c.size ||
          c.add(b) != c ||
          1 != c.size ||
          c.add({ x: 4 }) != c ||
          2 != c.size
        ) {
          return !1;
        }
        var f = c.entries(),
          g = f.next();
        if (g.done || g.value[0] != b || g.value[1] != b) {
          return !1;
        }
        g = f.next();
        return g.done ||
          g.value[0] == b ||
          4 != g.value[0].x ||
          g.value[1] != g.value[0]
          ? !1
          : f.next().done;
      } catch (h) {
        return !1;
      }
    }
    if ($jscomp.USE_PROXY_FOR_ES6_CONFORMANCE_CHECKS) {
      if (a && $jscomp.ES6_CONFORMANCE) {
        return a;
      }
    } else {
      if (b()) {
        return a;
      }
    }
    var c = function (a) {
      this.map_ = new Map();
      if (a) {
        a = $jscomp.makeIterator(a);
        for (var b; !(b = a.next()).done; ) {
          this.add(b.value);
        }
      }
      this.size = this.map_.size;
    };
    c.prototype.add = function (a) {
      a = 0 === a ? 0 : a;
      this.map_.set(a, a);
      this.size = this.map_.size;
      return this;
    };
    c.prototype.delete = function (a) {
      a = this.map_.delete(a);
      this.size = this.map_.size;
      return a;
    };
    c.prototype.clear = function () {
      this.map_.clear();
      this.size = 0;
    };
    c.prototype.has = function (a) {
      return this.map_.has(a);
    };
    c.prototype.entries = function () {
      return this.map_.entries();
    };
    c.prototype.values = function () {
      return this.map_.values();
    };
    c.prototype.keys = c.prototype.values;
    c.prototype[Symbol.iterator] = c.prototype.values;
    c.prototype.forEach = function (a, b) {
      var c = this;
      this.map_.forEach(function (d) {
        return a.call(b, d, d, c);
      });
    };
    return c;
  },
  "es6",
  "es3"
);
$jscomp.polyfill(
  "Array.prototype.fill",
  function (a) {
    return a
      ? a
      : function (a, c, d) {
          var b = this.length || 0;
          0 > c && (c = Math.max(0, b + c));
          if (null == d || d > b) {
            d = b;
          }
          d = Number(d);
          0 > d && (d = Math.max(0, b + d));
          for (c = Number(c || 0); c < d; c++) {
            this[c] = a;
          }
          return this;
        };
  },
  "es6",
  "es3"
);
function extend(a, b, c) {
  a.prototype = Object.create(b.prototype);
  a.prototype.constructor = a;
  a.parent = b.prototype;
  if (void 0 !== c) {
    for (var d in c) {
      c.hasOwnProperty(d) && (a.prototype[d] = c[d]);
    }
  }
}
function eventTarget(a) {
  this.eventListenerScope = this.target = a;
  this.eventListeners = [];
}
eventTarget.prototype = {
  constructor: eventTarget,
  addEventListener: function (a, b) {
    var c = this;
    Array.isArray(a) || (a = a.split(/\s+/));
    a = $jscomp.makeIterator(a);
    for (var d = a.next(); !d.done; d = a.next()) {
      d = d.value;
      var e = d.split(".");
      d = e.shift();
      e = { eventName: d, namespaces: e };
      void 0 !== this.target.addEventListener
        ? ((e.handler = function (a) {
            return b.call(c.eventListenerScope, a);
          }),
          this.target.addEventListener(d, e.handler, !1))
        : void 0 !== this.target.attachEvent &&
          ((e.handler = function () {
            var a = window.event;
            a.target = a.srcElement;
            if (void 0 !== a.button) {
              switch (a.button) {
                case 1:
                  a.which = 1;
                  break;
                case 2:
                  a.which = 3;
                  break;
                case 4:
                  a.which = 2;
                  break;
                default:
                  a.which = 1;
              }
            }
            b.call(c.eventListenerScope, a);
          }),
          this.target.attachEvent("on" + d, e.handler));
      this.eventListeners.push(e);
    }
    return this;
  },
  eventListenerIndex: 1,
  addEventListenerOnce: function (a, b) {
    Array.isArray(a) || (a = a.split(/\s+/));
    for (
      var c = $jscomp.makeIterator(a), d = c.next();
      !d.done;
      d = c.next()
    ) {}
    this.eventListenerIndex++;
    var e = this;
    this.addEventListener(a, function (c) {
      !1 !== b.call(this, c) && e.removeEventListener(a);
    });
    return this;
  },
  removeEventListener: function (a) {
    Array.isArray(a) || (a = a.split(/\s+/));
    a = $jscomp.makeIterator(a);
    for (var b = a.next(); !b.done; b = a.next()) {
      b = b.value;
      var c = b.split(".");
      b = c.shift();
      for (var d = [], e = this.eventListeners.length - 1; 0 <= e; e--) {
        var f = this.eventListeners[e],
          g = !0;
        if ("" != b && f.eventName != b) {
          g = !1;
        } else {
          for (
            var h = $jscomp.makeIterator(c), k = h.next();
            !k.done;
            k = h.next()
          ) {
            if (!f.namespaces.includes(k.value)) {
              g = !1;
              break;
            }
          }
        }
        g && (d.push(f), this.eventListeners.splice(e, 1));
      }
      if (void 0 !== this.target.removeEventListener) {
        for (b = $jscomp.makeIterator(d), c = b.next(); !c.done; c = b.next()) {
          (c = c.value),
            this.target.removeEventListener(c.eventName, c.handler, !1);
        }
      } else {
        if (void 0 !== this.target.detachEvent) {
          for (
            b = $jscomp.makeIterator(d), c = b.next();
            !c.done;
            c = b.next()
          ) {
            (c = c.value),
              this.target.detachEvent("on" + c.eventName, c.handler);
          }
        } else {
          return !1;
        }
      }
    }
    return this;
  },
  restrictInputNames: {
    integer: /\d/,
    integerSearch: /[\d><=!]/,
    decimal: /[\d.-]/,
    decimalSearch: /[\d.-><=!]/,
  },
  restrictInput: function (a) {
    "string" == typeof a && (a = this.restrictInputNames[a]);
    this.addEventListener("keypress.restrictInput", function (b) {
      "Enter" == b.key ||
        String.fromCharCode(b.keyCode).match(a) ||
        b.preventDefault();
    });
    return this;
  },
};
eventTarget.prototype.dispatchEvent = function (a) {
  return this.target.dispatchEvent.apply(this.target, arguments);
};
function node(a, b, c) {
  if (a instanceof Node) {
    this.sourceNode = a;
  } else {
    this.sourceNode = document.createElement(a);
    if (void 0 !== b && null !== b) {
      if ("string" == typeof b) {
        this.sourceNode.className = b;
      } else {
        for (var d in b) {
          b.hasOwnProperty(d) &&
            (null !== b[d] ? this.setAttribute(d, b[d]) : this.addAttribute(d));
        }
      }
    }
    void 0 !== c &&
      "" !== c &&
      this.sourceNode.appendChild(document.createTextNode(c));
  }
  this.target = this.sourceNode;
  this.eventListenerScope = this;
  this.eventListeners = [];
  this.nodeName = this.sourceNode.nodeName;
  this.nodeType = this.sourceNode.nodeType;
  1 == this.nodeType && this.attachInheritedElementProperties();
}
node.querySelector = function (a) {
  a = document.querySelector(a);
  return null !== a ? new node(a) : !1;
};
extend(node, eventTarget);
node.prototype.attachInheritedElementProperties = function () {
  this.attributes = this.sourceNode.attributes;
  this.children = this.sourceNode.children;
  this.childNodes = this.sourceNode.childNodes;
  this.classList = this.sourceNode.classList;
  this.dataset = this.sourceNode.dataset;
  this.options = this.sourceNode.options;
  this.style = this.sourceNode.style;
  this.tagName = this.sourceNode.tagName;
  this.validity = this.sourceNode.validity;
};
node.prototype.appendChild = function (a) {
  a instanceof node
    ? (a = a.sourceNode)
    : "string" == typeof a && (a = document.createTextNode(a));
  this.sourceNode.appendChild(a);
  return a instanceof Node ? new node(a) : a;
};
node.prototype.prependChild = function (a) {
  "string" == typeof a && (a = document.createTextNode(a));
  return this.insertBefore(a, this.sourceNode.firstChild);
};
node.prototype.append = function (a) {
  for (
    var b = $jscomp.makeIterator(arguments), c = b.next();
    !c.done;
    c = b.next()
  ) {
    this.appendChild(c.value);
  }
  return this;
};
node.prototype.prepend = function (a) {
  for (var b = arguments.length - 1; 0 <= b; b--) {
    this.prependChild(arguments[b]);
  }
  return this;
};
node.prototype.appendNode = function (a, b, c) {
  return this.appendChild(new node(a, b, c));
};
node.prototype.prependNode = function (a, b, c) {
  return this.prependChild(new node(a, b, c));
};
node.prototype.insertBefore = function (a, b) {
  for (var c = 0; c < arguments.length; c++) {
    arguments[c] instanceof node && (arguments[c] = arguments[c].sourceNode);
  }
  this.sourceNode.insertBefore(arguments[0], arguments[1]);
  a instanceof Node && (a = new node(a));
  return a;
};
node.prototype.insertAfter = function (a, b) {
  b instanceof node && (b = b.sourceNode);
  return null !== b.nextSibling
    ? this.insertBefore(a, b.nextSibling)
    : this.appendChild(a);
};
node.prototype.empty = function () {
  for (; null !== this.sourceNode.firstChild; ) {
    this.sourceNode.removeChild(this.sourceNode.firstChild);
  }
  return this;
};
node.prototype.remove = function () {
  var a = this.sourceNode.parentElement;
  return null !== a ? (a.removeChild(this.sourceNode), this) : null;
};
node.prototype.replace = function (a) {
  var b = this.parentElement();
  return null !== b
    ? (b.replaceChild(a, this.sourceNode),
      a instanceof Node && (a = new node(a)),
      a)
    : null;
};
node.prototype.replaceNode = function (a, b, c) {
  return this.replace(new node(a, b, c));
};
node.prototype.querySelectorAll = function (a) {
  return []
    .concat($jscomp.arrayFromIterable(this.sourceNode.querySelectorAll(a)))
    .map(function (a) {
      return new node(a);
    });
};
node.prototype.matchIDindex = 0;
node.prototype.matches = function (a) {
  if (void 0 !== this.sourceNode.matches) {
    return this.sourceNode.matches(a);
  }
  if (void 0 !== this.sourceNode.msMatchesSelector) {
    return this.sourceNode.msMatchesSelector(a);
  }
  var b = this.sourceNode.parentElement.hasAttribute("id");
  if (b) {
    var c = this.sourceNode.parentElement.id;
  } else {
    (c = "nodeMatchID" + this.matchIDindex++),
      (this.sourceNode.parentElement.id = c);
  }
  c = this.sourceNode.parentElement.parentElement.querySelectorAll(
    "#" + c + ">" + a
  );
  a = !1;
  c = $jscomp.makeIterator(c);
  for (var d = c.next(); !d.done; d = c.next()) {
    if (d.value.isSameNode(this.sourceNode)) {
      a = !0;
      break;
    }
  }
  b || this.sourceNode.parentElement.removeAttribute("id");
  return a;
};
node.prototype.containsOrIsSameNode = function (a) {
  return this.isSameNode(a) || this.contains(a);
};
node.prototype.ancestor = function (a) {
  for (var b = this.sourceNode, c = 0; c++ < a && null !== b; ) {
    b = b.parentElement;
  }
  return null !== b ? new node(b) : null;
};
node.prototype.ancestors = function (a) {
  for (var b = [], c = this; null !== c.parentElement(); ) {
    (c = c.parentElement()), (void 0 === a || c.matches(a)) && b.push(c);
  }
  return b;
};
node.prototype.addAttribute = function (a) {
  this.sourceNode.setAttribute(a, "");
  return this;
};
node.prototype.setAttributes = function (a) {
  for (var b in a) {
    a.hasOwnProperty(b) && this.sourceNode.setAttribute(b, a[b]);
  }
  return this;
};
node.prototype.addClass = function (a) {
  if (void 0 !== this.classList) {
    a = a.split(/\s+/);
    var b = $jscomp.makeIterator(a);
    for (a = b.next(); !a.done; a = b.next()) {
      this.classList.add(a.value);
    }
  } else {
    b = this.sourceNode.className;
    if ("string" == typeof b && "" != b) {
      b = b.split(/\s+/);
      a = a.split(/\s+/);
      var c = $jscomp.makeIterator(a);
      for (a = c.next(); !a.done; a = c.next()) {
        (a = a.value), b.includes(a) || b.push(a);
      }
      b = b.join(" ");
    } else {
      b = a;
    }
    this.sourceNode.className = b;
  }
  return this;
};
node.prototype.removeClass = function (a) {
  a = a.split(/\s+/);
  if (void 0 !== this.classList) {
    var b = $jscomp.makeIterator(a);
    for (a = b.next(); !a.done; a = b.next()) {
      this.classList.remove(a.value);
    }
  } else {
    b = this.sourceNode.className;
    if ("string" != typeof b || "" == b) {
      return this;
    }
    b = b.split(/\s+/);
    var c = $jscomp.makeIterator(a);
    for (a = c.next(); !a.done; a = c.next()) {
      (a = a.value), b.includes(a) && b.splice(b.indexOf(a), 1);
    }
    0 < b.length
      ? (this.sourceNode.className = b.join(" "))
      : this.sourceNode.removeAttribute("class");
  }
  return this;
};
node.prototype.changeClass = function (a, b) {
  b ? this.addClass(a) : this.removeClass(a);
  return this;
};
node.prototype.toggleClass = function (a) {
  if (void 0 !== this.classList) {
    a = a.split(/\s+/);
    var b = $jscomp.makeIterator(a);
    for (a = b.next(); !a.done; a = b.next()) {
      this.classList.toggle(a.value);
    }
  } else {
    b = this.sourceNode.className;
    if ("string" == typeof b && "" != b) {
      b = b.split(/\s+/);
      a = a.split(/\s+/);
      var c = $jscomp.makeIterator(a);
      for (a = c.next(); !a.done; a = c.next()) {
        (a = a.value), b.includes(a) ? b.splice(b.indexOf(a), 1) : b.push(a);
      }
      if (0 == b.length) {
        return this.sourceNode.removeAttribute("class"), this;
      }
      b = b.join(" ");
    } else {
      b = a;
    }
    this.sourceNode.className = b;
  }
  return this;
};
node.prototype.hasClass = function (a) {
  if (void 0 !== this.classList) {
    return this.classList.contains(a);
  }
  var b = this.sourceNode.className;
  return "string" == typeof b && "" != b
    ? ((b = b.split(/\s+/)), b.includes(a))
    : !1;
};
node.prototype.computedStyle = function (a) {
  a = a.replace(/-([a-z])/g, function (a, c) {
    return c.toUpperCase();
  });
  void 0 === this.computedStyles &&
    (this.computedStyles = getComputedStyle(this.sourceNode));
  return this.computedStyles[a];
};
node.prototype.addEventListener = function (a, b) {
  return node.parent.addEventListener.apply(this, arguments);
};
node.prototype._private_addTransitionListener = function (a, b, c, d) {
  var e = this;
  if (!0 === d) {
    var f = ".transitionListener" + this.eventListenerIndex;
    this.eventListenerIndex++;
  } else {
    f = "";
  }
  this.addEventListener(
    "webkitTransitionEnd" +
      f +
      " mozTransitionEnd" +
      f +
      " MSTransitionEnd" +
      f +
      " oTransitionEnd" +
      f +
      " transitionend" +
      f,
    function (d) {
      var g = [d];
      if (void 0 !== b) {
        if (d.propertyName != b) {
          return;
        }
        d = e.computedStyle(b);
        if (void 0 !== c && d != c) {
          return;
        }
        g.push(d);
      }
      g = a.apply(e, g);
      "" !== f && !1 !== g && e.removeEventListener(f);
    }
  );
};
node.prototype.addTransitionListener = function (a, b, c) {
  this._private_addTransitionListener(a, b, c);
  return this;
};
node.prototype.addTransitionListenerOnce = function (a, b, c, d) {
  this._private_addTransitionListener(b, c, d, !0);
  a = a.split(/\s+/);
  a = $jscomp.makeIterator(a);
  for (b = a.next(); !b.done; b = a.next()) {
    (b = b.value),
      "-" != b[0] ? this.addClass(b) : this.removeClass(b.substr(1));
  }
  return this;
};
node.prototype.pulse = function (a, b, c) {
  var d = this;
  this.addTransitionListenerOnce(
    a,
    function () {
      return d.removeClass(a);
    },
    b,
    c
  );
};
node.prototype.toggleTransition = function (a) {
  void 0 === a && (a = this.hasClass("noTransition"));
  a
    ? (this.offsetHeight(), this.removeClass("noTransition"))
    : this.addClass("noTransition");
};
node.prototype.addClassNoTransition = function (a) {
  this.toggleTransition(!1);
  this.addClass.apply(this, arguments);
  this.toggleTransition(!0);
  return this;
};
node.prototype.removeClassNoTransition = function (a) {
  this.toggleTransition(!1);
  this.removeClass.apply(this, arguments);
  this.toggleTransition(!0);
  return this;
};
node.prototype.toggleClassNoTransition = function (a) {
  this.toggleTransition(!1);
  this.toggleClass.apply(this, arguments);
  this.toggleTransition(!0);
  return this;
};
node.prototype.isCompatibleNode = function (a) {
  if (this.nodeType != a.nodeType || this.nodeName != a.nodeName) {
    return !1;
  }
  if (3 == this.nodeType) {
    return !0;
  }
  if (this.attributes.length != a.attributes.length) {
    return !1;
  }
  var b = !0;
  a = $jscomp.makeIterator(a.attributes);
  for (var c = a.next(); !c.done; c = a.next()) {
    if (
      ((c = c.value),
      !this.hasAttribute(c.name) || this.getAttribute(c.name) !== c.value)
    ) {
      b = !1;
      break;
    }
  }
  return b;
};
node.prototype.offset = function () {
  var a = this.getBoundingClientRect(),
    b = {
      top: Math.round(
        a.top + windowScrollTop() - document.documentElement.clientTop
      ),
      left: Math.round(
        a.left + windowScrollLeft() - document.documentElement.clientLeft
      ),
    };
  b.bottom = b.top + a.bottom - a.top;
  b.right = b.left + a.right - a.left;
  return b;
};
node.prototype.offsetFrom = function (a) {
  a instanceof Node && (a = new node(a));
  for (
    var b = { top: this.offsetTop(), left: this.offsetLeft() },
      c = this.offsetParent();
    a.contains(c);

  ) {
    (b.top += c.offsetTop()),
      (b.left += c.offsetLeft()),
      (c = c.offsetParent());
  }
  b.bottom = b.top + this.offsetHeight();
  b.right = b.left + this.offsetWidth();
  return b;
};
node.prototype.clone = function () {
  return new node(this.sourceNode);
};
node.prototype.childElementCount = function () {
  return this.sourceNode.childElementCount;
};
node.prototype.clientHeight = function () {
  return this.sourceNode.clientHeight;
};
node.prototype.clientLeft = function () {
  return this.sourceNode.clientLeft;
};
node.prototype.clientTop = function () {
  return this.sourceNode.clientTop;
};
node.prototype.clientWidth = function () {
  return this.sourceNode.clientWidth;
};
node.prototype.isContentEditable = function () {
  return this.sourceNode.isContentEditable;
};
node.prototype.files = function () {
  return this.sourceNode.files;
};
node.prototype.offsetHeight = function () {
  return this.sourceNode.offsetHeight;
};
node.prototype.offsetLeft = function () {
  return this.sourceNode.offsetLeft;
};
node.prototype.offsetTop = function () {
  return this.sourceNode.offsetTop;
};
node.prototype.offsetWidth = function () {
  return this.sourceNode.offsetWidth;
};
node.prototype.scrollHeight = function () {
  return this.sourceNode.scrollHeight;
};
node.prototype.scrollWidth = function () {
  return this.sourceNode.scrollWidth;
};
node.prototype.checked = function (a) {
  void 0 !== a && (this.sourceNode.checked = a);
  return this.sourceNode.checked;
};
node.prototype.className = function (a) {
  void 0 !== a && (this.sourceNode.className = a);
  return this.sourceNode.className;
};
node.prototype.contentEditable = function (a) {
  void 0 !== a && (this.sourceNode.contentEditable = a);
  return this.sourceNode.contentEditable;
};
node.prototype.dateTime = function (a) {
  void 0 !== a && (this.sourceNode.dateTime = a);
  return this.sourceNode.dateTime;
};
node.prototype.disabled = function (a) {
  void 0 !== a && (this.sourceNode.disabled = a);
  return this.sourceNode.disabled;
};
node.prototype.href = function (a) {
  void 0 !== a && (this.sourceNode.href = a);
  return this.sourceNode.href;
};
node.prototype.id = function (a) {
  void 0 !== a && (this.sourceNode.id = a);
  return this.sourceNode.id;
};
node.prototype.indeterminate = function (a) {
  void 0 !== a && (this.sourceNode.indeterminate = a);
  return this.sourceNode.indeterminate;
};
node.prototype.innerHTML = function (a) {
  void 0 !== a && (this.sourceNode.innerHTML = a);
  return this.sourceNode.innerHTML;
};
node.prototype.max = function (a) {
  void 0 !== a && (this.sourceNode.max = a);
  return this.sourceNode.max;
};
node.prototype.maxLength = function (a) {
  void 0 !== a && (this.sourceNode.maxLength = a);
  return this.sourceNode.maxLength;
};
node.prototype.min = function (a) {
  void 0 !== a && (this.sourceNode.min = a);
  return this.sourceNode.min;
};
node.prototype.minLength = function (a) {
  void 0 !== a && (this.sourceNode.minLength = a);
  return this.sourceNode.minLength;
};
node.prototype.name = function (a) {
  void 0 !== a && (this.sourceNode.name = a);
  return this.sourceNode.name;
};
node.prototype.nodeValue = function (a) {
  void 0 !== a && (this.sourceNode.nodeValue = a);
  return this.sourceNode.nodeValue;
};
node.prototype.pattern = function (a) {
  void 0 !== a && (this.sourceNode.pattern = a);
  return this.sourceNode.pattern;
};
node.prototype.placeholder = function (a) {
  void 0 !== a && (this.sourceNode.placeholder = a);
  return this.sourceNode.placeholder;
};
node.prototype.required = function (a) {
  void 0 !== a && (this.sourceNode.required = a);
  return this.sourceNode.required;
};
node.prototype.scrollLeft = function (a) {
  void 0 !== a && (this.sourceNode.scrollLeft = a);
  return this.sourceNode.scrollLeft;
};
node.prototype.scrollTop = function (a) {
  void 0 !== a && (this.sourceNode.scrollTop = a);
  return this.sourceNode.scrollTop;
};
node.prototype.selected = function (a) {
  void 0 !== a && (this.sourceNode.selected = a);
  return this.sourceNode.selected;
};
node.prototype.selectionEnd = function (a) {
  void 0 !== a && (this.sourceNode.selectionEnd = a);
  return this.sourceNode.selectionEnd;
};
node.prototype.selectionStart = function (a) {
  void 0 !== a && (this.sourceNode.selectionStart = a);
  return this.sourceNode.selectionStart;
};
node.prototype.src = function (a) {
  void 0 !== a && (this.sourceNode.src = a);
  return this.sourceNode.src;
};
node.prototype.tabIndex = function (a) {
  void 0 !== a && (this.sourceNode.tabIndex = a);
  return this.sourceNode.tabIndex;
};
node.prototype.textContent = function (a) {
  void 0 !== a && (this.sourceNode.textContent = a);
  return this.sourceNode.textContent;
};
node.prototype.title = function (a) {
  void 0 !== a && (this.sourceNode.title = a);
  return this.sourceNode.title;
};
node.prototype.type = function (a) {
  void 0 !== a && (this.sourceNode.type = a);
  return this.sourceNode.type;
};
node.prototype.value = function (a) {
  void 0 !== a && (this.sourceNode.value = a);
  return this.sourceNode.value;
};
node.prototype.firstChild = function () {
  var a = this.sourceNode.firstChild;
  a instanceof Node && (a = new node(a));
  return a;
};
node.prototype.firstElementChild = function () {
  var a = this.sourceNode.firstElementChild;
  a instanceof Node && (a = new node(a));
  return a;
};
node.prototype.lastChild = function () {
  var a = this.sourceNode.lastChild;
  a instanceof Node && (a = new node(a));
  return a;
};
node.prototype.lastElementChild = function () {
  var a = this.sourceNode.lastElementChild;
  a instanceof Node && (a = new node(a));
  return a;
};
node.prototype.nextSibling = function () {
  var a = this.sourceNode.nextSibling;
  a instanceof Node && (a = new node(a));
  return a;
};
node.prototype.nextElementSibling = function () {
  var a = this.sourceNode.nextElementSibling;
  a instanceof Node && (a = new node(a));
  return a;
};
node.prototype.offsetParent = function () {
  var a = this.sourceNode.offsetParent;
  a instanceof Node && (a = new node(a));
  return a;
};
node.prototype.parentNode = function () {
  var a = this.sourceNode.parentNode;
  a instanceof Node && (a = new node(a));
  return a;
};
node.prototype.parentElement = function () {
  var a = this.sourceNode.parentElement;
  a instanceof Node && (a = new node(a));
  return a;
};
node.prototype.previousSibling = function () {
  var a = this.sourceNode.previousSibling;
  a instanceof Node && (a = new node(a));
  return a;
};
node.prototype.previousElementSibling = function () {
  var a = this.sourceNode.previousElementSibling;
  a instanceof Node && (a = new node(a));
  return a;
};
node.prototype.blur = function () {
  this.sourceNode.blur();
};
node.prototype.checkValidity = function () {
  return this.sourceNode.checkValidity();
};
node.prototype.click = function () {
  this.sourceNode.click();
};
node.prototype.focus = function () {
  this.sourceNode.focus();
};
node.prototype.getAttribute = function (a) {
  return this.sourceNode.getAttribute.apply(this.sourceNode, arguments);
};
node.prototype.getAttributeNode = function (a) {
  return this.sourceNode.getAttributeNode.apply(this.sourceNode, arguments);
};
node.prototype.getBoundingClientRect = function () {
  return this.sourceNode.getBoundingClientRect();
};
node.prototype.getElementsByClassName = function (a) {
  return this.sourceNode.getElementsByClassName.apply(
    this.sourceNode,
    arguments
  );
};
node.prototype.getElementsByTagName = function (a) {
  return this.sourceNode.getElementsByTagName.apply(this.sourceNode, arguments);
};
node.prototype.hasAttribute = function (a) {
  return this.sourceNode.hasAttribute.apply(this.sourceNode, arguments);
};
node.prototype.hasAttributes = function () {
  return this.sourceNode.hasAttributes();
};
node.prototype.hasChildNodes = function () {
  return this.sourceNode.hasChildNodes();
};
node.prototype.normalize = function () {
  this.sourceNode.normalize();
};
node.prototype.removeAttribute = function (a) {
  this.sourceNode.removeAttribute.apply(this.sourceNode, arguments);
};
node.prototype.removeAttributeNode = function (a) {
  return this.sourceNode.removeAttributeNode.apply(this.sourceNode, arguments);
};
node.prototype.reportValidity = function () {
  return this.sourceNode.reportValidity();
};
node.prototype.reset = function () {
  this.sourceNode.reset();
};
node.prototype.select = function () {
  this.sourceNode.select();
};
node.prototype.setAttribute = function (a, b) {
  this.sourceNode.setAttribute.apply(this.sourceNode, arguments);
};
node.prototype.setAttributeNode = function (a) {
  return this.sourceNode.setAttributeNode.apply(this.sourceNode, arguments);
};
node.prototype.setCustomValidity = function (a) {
  this.sourceNode.setCustomValidity.apply(this.sourceNode, arguments);
};
node.prototype.setSelectionRange = function (a, b, c) {
  this.sourceNode.setSelectionRange.apply(this.sourceNode, arguments);
};
node.prototype.submit = function () {
  this.sourceNode.submit();
};
node.prototype.cloneNode = function (a) {
  return new node(this.sourceNode.cloneNode.apply(this.sourceNode, arguments));
};
node.prototype.querySelector = function (a) {
  var b = this.sourceNode.querySelector.apply(this.sourceNode, arguments);
  b instanceof Node && (b = new node(b));
  return b;
};
node.prototype.compareDocumentPosition = function (a) {
  a instanceof node && (a = a.sourceNode);
  return this.sourceNode.compareDocumentPosition(a);
};
node.prototype.contains = function (a) {
  a instanceof node && (a = a.sourceNode);
  return this.sourceNode.contains(a);
};
node.prototype.isEqualNode = function (a) {
  a instanceof node && (a = a.sourceNode);
  return this.sourceNode.isEqualNode(a);
};
node.prototype.isSameNode = function (a) {
  a instanceof node && (a = a.sourceNode);
  return this.sourceNode.isSameNode(a);
};
node.prototype.removeChild = function (a) {
  a instanceof node && (a = a.sourceNode);
  a = this.sourceNode.removeChild(a);
  a instanceof Node && (a = this);
  return a;
};
node.prototype.replaceChild = function (a) {
  for (var b = 0; b < arguments.length; b++) {
    arguments[b] instanceof node && (arguments[b] = arguments[b].sourceNode);
  }
  return new node(
    this.sourceNode.replaceChild.apply(this.sourceNode, arguments)
  );
};
function AJAX(a, b) {
  void 0 !== a && (this.url = a);
  this.options = clone(this.optionDefaults);
  void 0 !== b && merge(this.options, b);
}
AJAX.prototype = {
  constructor: AJAX,
  optionDefaults: {
    method: "GET",
    accept: "text/plain, text/html, application/xml, application/json",
  },
  get: function (a) {
    var b = [].concat($jscomp.arrayFromIterable(arguments));
    "string" == typeof b[0] && (this.url = b.shift());
    void 0 !== b[0] && merge(this.options, b[0]);
    this.options.method = "GET";
    this.execute();
  },
  post: function (a) {
    var b = [].concat($jscomp.arrayFromIterable(arguments));
    "string" == typeof b[0] && (this.url = b.shift());
    void 0 !== b[1] && merge(this.options, b[1]);
    merge(this.options, { method: "POST", data: b[0] });
    this.execute();
  },
  postFiles: function (a) {
    var b = [].concat($jscomp.arrayFromIterable(arguments)),
      c = 0;
    "string" == typeof b[0] && c++;
    var d = b.splice(c, 1)[0];
    b[c].append("json", JSON.stringify(d));
    this.post.apply(this, b);
  },
  execute: function (a) {
    var b = this,
      c = [].concat($jscomp.arrayFromIterable(arguments));
    "string" == typeof c[0] && (this.url = c.shift());
    void 0 !== c[0] && merge(this.options, c[0]);
    c =
      this.options.data instanceof FormData
        ? this.options.data
        : void 0 !== this.options.data
        ? "json=" + encodeURIComponent(JSON.stringify(this.options.data))
        : null;
    "GET" == this.options.method &&
      void 0 !== this.options.data &&
      ((this.url += "?" + c), (c = null));
    var d = new XMLHttpRequest();
    d.open(this.options.method, this.url, !0);
    this.options.data instanceof FormData ||
      d.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    d.setRequestHeader("Accept", this.options.accept);
    d.onreadystatechange = function () {
      return b.onReadyStateChange(d);
    };
    d.send(c);
  },
  onReadyStateChange: function (a) {
    if (4 == a.readyState) {
      if (200 == a.status) {
        var b = a.getResponseHeader("Content-Type");
        if ("application/json" == b) {
          try {
            var c = JSON.parse(a.responseText);
          } catch (d) {
            console.error("AJAX success, JSON syntax error", a.responseText, d);
            return;
          }
        } else {
          c = "application/xml" == b ? a.responseXML : a.responseText;
        }
        void 0 !== this.options.success &&
          this.success(a, c, this.options.success);
      } else {
        void 0 !== this.options.error && this.error(a, this.options.error);
      }
      void 0 !== this.options.complete &&
        this.complete(a, c, this.options.complete);
    }
  },
  success: function (a, b, c) {
    c(b, a);
  },
  error: function (a, b) {
    b(a, a.status + ": " + a.statusText);
  },
  complete: function (a, b, c) {
    c(a, b);
  },
};
var eventTargets = {
  window: new eventTarget(window),
  document: new eventTarget(document),
};
function DOMready() {
  var a = this;
  if (void 0 !== document.addEventListener) {
    eventTargets.document.addEventListenerOnce("DOMContentLoaded", function () {
      return a.execute();
    });
  } else {
    if (void 0 !== document.attachEvent) {
      eventTargets.document.addEventListenerOnce(
        "onreadystatechange",
        function () {
          if ("interactive" !== document.readyState) {
            return !1;
          }
          a.execute();
        }
      );
      var b = !1;
      try {
        b = null == window.frameElement;
      } catch (c) {}
      document.documentElement.doScroll && b && this.ieScrollCheck();
    }
  }
  eventTargets.window.addEventListenerOnce("load", function () {
    return a.execute();
  });
}
DOMready.prototype = {
  constructor: DOMready,
  callbacks: [],
  add: function (a) {
    this.callbacks.push(a);
    "interactive" == document.readyState && this.execute();
  },
  execute: function () {
    var a = this;
    if (document.body) {
      for (
        var b = $jscomp.makeIterator(this.callbacks), c = b.next();
        !c.done;
        c = b.next()
      ) {
        (c = c.value), c();
      }
      this.callbacks = [];
    } else {
      setTimeout(function () {
        return a.execute();
      }, 13);
    }
  },
  ieScrollCheck: function () {
    var a = this;
    if (0 != this.callbacks.length) {
      try {
        document.documentElement.doScroll("left");
      } catch (b) {
        setTimeout(function () {
          return a.ieScrollCheck();
        }, 1);
        return;
      }
      this.execute();
    }
  },
};
var domReady = new DOMready();
Number.prototype.mod = function (a) {
  return ((this % a) + a) % a;
};
Number.prototype.toFixedRounded = function (a) {
  var b = Math.pow(10, a);
  return (Math.round(this * b) / b).toFixed(a);
};
String.prototype.toSentenceCase = function () {
  return this[0].toUpperCase() + this.substr(1);
};
Date.prototype.clone = function () {
  return new Date(this.valueOf());
};
Date.prototype.locale = "en-GB";
Date.prototype.getMonthName = function () {
  return this.toLocaleDateString(this.locale, { month: "long" });
};
Date.prototype.getMonthNameShort = function () {
  return this.toLocaleDateString(this.locale, { month: "short" });
};
Date.prototype.getDayName = function () {
  return this.toLocaleDateString(this.locale, { weekday: "long" });
};
Date.prototype.getDayNameShort = function () {
  return this.toLocaleDateString(this.locale, { weekday: "short" });
};
Date.prototype.getDayNameShorter = function () {
  return this.toLocaleDateString(this.locale, { weekday: "short" }).substr(
    0,
    2
  );
};
Date.prototype.getTimeSeconds = function () {
  return Math.round(this.getTime() / 1000);
};
Date.prototype.toISODateString = function () {
  return (
    this.toLocaleDateString(this.locale, { year: "numeric" }) +
    "-" +
    this.toLocaleDateString(this.locale, { month: "2-digit" }) +
    "-" +
    this.toLocaleDateString(this.locale, { day: "2-digit" })
  );
};
Date.prototype.addDays = function (a) {
  this.setDate(this.getDate() + a);
};
Date.prototype.msPerDay = 864e5;
Date.prototype.differenceDays = function (a) {
  return Math.round(
    (this.clone().setHours(12, 0, 0) - a.clone().setHours(12, 0, 0)) /
      this.msPerDay
  );
};
function sortNumeric(a, b) {
  return a - b;
}
Array.prototype.sortNumeric = function () {
  return this.sort(sortNumeric);
};
function size(a) {
  return Object.keys(a).length;
}
Map.prototype.toObject = function () {
  for (
    var a = {}, b = $jscomp.makeIterator(this), c = b.next();
    !c.done;
    c = b.next()
  ) {
    var d = $jscomp.makeIterator(c.value);
    c = d.next().value;
    d = d.next().value;
    a[c] = d;
  }
  return a;
};
function clone(a, b) {
  void 0 === b && (b = !1);
  return merge(b, Array.isArray(a) ? [] : new a.constructor(), a);
}
function merge(a) {
  var b = [].concat($jscomp.arrayFromIterable(arguments)),
    c = "boolean" === typeof b[0] ? b.shift() : !1,
    d = b.shift();
  b = $jscomp.makeIterator(b);
  for (var e = b.next(); !e.done; e = b.next()) {
    if (((e = e.value), Array.isArray(e))) {
      e = $jscomp.makeIterator(e);
      for (var f = e.next(); !f.done; f = e.next()) {
        d.push(mergeItem(f.value, c));
      }
    } else {
      for (var g in e) {
        e.hasOwnProperty(g) && (d[g] = mergeItem(e[g], c));
      }
    }
  }
  return d;
}
function mergeItem(a, b) {
  return b && "object" == typeof a && null !== a ? clone(a, b) : a;
}
function windowScrollTop() {
  return void 0 !== window.pageYOffset
    ? window.pageYOffset
    : document.documentElement.scrollTop;
}
function windowScrollLeft() {
  return void 0 !== window.pageXOffset
    ? window.pageXOffset
    : document.documentElement.scrollLeft;
}
function windowInnerWidth() {
  return void 0 !== window.innerWidth ? window.innerWidth : window.clientWidth;
}
function windowInnerHeight() {
  return void 0 !== window.innerHeight
    ? +window.innerHeight
    : +window.clientHeight;
}
function sessionVal(a, b) {
  if ("string" == typeof a) {
    var c = a;
    a = {};
    a[c] = b;
  }
  c = [];
  for (var d in a) {
    if (a.hasOwnProperty(d)) {
      var e = { name: d };
      b = a[d];
      null !== b && (e.value = b);
      c.push(e);
    }
  }
  new AJAX().get("/script/sessionVal.php", { data: c });
}
function interval(a, b) {
  void 0 === b && (b = new Date());
  b = Math.max(b.getTimeSeconds() - a.getTimeSeconds(), 0);
  return 86400 < b
    ? { time: a, unit: "date" }
    : 3600 < b
    ? { time: Math.floor(b / 3600), unit: "h" }
    : 60 < b
    ? { time: Math.floor(b / 60), unit: "m" }
    : { time: b, unit: "s" };
}
var nodes = {};
domReady.add(function () {
  return (nodes = {
    body: new node(document.body),
    footer: node.querySelector("body > footer"),
  });
});
var integerTypes = {
    tinyint: { unsignedMax: 255 },
    smallint: { unsignedMax: 65535 },
    mediumint: { unsignedMax: 16777215 },
    int: { unsignedMax: 4294967295 },
    bigint: { unsignedMax: "18446744073709551615" },
  },
  type;
for (type in integerTypes) {
  if (integerTypes.hasOwnProperty(type)) {
    var halfUnsignedMax = integerTypes[type].unsignedMax / 2;
    integerTypes[type].signedMin = -Math.ceil(halfUnsignedMax);
    integerTypes[type].signedMax = Math.floor(halfUnsignedMax);
  }
}
function Input(a, b) {
  this.form = a;
  this.column = b;
}
Input.prototype = {
  constructor: Input,
  addEventListeners: function () {
    var a = this;
    switch (this.column.type) {
      case "boolean":
        this.tristateCheckbox &&
          this.node
            .addEventListener("mousedown", function (b) {
              return a.tristateCheckboxMousedown(b);
            })
            .addEventListener("click", function (b) {
              return a.tristateCheckboxClick(b);
            })
            .addEventListener("keyup", function (b) {
              return a.tristateCheckboxKeyup(b);
            });
        break;
      case "tinyint":
      case "smallint":
      case "mediumint":
      case "int":
      case "bigint":
        this.typeNumber && this.node.restrictInput("integer");
        break;
      case "decimal":
        this.typeNumber && this.node.restrictInput("decimal");
        break;
      case "varchar":
      case "text":
        ("varchar" == this.column.type ||
          void 0 !== this.column.minLength ||
          (void 0 !== this.column.pattern &&
            void 0 !== this.column.patternDescription)) &&
          this.node.addEventListener("input", function (b) {
            return a.setCustomValidity(b);
          }),
          void 0 !== this.column.restrictInput &&
            this.node.restrictInput(this.column.restrictInput),
          void 0 !== this.column.wordLimit &&
            this.node.addEventListener("input", function () {
              return a.checkWordLimit();
            });
    }
    void 0 !== this.column.unique &&
      this.column.unique &&
      this.node.addEventListener("input", function () {
        return a.checkExists();
      });
    this.node.addEventListener("keydown", function (b) {
      return a.keydown(b);
    });
  },
  keydown: function (a) {
    "Escape" != a.key && "Esc" != a.key && a.stopPropagation();
  },
  tristateCheckboxMousedown: function (a) {
    0 == a.button && this.tristateCheckboxCycle();
  },
  tristateCheckboxClick: function (a) {
    a.preventDefault();
  },
  tristateCheckboxKeyup: function (a) {
    if (" " == a.key || "Spacebar" == a.key) {
      a.preventDefault(), this.tristateCheckboxCycle();
    }
  },
  tristateCheckboxCycle: function () {
    this.node.indeterminate()
      ? (this.node.indeterminate(!1), this.node.checked(!0))
      : this.node.checked()
      ? this.node.checked(!1)
      : this.node.indeterminate(!0);
    this.node.dispatchEvent(new Event("change"));
  },
  setCustomValidity: function (a) {
    this.node.validity.tooShort || this.node.validity.tooLong
      ? this.node.setCustomValidity(
          void 0 !== this.column.lengthDescription
            ? this.column.lengthDescription
            : this.column.printName +
                "s are " +
                (this.column.minLength < this.column.length
                  ? "between " + this.column.minLength + " and "
                  : "") +
                this.column.length +
                " characters."
        )
      : this.node.validity.patternMismatch &&
        void 0 !== this.column.patternDescription
      ? this.node.setCustomValidity(this.column.patternDescription)
      : this.node.setCustomValidity("");
  },
  checkExists: function (a) {
    this.node.checkValidity() &&
      this.form.checkExists(this.column.name, this.getValue(), a);
  },
  checkExistsSuccess: function (a) {
    a
      ? this.node.setCustomValidity(this.column.existsMessage)
      : this.node.setCustomValidity("");
  },
  getValue: function (a) {
    void 0 === a && (a = this.column.nullable);
    switch (this.column.type) {
      case "boolean":
        a = a && this.node.indeterminate() ? null : this.node.checked();
        break;
      case "tinyint":
      case "smallint":
      case "mediumint":
      case "int":
      case "bigint":
      case "float":
      case "double":
      case "decimal":
        a = a && "" == this.node.value() ? null : Number(this.node.value());
        break;
      default:
        a = a && "" == this.node.value() ? null : this.node.value();
    }
    return a;
  },
  printValue: function () {
    var a = this.getValue();
    if (null === a) {
      a = "";
    } else {
      switch (this.column.type) {
        case "boolean":
          a = a ? "True" : "False";
          break;
        case "date":
          a = a.substr(8, 2) + "/" + a.substr(5, 2) + "/" + a.substr(0, 4);
      }
    }
    return a;
  },
  hasChanged: function (a) {
    void 0 === a && (a = this.column.nullable);
    var b = this.value;
    "string" == typeof b && (b = b.replace(/\r\n/g, "\n"));
    a = this.getValue(a);
    "string" == typeof a && (a = a.replace(/\r\n/g, "\n"));
    return b !== a;
  },
  addConditionListener: function (a, b) {
    var c = this;
    this.node.addEventListener("change", function () {
      return a.conditionalEnable(c.getValue() === b);
    });
  },
  conditionalEnable: function (a) {
    this.node.disabled(!a);
    this.node.required(a);
    var b = this.node.parentElement().parentElement();
    b.changeClass("required", a);
    this.column.hideUntilEnabled && b.changeClass("hidden", !a);
  },
  checkWordLimit: function () {
    this.getValue().split(/\s+/).length > this.column.wordLimit
      ? this.node.setCustomValidity(
          "There is a " + this.column.wordLimit + " word limit."
        )
      : this.node.setCustomValidity("");
  },
};
function ManyToManyInput(a, b) {
  ManyToManyInput.parent.constructor.apply(this, arguments);
}
extend(ManyToManyInput, Input, {
  addEventListeners: function () {
    var a = this;
    if (!this.column.nullable) {
      for (
        var b = $jscomp.makeIterator(this.subinputs), c = b.next();
        !c.done;
        c = b.next()
      ) {
        c.value.addEventListener("change", function () {
          return a.checkNull();
        });
      }
      this.checkNull();
    }
  },
  getValue: function () {
    for (
      var a = [], b = $jscomp.makeIterator(this.subinputs), c = b.next();
      !c.done;
      c = b.next()
    ) {
      (c = c.value), c.checked() && a.push(c.dataset.id);
    }
    return a;
  },
  hasChanged: function () {
    changed = !1;
    for (
      var a = $jscomp.makeIterator(this.subinputs), b = a.next();
      !b.done;
      b = a.next()
    ) {
      if (b.value.checked()) {
        changed = !0;
        break;
      }
    }
    return changed;
  },
  addConditionListener: function (a, b) {
    for (
      var c = {}, d = $jscomp.makeIterator(this.subinputs), e = d.next();
      !e.done;
      c = { $jscomp$loop$prop$subinput$87: c.$jscomp$loop$prop$subinput$87 },
        e = d.next()
    ) {
      (c.$jscomp$loop$prop$subinput$87 = e.value),
        +c.$jscomp$loop$prop$subinput$87.dataset.id === b &&
          c.$jscomp$loop$prop$subinput$87.addEventListener(
            "change",
            (function (b) {
              return function () {
                return a.conditionalEnable(
                  b.$jscomp$loop$prop$subinput$87.checked()
                );
              };
            })(c)
          );
    }
  },
  checkNull: function () {
    for (
      var a = !0, b = $jscomp.makeIterator(this.subinputs), c = b.next();
      !c.done;
      c = b.next()
    ) {
      if (c.value.checked()) {
        a = !1;
        break;
      }
    }
    a
      ? this.subinputs[0].setCustomValidity("You must choose at least 1 option")
      : this.subinputs[0].setCustomValidity("");
  },
});
function NewInput(a, b) {
  this.form = a;
  this.column = b;
  this.node = new node(this.nodeName);
  switch (b.type) {
    case "boolean":
      this.node.type("checkbox");
      this.hasValue
        ? this.value && this.node.checked(!0)
        : this.node.indeterminate(!0);
      break;
    case "tinyint":
    case "smallint":
    case "mediumint":
    case "int":
    case "bigint":
      this.typeNumber &&
        ((a = integerTypes[b.type]),
        this.node.setAttributes({
          type: "number",
          min: b.signed ? a.signedMin : 0,
          max: b.signed ? a.signedMax : a.unsignedMax,
          pattern: "\\d",
        }));
      break;
    case "decimal":
      if (this.typeNumber) {
        a = Math.pow(10, -b.scale);
        var c = Math.pow(10, b.precision - b.scale) - a;
        this.node.setAttributes({
          type: "number",
          min: b.signed ? -c : 0,
          max: c,
          step: a,
          pattern: "[\\d.-]",
        });
      }
      break;
    case "date":
      this.node.setAttributes({ type: "date", pattern: "[\\d/-\\\\]" });
      break;
    case "varchar":
    case "text":
      this.node.maxLength("varchar" == b.type ? b.length : 65535),
        void 0 !== b.minLength && this.node.minLength(b.minLength),
        void 0 !== b.pattern && this.node.pattern(b.pattern);
  }
  void 0 !== b.inputType && this.node.type(b.inputType);
  "boolean" != b.type &&
    this.hasValue &&
    ("text" != b.type
      ? this.node.value(this.value)
      : this.node.textContent(this.value));
  this.required && this.node.addAttribute("required");
  this.addEventListeners();
}
extend(NewInput, Input, {
  focus: function () {
    this.node.focus();
  },
});
function NewInputInput(a, b) {
  this.nodeName = "text" != b.type ? "input" : "textarea";
  switch (b.type) {
    case "boolean":
      this.tristateCheckbox = b.nullable;
      break;
    case "tinyint":
    case "smallint":
    case "mediumint":
    case "int":
    case "bigint":
    case "decimal":
      this.typeNumber = !0;
  }
  this.required = !b.nullable && "boolean" != b.type;
  NewInputInput.parent.constructor.apply(this, arguments);
}
extend(NewInputInput, NewInput);
function NewInsertInput(a, b) {
  this.hasValue = null !== b.default;
  this.value = b.default;
  NewInsertInput.parent.constructor.apply(this, arguments);
}
extend(NewInsertInput, NewInputInput);
function ExtantInput(a, b, c, d) {
  this.form = a;
  this.column = b;
  this.node = c;
  this.value = b.nullable && void 0 === d ? null : d;
  this.addEventListeners();
}
extend(ExtantInput, Input);
function ExtantManyToManyInput(a, b, c, d) {
  ExtantManyToManyInput.parent.constructor.call(this, a, b);
  this.node = c;
  this.subinputs = this.node.querySelectorAll("input");
  this.value = b.nullable && void 0 === d ? null : d;
  this.addEventListeners();
}
extend(ExtantManyToManyInput, ManyToManyInput);
function Form() {
  this.statics.formID++;
  this.submitting = !1;
  this.inputs = new Map();
  this.unique = new Map();
  this.data = {};
  for (
    var a = $jscomp.makeIterator(this.columns), b = a.next();
    !b.done;
    b = a.next()
  ) {
    (b = b.value),
      void 0 !== b.unique && b.unique && this.unique.set(b.name, !1);
  }
}
Form.prototype = {
  constructor: Form,
  statics: { formID: 0 },
  checkExists: function (a, b, c) {
    var d = this;
    c = void 0 === c ? !1 : c;
    this.unique.set(a, !1);
    this.forum.checkUserExists(a, b, function (b) {
      return d.checkExistsSuccess(a, c, b);
    });
  },
  checkExistsSuccess: function (a, b, c) {
    c.success &&
      (this.inputs.get(a).checkExistsSuccess(c.exists),
      this.unique.set(a, !c.exists),
      c.exists ? this.node.reportValidity() : b && this.submit());
  },
  submit: function (a) {
    var b = this;
    void 0 !== a && a.preventDefault();
    if (this.submitting) {
      return !1;
    }
    a = $jscomp.makeIterator(this.inputs);
    for (var c = a.next(); !c.done; c = a.next()) {
      var d = $jscomp.makeIterator(c.value);
      c = d.next().value;
      d = d.next().value;
      d.hasChanged() && (this.data[c] = d.getValue());
    }
    if (0 == size(this.data)) {
      return !1;
    }
    this.submitting = !0;
    new AJAX().post(
      this.handler,
      { action: this.action, data: this.data },
      {
        success: function (a) {
          return b.submitSuccess(a);
        },
      }
    );
    return !0;
  },
  submitSuccess: function (a) {
    a.success || (this.submitting = !1);
  },
  displayError: function (a) {
    void 0 === this.errorMessage
      ? (this.errorMessageRow = this.tbody
          .prependNode("tr", "error")
          .append(
            new node("td", { colspan: 2 }).append(
              (this.errorMessage = new node("p"))
            )
          ))
      : this.errorMessage.empty();
    this.errorMessage.append.apply(this.errorMessage, arguments);
  },
  defaultError: function (a) {
    this.displayError(
      "There was an error " + a + ".",
      document.createElement("br"),
      "If the problem persists, please contact ",
      new node("a", { href: "mailto:" + this.errorEmail }, this.errorEmail),
      "."
    );
  },
  clearError: function () {
    void 0 !== this.errorMessage &&
      (this.errorMessageRow.remove(),
      delete this.errorMessageRow,
      delete this.errorMessage);
  },
  additionalInfoToggleClick: function (a, b) {
    var c = this;
    a.preventDefault();
    this.additionalInfoVisible
      ? this.additionalInfoRemove()
      : (a.stopPropagation(),
        (this.additionalInfoToggle = b),
        (this.additionalInfo = b.nextSibling()),
        this.additionalInfo.addClass("visible"),
        this.additionalInfoRemoveClickTarget.addEventListener(
          "click.additionalInfo",
          function (a) {
            return c.additionalInfoRemoveClick(a);
          }
        ),
        (this.additionalInfoVisible = !0));
  },
  additionalInfoRemoveClick: function (a) {
    this.additionalInfo.containsOrIsSameNode(a.target) ||
      this.additionalInfoToggle.isSameNode(a.target) ||
      this.additionalInfoRemove();
  },
  additionalInfoRemove: function () {
    this.additionalInfo.removeClass("visible");
    this.additionalInfoRemoveClickTarget.removeEventListener(".additionalInfo");
    this.additionalInfoVisible = !1;
  },
  addConditionListeners: function (a) {
    a = $jscomp.makeIterator(this.columns);
    for (var b = a.next(); !b.done; b = a.next()) {
      (b = b.value),
        void 0 !== b.condition &&
          this.inputs
            .get(b.condition.field)
            .addConditionListener(this.inputs.get(b.name), b.condition.value);
    }
  },
};
function ModalFormContainer() {
  this.shown = !1;
  nodes.body.append(
    (this.node = new node("div", "modalContainer form hidden"))
  );
}
ModalFormContainer.prototype = {
  constructor: ModalFormContainer,
  appendForm: function (a) {
    var b = this;
    this.form = a;
    this.node.appendNode("div").appendChild(a.node);
    this.node.offsetHeight();
    a.firstInputFocus();
    this.shown ||
      ((this.shown = !0),
      this.node.addTransitionListenerOnce("-hidden", function () {
        return b.showComplete();
      }));
  },
  showComplete: function () {
    var a = this;
    eventTargets.document
      .addEventListener("click.modalFormRemove", function (b) {
        return a.documentClick(b);
      })
      .addEventListener("keydown.modalFormRemove", function (b) {
        return a.documentKeydown(b);
      });
  },
  documentClick: function (a) {
    this.form.node.containsOrIsSameNode(a.target) || this.close();
  },
  documentKeydown: function (a) {
    27 == a.which && this.close();
  },
  close: function () {
    this.node.addTransitionListenerOnce("hidden", function () {
      this.remove();
    });
    eventTargets.document.removeEventListener(".modalFormRemove");
  },
  replace: function (a) {
    var b = this;
    this.oldForm = this.form;
    this.appendForm(a);
    this.node.addTransitionListenerOnce("replacing", function () {
      return b.replaceComplete();
    });
  },
  replaceComplete: function () {
    this.oldForm.remove();
    delete this.oldForm;
    this.node.removeClass("replacing");
  },
};
function ModalForm(a) {
  var b = this;
  ModalForm.parent.constructor.apply(this, arguments);
  this.container = a;
  this.additionalInfoVisible = !1;
  this.node = new node("form", "defaultForm modal");
  this.tbody = new node("tbody");
  for (
    var c = this, d = $jscomp.makeIterator(this.columns), e = d.next();
    !e.done;
    e = d.next()
  ) {
    if (((e = e.value), !e.primaryKey)) {
      var f = new NewInsertInput(this, e),
        g = "form" + this.statics.formID + "-" + e.name;
      f.node.setAttribute("id", g);
      this.inputs.set(e.name, f);
      void 0 === this.firstInput && (this.firstInput = f);
      var h = void 0;
      this.tbody
        .appendNode("tr", e.nullable ? null : "required")
        .append(
          (h = new node("td").append(
            new node("label", { for: g }, e.printName)
          )),
          new node("td").append(f.node)
        );
      void 0 !== e.additionalInfo &&
        (void 0 == this.additionalInfoRemoveClickTarget &&
          (this.additionalInfoRemoveClickTarget = this.node),
        h.append(
          new node(
            "div",
            "additionalInfoToggle fa fa-info-circle"
          ).addEventListener("click", function (a) {
            c.additionalInfoToggleClick(a, this);
          }),
          new node("p", "additionalInfo", e.additionalInfo)
        ));
    }
  }
  this.submitRow = this.tbody
    .appendNode("tr")
    .append(
      new node("td"),
      new node("td").append(
        (this.submitButton = new node(
          "button",
          { type: "submit" },
          this.submitLabel
        ))
      )
    );
  void 0 !== this.title && this.node.appendNode("h2", null, this.title);
  void 0 !== this.message && this.node.appendNode("p", "message", this.message);
  this.node.append(
    new node("table").append(this.tbody),
    (this.closeButton = new node("button", {
      type: "button",
      class: "close fa fa-times",
    }))
  );
  this.node.addEventListener("submit", function (a) {
    return b.submit(a);
  });
  this.closeButton.addEventListener("click", function () {
    return b.closeButtonClick();
  });
  this.addConditionListeners();
}
extend(ModalForm, Form, {
  firstInputFocus: function () {
    this.firstInput.focus();
  },
  submit: function (a) {
    if (!ModalForm.parent.submit.apply(this, arguments)) {
      return 0 == size(this.data) && this.close(), !1;
    }
    this.submitButton
      .addClass("submitting")
      .empty()
      .append("Submitting", new node("span", "fa fa-spin fa-circle-o-notch"));
    return !0;
  },
  submitSuccess: function (a, b) {
    ModalForm.parent.submitSuccess.call(this, a);
    void 0 === b && (b = !1);
    a.success
      ? (b || this.close(), (a = "Success"))
      : (this.submitButton.removeClass("submitting"), (a = this.submitLabel));
    this.submitButton.empty().textContent(a);
  },
  closeButtonClick: function () {
    this.close();
  },
  close: function () {
    this.container.close();
  },
  remove: function () {
    this.node.parentElement().remove();
  },
});
function ExtantForm(a) {
  var b = this;
  ExtantForm.parent.constructor.apply(this, arguments);
  this.tbody = this.node.querySelector("tbody");
  this.submitButton = this.node.querySelector("button[type=submit]");
  for (
    var c = this, d = $jscomp.makeIterator(this.columns), e = d.next();
    !e.done;
    e = d.next()
  ) {
    if (((e = e.value), !e.primaryKey && !e.hidden)) {
      var f = this.node.querySelector("tr." + e.name),
        g = void 0;
      g =
        "manyToMany" != e.type
          ? new ExtantInput(
              this,
              e,
              f.querySelector(
                e.foreignKey
                  ? "select"
                  : "text" != e.type
                  ? "input"
                  : "textarea"
              ),
              a[e.name]
            )
          : new ExtantManyToManyInput(this, e, f, a[e.name]);
      this.inputs.set(e.name, g);
      void 0 !== e.additionalInfo &&
        (void 0 == this.additionalInfoRemoveClickTarget &&
          (this.additionalInfoRemoveClickTarget = eventTargets.document),
        f
          .querySelector(".additionalInfoToggle")
          .addEventListener("click", function (a) {
            c.additionalInfoToggleClick(a, this);
          }));
    }
  }
  this.node.addEventListener("submit", function (a) {
    return b.submit(a);
  });
  this.addConditionListeners();
}
extend(ExtantForm, Form, {
  checkExists: function (a, b, c) {
    this.inputs.get(a).hasChanged() &&
      ExtantForm.parent.checkExists.apply(this, arguments);
  },
  submit: function (a) {
    if (!ExtantForm.parent.submit.apply(this, arguments)) {
      return !1;
    }
    this.submitButton
      .addClass("submitting")
      .empty()
      .append("Submitting", new node("span", "fa fa-spin fa-circle-o-notch"));
    return !0;
  },
  submitSuccess: function (a) {
    var b = this;
    ExtantForm.parent.submitSuccess.apply(this, arguments);
    if (a.success) {
      var c = "Success";
      this.clearError();
    } else {
      this.submitButton.removeClass("submitting").addClass("failed"),
        (c = "Submit");
    }
    this.submitButton.empty().textContent(c);
    this.submitButton.blur();
    setTimeout(function () {
      return b.allowSubmit();
    }, 3000);
  },
  allowSubmit: function () {
    this.submitting = !1;
    this.submitButton
      .removeClass("submitting failed")
      .empty()
      .textContent("Submit");
  },
});
function Search(a) {
  var b = this;
  this.container = a;
  this.form = node.querySelector("." + this.name + "Form");
  this.input = this.form.querySelector("input");
  this.fixed =
    this.drawn =
    this.active =
    this.blurOnSubmit =
    this.inputFocussed =
      !1;
  this.activeGroupName = "all";
  this.noResults = new node("p").append(
    "Sorry, there were no",
    (this.noResultsType = new node("span", null, " results")),
    " matching your query."
  );
  this.form
    .addEventListener("click", function () {
      return b.formClick();
    })
    .addEventListener("submit", function (a) {
      return b.submit(a);
    })
    .addEventListener("reset", function () {
      return b.reset();
    });
  this.input
    .addEventListener("keydown", function (a) {
      return b.inputKeydown(a);
    })
    .addEventListener("focus", function () {
      return b.inputFocus();
    })
    .addEventListener("blur", function () {
      return b.inputBlur();
    });
}
// Search.prototype = {
//   constructor: Search, inputKeydown: function (a) {
//     switch (a.key) {
//       case 'Tab':
//         a.preventDefault();
//         this.input.blur();
//         this.container.afterSearchFocus();
//         break;
//       case 'Escape':
//       case 'Esc':
//         this.remove();
//     }
//   }, inputFocus: function () {
//     var a = this;
//     this.inputFocussed = !0;
//     this.windowHeight = windowInnerHeight();
//     eventTargets.window.addEventListener('resize.' + this.name + '.inputFocus', function () {
//       return a.resizeInputFocus();
//     });
//     this.container.searchFocus();
//   }, resizeInputFocus: function () {
//     this.blurOnSubmit = windowInnerHeight() <= 2 / 3 * this.windowHeight;
//   }, inputBlur: function () {
//     this.inputFocussed = !1;
//     eventTargets.window.removeEventListener('resize.' + this.name + '.inputFocus');
//     this.active || this.container.searchDeactivate();
//   }, formClick: function () {
//     this.input.focus();
//   }, submit: function (a) {
//     var b = this;
//     a.preventDefault();
//     this.submitting || (this.query = this.input.value(), '' != this.query && (this.submitting = !0, this.container.searchSubmit(), this.active = !0, this.form.removeClass('submitComplete').addClass('active'), this.submitSpinner = this.form.appendNode('span', 'submitSpinner fa fa-circle-o-notch fa-spin'), eventTargets.window.removeEventListener('resize.' + this.name + '.inputFocus'), this.blurOnSubmit && this.input.blur(), (new AJAX).get('/script/' + this.name + '.php', {
//       data: { query: this.query }, complete: function (a) {
//         return b.submitComplete();
//       }, success: function (a) {
//         return b.submitSuccess(a);
//       }, error: function (a, b) {
//         return console.error(b);
//       }
//     })));
//   }, submitComplete: function () {
//     this.submitting = !1;
//     this.form.addClass('submitComplete');
//     this.submitSpinner.remove();
//     delete this.submitSpinner;
//   }, submitSuccess: function (a) {
//     this.results = a.results;
//     console.log('main: ' + a.mainQuery);
//     console.log('synonyms: ' + a.synonymQuery);
//     (a = this.drawn) ? (this.resultsContainer.empty(), this.googleLink.href(this.googleURL())) : this.drawResultsContainer();
//     this.drawResults(this.activeGroupName);
//     a || this.showResultsContainer();
//   }, drawResultsContainer: function () {
//     var a = this;
//     this.filters = {};
//     this.filterContainer = new node('div', 'filters');
//     for (var b = $jscomp.makeIterator(this.sourceGroups), c = b.next(); !c.done; c = b.next()) {
//       var d = $jscomp.makeIterator(c.value);
//       c = d.next().value;
//       d = d.next().value;
//       var e = c == this.activeGroupName;
//       this.filters[c] = new SearchFilter(this, c, d.filterTitle, e);
//       this.filterContainer.appendChild(this.filters[c].node);
//       e && (this.activeFilter = this.filters[c]);
//     }
//     this.modalContainer = (new node('div', 'layoutRow modalContainer searchRow ' + this.name + 'Row hidden' + (this.fixed ? ' fixed' : ''))).append((new node('div')).append(this.mainContainer = (new node('div', 'modal searchResults')).append(this.filterContainer, this.scrollableContainer = (new node('div', 'scrollable')).append(this.resultsContainer = new node('div', 'results'), (new node('p', 'footer')).append('No suitable results? ', this.googleLink = new node('a', { href: this.googleURL(), target: '_blank' },
//       'search via Google'))))));
//     this.setMainContainerHeight();
//     eventTargets.window.addEventListener('resize.' + this.name, function () {
//       return a.setMainContainerHeight();
//     });
//     nodes.body.appendChild(this.modalContainer);
//     this.drawn = !0;
//   }, showResultsContainer: function () {
//     var a = this;
//     this.modalContainer.offsetHeight();
//     this.modalContainer.addTransitionListenerOnce('-hidden', function () {
//       return a.modalContainerFadeComplete();
//     });
//   }, drawResults: function (a) {
//     if (0 < this.results[a].length) {
//       a = $jscomp.makeIterator(this.results[a]);
//       for (var b = a.next(); !b.done; b = a.next()) {
//         this.drawResult(b.value);
//       }
//     } else {
//       this.noResultsType.textContent(' ' + this.sourceGroups.get(a).noResultsText), this.resultsContainer.appendChild(this.noResults);
//     }
//   }, filterClick: function (a, b) {
//     this.activeFilter.deactivate();
//     this.activeFilter = a;
//     this.activeGroupName = b;
//     this.resultsContainer.empty();
//     this.scrollableContainer.scrollTop(0);
//     this.drawResults(b);
//   }, drawResult: function (a) {
//     var b = this.sources[a.table];
//     if (void 0 === b.ancestryPath) {
//       var c = this.parseSource(a, b.path);
//     } else {
//       c = '';
//       for (var d = $jscomp.makeIterator(a.ancestry), e = d.next(); !e.done; e = d.next()) {
//         c += '/' + e.value.path;
//       }
//     }
//     c = this.resultsContainer.appendNode('a', { 'class': 'searchResult searchResult' + a.table.toSentenceCase(), href: c });
//     c.appendNode('h2', null, this.parseSource(a, b.label));
//     c.appendNode('p', 'rank', a.rank.toFixed(2));
//     void 0 !== b.date && (d = new Date(a[b.date]), c.appendNode('p', 'time').appendNode('time', { datetime: d.toISOString() }, d.getDate() + ' ' + d.getMonthNameShort() + ' ' + d.getFullYear()));
//     void 0 !== b.header && (d = c.appendNode('h3', null, a[b.header]), void 0 !== b.author && d.appendNode('span', 'author', ' \u2013 ' + a[b.author]));
//     void 0 !== b.text && null !== a[b.text] && c.appendNode('p', null, a[b.text]);
//     void 0 !== b.html && null !== a[b.html] && (c = c.appendNode('p'), c.innerHTML(a[b.html]), a = c.firstChild().textContent(), c.empty().appendChild(a));
//   }, parseSource: function (a, b) {
//     return b.replace(/\$(\w+)/g, function (b, d) {
//       return a[d];
//     });
//   }, googleURL: function () {
//     return 'https://www.google.co.uk/search?q=site%3Aadfam.org.uk' + this.subdomain + '+' + encodeURIComponent(this.query).replace(/(?:%20)+/, '+');
//   }, scrollCheck: function () {
//     this.drawn && this.setMainContainerHeight();
//   }, changeFixed: function (a) {
//     this.fixed = a;
//     this.drawn && this.modalContainer.changeClass('fixed', a);
//   }, setMainContainerHeight: function () {
//     this.fixed || (this.mainContainer.style.height = (windowInnerHeight() + windowScrollTop() - this.container.offsetTop - this.container.height) / 20 - 0.5 + 'rem');
//   }, modalContainerFadeComplete: function () {
//     var a = this;
//     eventTargets.document.addEventListener('click.' + this.name, function (b) {
//       return a.documentClick(b);
//     });
//     eventTargets.document.addEventListener('keydown.' + this.name, function (b) {
//       'r' == b.key && b.ctrlKey && (b.preventDefault(), a.resultsContainer.toggleClass('showRank'));
//     });
//   }, documentClick: function (a) {
//     this.scrollableContainer.containsOrIsSameNode(a.target) || this.filterContainer.containsOrIsSameNode(a.target) || this.form.containsOrIsSameNode(a.target) || (a.preventDefault(), a.stopPropagation(), this.remove());
//   }, reset: function () {
//     this.input.blur();
//     this.remove();
//   }, remove: function () {
//     var a = this;
//     this.active && (this.drawn = this.active = !1, this.modalContainer.addTransitionListenerOnce('hidden', function () {
//       return a.removeComplete();
//     }), this.form.removeClass('active submitComplete'), this.container.searchDeactivate(), eventTargets.window.removeEventListener('.' + this.name), eventTargets.document.removeEventListener('.' + this.name));
//   }, removeComplete: function () {
//     this.modalContainer.remove();
//     delete this.modalContainer;
//   }
// };
// function SiteSearch(a) {
//   SiteSearch.parent.constructor.apply(this, arguments);
// }
// extend(SiteSearch, Search, {
//   name: 'siteSearch', sources: {
//     page: { label: 'Page', header: 'title', text: 'description', ancestryPath: !0 }, news: { label: '$type', date: 'time', header: 'title', text: 'shortDescription', path: '/our-work/news-and-events/$typePath/$id' }, resourceLibrary: { label: 'Resource', header: 'title', html: 'description', path: '/our-work/supporting-professionals/resources/$id' }, resourceLibraryTagName: { label: 'Resource Topic', header: 'name', path: '/our-work/supporting-professionals/resources/$path' },
//     blogPost: { label: 'Blog', date: 'datePublished', header: 'title', author: 'name', text: 'snippet', path: '/about-us/blog/$id' }
//   }, sourceGroups: new Map([['all', { filterTitle: 'All', noResultsText: 'results' }], ['page', { filterTitle: 'Pages', noResultsText: 'pages' }], ['news', { filterTitle: 'News & Events', noResultsText: 'news items or events' }], ['resources', { filterTitle: 'Resources', noResultsText: 'resources' }], ['blogPost', { filterTitle: 'Blog', noResultsText: 'blog posts' }]]), subdomain: ''
// });
function ForumSearch(a) {
  ForumSearch.parent.constructor.apply(this, arguments);
}
extend(ForumSearch, Search, {
  name: "forumSearch",
  sources: {
    forumCategory: {
      label: "Category",
      header: "name",
      text: "description",
      path: "/help-for-families/finding-support/forum/category/$path",
    },
    forumThread: {
      label: "Thread",
      date: "dateCreated",
      header: "title",
      text: "text",
      path: "/help-for-families/finding-support/forum/thread/$id",
    },
    forumPost: {
      label: "Post",
      date: "dateCreated",
      header: "title",
      text: "text",
      path: "/help-for-families/finding-support/forum/thread/$threadID#forumPost$postID",
    },
    forumThreadPost: {
      label: "Both",
      date: "dateCreated",
      header: "title",
      text: "text",
      path: "/help-for-families/finding-support/forum/thread/$threadID#forumPost$postID",
    },
    forumUser: {
      label: "User",
      header: "username",
      path: "/help-for-families/finding-support/forum/user/$userPath",
    },
  },
  sourceGroups: new Map([
    ["all", { filterTitle: "All", noResultsText: "results" }],
    [
      "forumCategory",
      { filterTitle: "Categories", noResultsText: "categories" },
    ],
    ["forumThread", { filterTitle: "Threads", noResultsText: "threads" }],
    ["forumPost", { filterTitle: "Posts", noResultsText: "posts" }],
    [
      "forumThreadPost",
      { filterTitle: "Both", noResultsText: "posts/threads" },
    ],
    ["forumUser", { filterTitle: "Users", noResultsText: "users" }],
  ]),
  subdomain: "/help-for-families/finding-support/forum",
  drawResultsContainer: function () {
    ForumSearch.parent.drawResultsContainer.call(this);
    this.setModalContainerTop();
  },
  resizeCheck: function () {
    this.drawn && this.setModalContainerTop();
  },
  setModalContainerTop: function () {
    this.modalContainer.style.top =
      (this.container.offsetTop + this.container.height) / 20 + "rem";
  },
});
function SearchFilter(a, b, c, d) {
  var e = this;
  this.search = a;
  this.groupName = b;
  this.active = d;
  this.node = new node(
    "button",
    "searchFilter" + b.toSentenceCase() + (d ? " this" : ""),
    c
  ).addEventListener("click", function () {
    return e.click();
  });
}
SearchFilter.prototype = {
  constructor: SearchFilter,
  click: function () {
    this.active ||
      ((this.active = !0),
      this.node.addClass("this"),
      this.search.filterClick(this, this.groupName));
  },
  deactivate: function () {
    this.active && ((this.active = !1), this.node.removeClass("this"));
  },
};
function Nav() {
  var a = this;
  this.node = node.querySelector(this.selector);
  this.behindSearch = this.node.querySelector(this.behindSearchSelector);
  this.afterSearch = this.behindSearch.querySelector(this.afterSearchSelector);
  this.offsetTop = this.node.offset().top;
  this.height = this.node.offsetHeight();
  this.fixed = !1;
  eventTargets.window
    .addEventListener("scroll", function () {
      return a.scrollCheck();
    })
    .addEventListener("resize", function () {
      return a.resizeCheck();
    });
  this.behindSearch.addTransitionListener(function (b, c) {
    return a.behindSearchTransitionComplete(c);
  }, "opacity");
}
Nav.prototype = {
  constructor: Nav,
  scrollCheck: function () {
    this.search.scrollCheck();
  },
  resizeCheck: function () {
    this.offsetTop = this.node.offset().top;
  },
  searchFocus: function () {
    this.behindSearch.addClass("searchFocus");
    this.behindSearchTransparent && this.behindSearch.addClass("searchActive");
  },
  behindSearchTransitionComplete: function (a) {
    (this.behindSearchTransparent = 0 == a) &&
      this.search.inputFocussed &&
      this.behindSearch.addClass("searchActive");
  },
  searchDeactivate: function () {
    this.behindSearch.removeClass("searchActive");
    this.behindSearch.offsetHeight();
    this.behindSearch.removeClass("searchFocus");
    this.behindSearchTransparent = !1;
  },
  afterSearchFocus: function () {
    this.afterSearch.focus();
  },
};
function MainNav() {
  var a = this;
  MainNav.parent.constructor.call(this);
  this.tier0 = this.node.querySelector(".navTier0");
  this.input = this.node.querySelector("input");
  null !== this.input &&
    (this.inputAncestors = this.input.ancestors(
      ".navTier0 > .navPage, .navTier1 > .navPage"
    ));
  this.tier0Transparent = this.sideNavTransitioning = this.sideNavShown = !1;
  this.node.querySelector(".navTiers").addTransitionListener(
    function () {
      return a.logoShow();
    },
    "margin-left",
    "140px"
  );
  this.tier0.addTransitionListener(function (b, c) {
    return a.sideNavTransitionComplete(c);
  }, "left");
  this.node.querySelector(".navBarMain > .navLogo").addTransitionListener(
    function () {
      return a.logoHide();
    },
    "opacity",
    "0"
  );
  var b = function () {
    return a.toggleClick();
  };
  this.node.querySelector(".navToggleStatic").addEventListener("click", b);
  this.node.querySelector(".navToggleFixed").addEventListener("click", b);
  b = this.node.querySelector(".navBlanker");
  b.addEventListener("click", function () {
    return a.sideNavClose();
  });
  null !== this.input &&
    this.input
      .addEventListener("keydown", function (b) {
        return a.inputKeydown(b);
      })
      .addEventListener("focus", function () {
        return a.inputFocus();
      })
      .addEventListener("blur", function () {
        return a.inputBlur();
      });
  var c = function () {
    return a.sideNavClose();
  };
  new Hammer(b.sourceNode).on("swipeleft", c);
  new Hammer(this.tier0.sourceNode).on("swipeleft", c);
  // this.search = new SiteSearch(this);
  // this.scrollCheck();
}
extend(MainNav, Nav, {
  selector: "body > nav",
  behindSearchSelector: ".navTier0",
  afterSearchSelector: ".navPage > a",
  scrollCheck: function () {
    MainNav.parent.scrollCheck.call(this);
    windowScrollTop() > this.offsetTop
      ? this.fixed ||
        ((this.fixed = !0),
        this.node.addClass("fixed showLogoSpaced"),
        (1216 >= windowInnerWidth() || this.search.inputFocussed) &&
          this.logoShow(),
        this.search.changeFixed(!0))
      : this.fixed &&
        ((this.fixed = !1),
        this.node.removeClass("fixed showLogoSpaced showLogo"),
        this.search.changeFixed(!1));
  },
  logoShow: function () {
    this.fixed &&
      (this.node.addClass("showLogoPrepare"),
      this.node.offsetHeight(),
      this.node.addClass("showLogo"));
  },
  logoHide: function () {
    this.fixed || this.node.removeClass("showLogoPrepare");
  },
  toggleClick: function () {
    this.sideNavTransitioning ||
      ((this.sideNavTransitioning = !0),
      this.sideNavShown ? this.sideNavClose() : this.sideNavOpen());
  },
  sideNavOpen: function () {
    this.sideNavShown ||
      (nodes.body.addClass("showNavPrepare"),
      nodes.body.offsetHeight(),
      nodes.body.addClass("showNav"),
      this.search.remove(),
      (this.sideNavShown = !0));
  },
  sideNavClose: function () {
    this.sideNavShown &&
      (nodes.body.removeClass("showNav"), (this.sideNavShown = !1));
  },
  sideNavTransitionComplete: function (a) {
    this.sideNavTransitioning = !1;
    "-400px" == a && nodes.body.removeClass("showNavPrepare");
  },
  inputKeydown: function (a) {
    ("Escape" != a.key && "Esc" != a.key) || this.input.blur();
  },
  inputFocus: function () {
    for (
      var a = $jscomp.makeIterator(this.inputAncestors), b = a.next();
      !b.done;
      b = a.next()
    ) {
      b.value.addClass("inputFocus");
    }
  },
  inputBlur: function () {
    for (
      var a = $jscomp.makeIterator(this.inputAncestors), b = a.next();
      !b.done;
      b = a.next()
    ) {
      b.value.removeClass("inputFocus");
    }
  },
  searchSubmit: function () {
    this.sideNavClose();
  },
});
function ForumNav() {
  ForumNav.parent.constructor.call(this);
  this.search = new ForumSearch(this);
  this.scrollCheck();
}
extend(ForumNav, Nav, {
  selector: ".forumNav",
  behindSearchSelector: ".forumNavBreadcrumb",
  afterSearchSelector: ".breadcrumbItem",
  scrollCheck: function () {
    ForumNav.parent.scrollCheck.call(this);
    windowScrollTop() > this.offsetTop - nav.height
      ? this.fixed ||
        ((this.fixed = !0),
        this.node.addClass("fixed"),
        this.search.changeFixed(!0))
      : this.fixed &&
        ((this.fixed = !1),
        this.node.removeClass("fixed"),
        this.search.changeFixed(!1));
  },
  resizeCheck: function () {
    ForumNav.parent.resizeCheck.call(this);
    this.height = this.node.offsetHeight();
    this.search.resizeCheck();
  },
  searchSubmit: function () {},
});
var nav;
domReady.add(function () {
  nav = new MainNav();
  "forum" == page.path && new ForumNav();
});
function FamilyAngleForm() {}
FamilyAngleForm.prototype = {
  constructor: FamilyAngleForm,
  recaptchaLoad: function () {
    var a = this;
    domReady.add(function () {
      return a.construct();
    });
  },
  construct: function () {
    var a = this;
    this.form = node.querySelector(".familyAngleForm");
    this.inputs = this.form.querySelectorAll("input");
    this.firstInput = this.form.querySelector("input");
    this.submitButton = this.form.querySelector("button");
    this.section = nodes.footer.querySelector("section.familyAngle");
    this.highlightBox = this.section.querySelector(".highlightBox");
    this.disabled = !1;
    this.recaptchaID = grecaptcha.render(
      this.form.querySelector(".recaptcha").sourceNode,
      {
        sitekey: "6LeGWzoUAAAAAAfwJhyQ-0dcCY3i6Jslh70LkpDY",
        size: "invisible",
        badge: "inline",
        callback: function () {
          return new Promise(function (b, c) {
            return a.recaptchaExecutor(b, c);
          });
        },
      }
    );
    this.form.addEventListener("submit", function (b) {
      return a.submit(b);
    });
    for (
      var b = $jscomp.makeIterator(
          nodes.body.querySelectorAll(".headerButton.subscribe")
        ),
        c = b.next();
      !c.done;
      c = b.next()
    ) {
      c.value.addEventListener("click", function (b) {
        return a.subscribeButtonClick(b);
      });
    }
  },
  submit: function (a) {
    a.preventDefault();
    this.disabled ||
      (grecaptcha.execute(this.recaptchaID),
      this.form.addClass("submitting"),
      this.submitButton
        .empty()
        .append(
          (this.submitButtonIcon = new node(
            "span",
            "fa fa-circle-o-notch fa-spin"
          )),
          (this.submitButtonText = document.createTextNode("\u2002Submitting"))
        ));
  },
  recaptchaExecutor: function (a, b) {
    for (
      var c = this,
        d = {
          contact: {},
          recaptchaResponse: grecaptcha.getResponse(this.recaptchaID),
        },
        e = $jscomp.makeIterator(this.inputs),
        f = e.next();
      !f.done;
      f = e.next()
    ) {
      if (((f = f.value), f.required() || "" != f.value())) {
        d.contact[f.name()] = f.value();
      }
    }
    new AJAX().post("/script/familyAngleSignUp.php", d, {
      success: function (d) {
        return c.signUpSuccess(d, a, b);
      },
    });
  },
  signUpSuccess: function (a, b, c) {
    this.form.removeClass("submitting");
    if (a.success) {
      this.disabled = !0;
      a = $jscomp.makeIterator(this.inputs);
      for (c = a.next(); !c.done; c = a.next()) {
        c.value.disabled(!0);
      }
      this.submitButton.disabled(!0);
      this.submitButtonIcon
        .removeClass("fa-circle-o-notch fa-spin")
        .addClass("fa-check");
      this.submitButtonText.textContent = "\u2002Thank you";
      b();
    } else {
      "reCAPTCHA" == a.failType ? c() : b();
    }
  },
  subscribeButtonClick: function (a) {
    a.preventDefault();
    nav.sideNavClose();
    window.scrollTo(0, this.section.offset().top - nav.height - 20);
    this.firstInput.focus();
    this.highlightBox.pulse("show", "background-color");
  },
};
var familyAngleForm = new FamilyAngleForm();
function recaptchaLoad() {
  familyAngleForm.recaptchaLoad();
}
window.recaptchaLoad = recaptchaLoad;
function RightPane(a) {
  var b = this;
  this.node = a;
  this.mainContent = node.querySelector(".layoutRow.main");
  this.position = "top";
  this.resizeCheck();
  eventTargets.window
    .addEventListener("scroll.rightPane", function () {
      return b.scrollCheck();
    })
    .addEventListener("resize.rightPane", function () {
      return b.resizeCheck();
    });
}
RightPane.prototype = {
  constructor: RightPane,
  verticalPadding: 60,
  scrollCheck: function () {
    this.fixed
      ? this.setPosition("top")
      : windowScrollTop() > this.maxScroll
      ? this.setPosition("bottom")
      : windowScrollTop() > this.mainNavOffset
      ? this.setPosition("fixed")
      : this.setPosition("top");
  },
  setPosition: function (a) {
    if (this.position != a) {
      switch (((this.position = a), a)) {
        case "top":
          this.node.removeClass("bottom fixed");
          break;
        case "bottom":
          this.node.removeClass("fixed").addClass("bottom");
          break;
        case "fixed":
          this.node.removeClass("bottom").addClass("fixed");
      }
    }
  },
  resizeCheck: function () {
    var a = this.node.clientHeight() + this.verticalPadding;
    this.fixed =
      windowInnerHeight() < nav.height + a ||
      a >= this.mainContent.clientHeight();
    this.mainNavOffset = this.mainContent.offset().top - nav.height;
    this.maxScroll =
      document.body.clientHeight - nodes.footer.clientHeight() - a - nav.height;
    this.scrollCheck();
  },
};
var rightPane;
domReady.add(function () {
  var a = node.querySelector(".rightPane");
  !1 !== a && (rightPane = new RightPane(a));
});
function Gallery(a, b, c) {
  var d = this;
  this.items = a;
  this.figure = b;
  this.resolutions = c;
  this.i = 0;
  this.controlsVisible = this.captionVisible = this.zeroIsTop = !0;
  this.imageCount = this.items.length;
  this.images = {};
  this.dimensions = {};
  this.aspectRatio = {};
  this.isTile = this.figure.hasClass("tile");
  this.figureInner = this.figure.firstChild();
  this.imageContainer0 = this.figure.querySelector(".galleryImageContainer0");
  this.imageContainer1 = this.figure.querySelector(".galleryImageContainer1");
  this.image0 = this.imageContainer0.querySelector("img");
  this.image1 = this.imageContainer1.querySelector("img");
  this.caption = this.figure.querySelector(".galleryCaption");
  this.h2 = this.caption.prependNode("h2", null, this.currentItem().name);
  this.figcaption = this.caption.querySelector("figcaption");
  this.textDiv = this.caption.appendNode("div", "text");
  this.textDiv.innerHTML(this.currentItem().text);
  this.controls = this.figure.querySelector(".galleryControls");
  this.indexP = this.controls.querySelector("p");
  this.indexSpan = this.indexP.querySelector(".imageNumber");
  this.indexP.querySelector(".imageCount").textContent(this.imageCount);
  this.fullscreenButton = this.controls.querySelector(".fullscreenToggle");
  this.navButtons = {
    previous: this.controls.querySelector(".previous"),
    next: this.controls.querySelector(".next"),
  };
  this.captionButton = this.controls.querySelector(".toggleCaption");
  this.figureHammer = new Hammer(this.figure.sourceNode);
  this.resolutionIndex = session.resolutionIndex;
  this.checkDimensions();
  this.figure.addEventListener("click", function (a) {
    return d.figureClick(a);
  });
  this.fullscreenButton.addEventListener("click", function (a) {
    return d.fullscreenButtonClick(a);
  });
  this.navButtons.previous.addEventListener("click", function (a) {
    return d.navButtonClick(d, a, !1);
  });
  this.navButtons.next.addEventListener("click", function (a) {
    return d.navButtonClick(d, a, !0);
  });
  this.captionButton.addEventListener("click", function () {
    return d.captionButtonClick();
  });
  eventTargets.window.addEventListener("resize.gallery", function () {
    return d.resizeCheck();
  });
  this.indexP.addTransitionListener(
    function () {
      return d.indexPTransitionComplete();
    },
    "top",
    "0px"
  );
}
Gallery.prototype = {
  constructor: Gallery,
  folderPath: "/files/the-other-faces-of-addiction/",
  pagePath: "/about-us/the-other-faces-of-addiction/",
  nextIndex: function () {
    return (this.i + 1) % this.imageCount;
  },
  previousIndex: function () {
    return (this.i - 1).mod(this.imageCount);
  },
  currentItem: function () {
    return this.items[this.i];
  },
  getItem: function (a) {
    return this.items[a.mod(this.imageCount)];
  },
  switchTop: function () {
    this.zeroIsTop = !this.zeroIsTop;
  },
  imageContainerTop: function () {
    return this.zeroIsTop ? this.imageContainer0 : this.imageContainer1;
  },
  imageContainerBottom: function () {
    return this.zeroIsTop ? this.imageContainer1 : this.imageContainer0;
  },
  imageTop: function () {
    return this.zeroIsTop ? this.image0 : this.image1;
  },
  imageBottom: function () {
    return this.zeroIsTop ? this.image1 : this.image0;
  },
  path: function (a) {
    void 0 === a && (a = this.i);
    return this.galleryPath + this.filename(a);
  },
  filename: function (a) {
    void 0 === a && (a = this.i);
    return this.items[a].path + ".jpeg";
  },
  keydown: function (a) {
    switch (a.key) {
      case "Escape":
      case "Esc":
        this.fullscreenOff();
        break;
      case "PageUp":
      case "PageDown":
      case "End":
      case "Home":
      case "ArrowUp":
      case "Up":
      case "ArrowDown":
      case "Down":
        this.caption.focus();
        break;
      case "ArrowLeft":
      case "Left":
      case "ArrowRight":
      case "Right":
        a = "ArrowRight" == a.key;
        (a ? this.navButtons.next : this.navButtons.previous).pulse("pulse");
        this.changeGallery(a);
        break;
      case "i":
        this.captionButton.pulse("pulse"), this.captionToggle();
    }
  },
  navButtonClick: function (a, b, c) {
    b.preventDefault();
    this.changeGallery(c);
    a.blur();
  },
  figureSwipe: function (a) {
    this.changeGallery(a);
  },
  changeGallery: function (a) {
    this.set((this.i + (a ? 1 : -1)).mod(this.imageCount), a);
  },
  set: function (a, b) {
    this.i = a;
    Modernizr.history &&
      this.fullscreenActive &&
      history.replaceState(
        {},
        "",
        this.pagePath + this.currentItem().pathLower
      );
    this.navButtons.previous.setAttribute(
      "href",
      this.pagePath + this.getItem(this.i - 1).pathLower
    );
    this.navButtons.next.setAttribute(
      "href",
      this.pagePath + this.getItem(this.i + 1).pathLower
    );
    this.imageChange();
    this.setImageSize(this.imageBottom());
    this.caption.scrollTop(0);
    this.caption.toggleClass("alternate");
    this.textChange();
    void 0 === b
      ? (this.imageContainerTop().addClass("transparent"),
        this.imageContainerBottom().removeClass("transparent"))
      : ((a = b ? "left" : "right"),
        (b = b ? "right" : "left"),
        this.imageContainerBottom().toggleTransition(!1),
        this.imageContainerBottom().removeClass(a).addClass(b),
        this.imageContainerBottom().toggleTransition(!0),
        this.imageContainerTop().addClass("transparent " + a),
        this.imageContainerBottom().removeClass("transparent " + b));
    this.switchTop();
    this.preload();
  },
  preload: function () {
    void 0 === this.images[this.resolutionIndex] &&
      (this.images[this.resolutionIndex] = {});
    this.preloadItem(this.i);
    this.preloadItem(this.nextIndex());
    this.preloadItem(this.previousIndex());
  },
  preloadItem: function (a) {
    var b = this.images[this.resolutionIndex];
    if (void 0 !== b[a]) {
      a == this.i && this.resizeImageTop();
    } else {
      b[a] = new Image();
      b[a].dataset.i = a;
      b[a].dataset.loaded = "false";
      var c = this;
      b[a].onload = function () {
        this.dataset.loaded = "true";
        this.dataset.i == c.i && c.resizeImageTop();
      };
      b[a].src = this.path(a);
    }
  },
  resizeImageTop: function () {
    var a = this.path();
    this.imageTop().getAttribute("src") != a &&
      void 0 !== this.images[this.resolutionIndex] &&
      void 0 !== this.images[this.resolutionIndex][this.i] &&
      "true" == this.images[this.resolutionIndex][this.i].dataset.loaded &&
      this.imageTop().src(a);
  },
  imageChange: function (a) {
    void 0 === a && (a = this.i);
    this.imageBottom().src(this.path(a));
  },
  textChange: function () {
    var a = this.currentItem();
    this.h2.textContent(a.name);
    this.figcaption.textContent("\u201c" + a.snippet + "\u201d");
    this.textDiv.innerHTML(a.text);
    this.indexSpan.textContent(this.i + 1);
  },
  setImageSize: function (a, b) {
    void 0 === b && (b = this.i);
    if (this.items[b].aspectRatio <= this.aspectRatio.window) {
      b = "auto";
      var c = "100%";
    } else {
      (b = "100%"), (c = "auto");
    }
    a.style.width = b;
    a.style.height = c;
  },
  captionButtonClick: function () {
    this.captionToggle();
  },
  captionToggle: function () {
    this.fullscreenActive &&
      (this.controlsVisible
        ? (this.caption.toggleClass("hidden"),
          (this.captionVisible = !this.captionVisible))
        : (this.caption.removeClass("hidden"),
          (this.captionVisible = !0),
          this.controlsToggle()));
  },
  fullscreenActive: !1,
  figureClick: function (a) {
    this.fullscreenActive ? this.controlsToggle(a) : this.fullscreenOn();
  },
  fullscreenButtonClick: function (a) {
    a.preventDefault();
    a.stopPropagation();
    this.fullscreenToggle();
    this.fullscreenButton.blur();
  },
  fullscreenOn: function () {
    this.fullscreenActive || this.fullscreenToggle();
  },
  fullscreenOff: function () {
    this.fullscreenActive && this.fullscreenToggle();
  },
  fullscreenToggle: function () {
    var a = this;
    this.fullscreenActive = !this.fullscreenActive;
    nodes.body.toggleClass("noScroll");
    this.figure.toggleClass("fullscreen");
    this.isTile && this.figure.toggleClass("tile tileFull");
    this.fullscreenButton.toggleClass("fa-expand fa-times-circle");
    this.fullscreenActive
      ? ((this.galleryPath =
          this.folderPath +
          this.resolutions[this.resolutionIndex].width +
          "x" +
          this.resolutions[this.resolutionIndex].height +
          "/"),
        this.setImageSize(this.imageTop()),
        this.preload(),
        this.imageContainerBottom().addClassNoTransition("transparent right"),
        this.fullscreenButton.setAttribute("title", "exit fullscreen [esc]"),
        eventTargets.document.addEventListener("keydown.gallery", function (b) {
          return a.keydown(b);
        }),
        this.figureHammer.on("swiperight", function () {
          return a.figureSwipe(!1);
        }),
        this.figureHammer.on("swipeleft", function () {
          return a.figureSwipe(!0);
        }),
        Modernizr.history &&
          history.pushState(
            {},
            "",
            this.pagePath + this.currentItem().pathLower
          ))
      : ((this.galleryPath =
          this.folderPath +
          this.figure.dataset.width +
          "x" +
          this.figure.dataset.height +
          "/"),
        this.imageTop().src(this.path()),
        this.imageContainer0.removeClassNoTransition("left right transparent"),
        this.imageContainer1.removeClassNoTransition("left right transparent"),
        this.zeroIsTop ||
          this.imageContainer0.addClassNoTransition("transparent"),
        this.fullscreenButton.setAttribute("title", "fullscreen"),
        eventTargets.document.removeEventListener("keydown.gallery"),
        this.figureHammer.off("swiperight"),
        this.figureHammer.off("swipeleft"),
        this.resizeCheck(),
        this.figure.removeClass("controlsHidden"),
        (this.controlsVisible = !0),
        Modernizr.history && history.back());
  },
  controlsToggle: function (a) {
    if (
      void 0 === a ||
      (!this.controls.containsOrIsSameNode(a.target) &&
        !this.caption.containsOrIsSameNode(a.target))
    ) {
      this.figure.changeClass("controlsHidden", this.controlsVisible),
        this.controlsVisible || this.indexP.addClass("controlsReturning"),
        (this.controlsVisible = !this.controlsVisible);
    }
  },
  indexPTransitionComplete: function () {
    this.indexP.removeClass("controlsReturning");
  },
  checkDimensions: function () {
    var a =
      void 0 !== this.dimensions.window
        ? this.dimensions.window.width
        : session.windowWidth;
    this.fullscreenActive ||
      (this.dimensions.figure = {
        width: this.figureInner.clientWidth(),
        height: this.figureInner.clientHeight(),
      });
    this.dimensions.window = {
      width: windowInnerWidth(),
      height: windowInnerHeight(),
    };
    this.aspectRatio.window =
      (this.dimensions.window.width - 40) /
      (this.dimensions.window.height - 40);
    var b = {};
    this.dimensions.window.width != a &&
      (b.windowWidth = this.dimensions.window.width);
    a = $jscomp.makeIterator(this.resolutions.entries());
    for (var c = a.next(); !c.done; c = a.next()) {
      var d = $jscomp.makeIterator(c.value),
        e = d.next().value;
      d = d.next().value;
      if (
        this.dimensions.window.width <= d.width &&
        this.dimensions.window.height <= d.height
      ) {
        break;
      }
    }
    e != this.resolutionIndex &&
      ((this.resolutionIndex = e), (b.resolutionIndex = e));
    this.fullscreenActive
      ? ((this.galleryPath = this.folderPath + d.width + "x" + d.height + "/"),
        this.preload())
      : (this.galleryPath =
          this.folderPath +
          this.figure.dataset.width +
          "x" +
          this.figure.dataset.height +
          "/");
    0 < size(b) &&
      (clearTimeout(this.checkDimensionsSessionUpdateTimer),
      (this.checkDimensionsSessionUpdateTimer = setTimeout(function () {
        return sessionVal(b);
      }, 200)));
  },
  resizeCheck: function () {
    this.checkDimensions();
    this.setImageSize(this.imageTop());
  },
};
function Slideshow(a, b, c) {
  var d = this;
  for (
    Slideshow.parent.constructor.apply(this, arguments);
    !this.currentItem().slideshow;

  ) {
    this.i++;
  }
  this.running = !1;
  this.textChange();
  this.timers = new Map();
  this.figure.removeClass("stopped");
  this.setImagePosition(this.imageTop(), this.i);
  this.start();
  eventTargets.window
    .addEventListener("resize.slideshow", function () {
      return d.checkImagePositions();
    })
    .addEventListener("visibilitychange.slideshow", function () {
      return d.windowVisibilityChange();
    });
}
extend(Slideshow, Gallery, {
  duration: { stay: 6000, fade: 1200 },
  nextIndex: function () {
    if (this.fullscreenActive) {
      var a = Slideshow.parent.nextIndex.call(this);
    } else {
      for (a = (this.i + 1) % this.imageCount; !this.items[a].slideshow; ) {
        a = (a + 1) % this.imageCount;
      }
    }
    return a;
  },
  previousIndex: function () {
    if (this.fullscreenActive) {
      var a = Slideshow.parent.previousIndex.call(this);
    } else {
      for (a = (this.i - 1).mod(this.imageCount); !this.items[a].slideshow; ) {
        a = (a - 1).mod(this.imageCount);
      }
    }
    return a;
  },
  start: function () {
    this.running ||
      ((this.running = !0),
      this.caption.toggleTransition(!0),
      this.changeSlideshow());
  },
  stop: function () {
    if (this.running) {
      this.running = !1;
      for (
        var a = $jscomp.makeIterator(this.timers.values()), b = a.next();
        !b.done;
        b = a.next()
      ) {
        clearTimeout(b.value);
      }
      this.caption.removeClassNoTransition("offset left right");
    }
  },
  fade: function () {
    var a = this;
    this.switchTop();
    this.i = this.nextIndex();
    Modernizr.csstransitions &&
      (this.imageContainer0.toggleClass("transparent"),
      this.caption.addClass("offset left"),
      this.timers.set(
        "captionArrive",
        setTimeout(function () {
          return a.captionArrive();
        }, this.duration.fade / 2 + 100)
      ),
      this.timers.set(
        "changeSlideshow",
        setTimeout(function () {
          return a.changeSlideshow();
        }, this.duration.fade + 100)
      ));
    this.timers.set(
      "textChange",
      setTimeout(function () {
        return a.textChange();
      }, this.duration.fade / 2)
    );
  },
  imagePosition: function (a) {
    var b = {};
    a.aspectRatio <= this.aspectRatio.figure
      ? ((b.top =
          Math.max(
            Math.min(
              100 *
                (0.5 - (this.aspectRatio.figure / a.aspectRatio) * a.focusTop),
              0
            ),
            100 * (1 - this.aspectRatio.figure / a.aspectRatio)
          ) + "%"),
        (b.left = 0),
        (b.width = "100%"),
        (b.height = "auto"))
      : ((b.top = 0),
        (b.left =
          Math.min(
            Math.max(
              100 *
                (0.5 - (a.aspectRatio / this.aspectRatio.figure) * a.focusLeft),
              0
            ),
            100 * (1 - a.aspectRatio / this.aspectRatio.figure)
          ) + "%"),
        (b.width = "auto"),
        (b.height = "100%"));
    return b;
  },
  setImagePosition: function (a, b) {
    b = this.imagePosition(this.items[b]);
    a.style.top = b.top;
    a.style.left = b.left;
    this.fullscreenActive ||
      ((a.style.width = b.width), (a.style.height = b.height));
  },
  changeSlideshow: function () {
    var a = this,
      b = this.nextIndex();
    this.imageChange(b);
    this.setImagePosition(this.imageBottom(), b);
    this.timers.set(
      "fade",
      setTimeout(function () {
        return a.fade();
      }, this.duration.stay)
    );
  },
  changeGallery: function (a) {
    this.fullscreenActive &&
      Slideshow.parent.changeGallery.apply(this, arguments);
  },
  set: function (a, b) {
    this.fullscreenActive && Slideshow.parent.set.apply(this, arguments);
  },
  captionArrive: function () {
    this.caption.toggleClassNoTransition("left right");
    this.caption.removeClass("offset right");
  },
  fullscreenToggle: function () {
    Slideshow.parent.fullscreenToggle.call(this);
    this.fullscreenActive
      ? this.stop()
      : (this.setImagePosition(this.imageTop(), this.i), this.start());
  },
  checkDimensions: function () {
    Slideshow.parent.checkDimensions.call(this);
    this.aspectRatio.figure =
      this.dimensions.figure.width / this.dimensions.figure.height;
  },
  checkImagePositions: function () {
    this.setImagePosition(this.imageTop(), this.i);
    this.setImagePosition(this.imageBottom(), this.nextIndex());
  },
  windowVisibilityChange: function () {
    this.fullscreenActive || (document.hidden ? this.stop() : this.start());
  },
});
function initGallery() {
  domReady.add(function () {
    "home" == page.path
      ? new Slideshow(
          portraits,
          node.querySelector("figure.gallery.slideshow"),
          resolutions
        )
      : "the-other-faces-of-addiction" == page.path &&
        new PortraitsList(portraits, window.portraitPath);
  });
}
window.initGallery = initGallery;
function Carousel(a) {
  var b = this;
  this.container = a;
  this.i = 0;
  this.mover = this.container.firstChild();
  this.itemCount = this.mover.childElementCount();
  this.width = this.container.clientWidth();
  this.container
    .addEventListener("mouseenter", function () {
      return b.mouseenter();
    })
    .addEventListener("mouseleave", function () {
      return b.mouseleave();
    });
  eventTargets.window
    .addEventListener("resize.carousel", function () {
      return b.windowResizeInitiate();
    })
    .addEventListener("visibilitychange.carousel", function () {
      return b.windowVisibilityChange();
    });
  this.start();
}
Carousel.prototype = {
  constructor: Carousel,
  duration: 5000,
  nextIndex: function () {
    return (this.i + 1) % this.itemCount;
  },
  start: function () {
    var a = this;
    void 0 === this.timer &&
      (this.timer = setInterval(function () {
        return a.change();
      }, this.duration));
  },
  stop: function () {
    clearInterval(this.timer);
    delete this.timer;
  },
  change: function () {
    this.i = this.nextIndex();
    this.mover.style.left = this.width * this.i * -1 + "px";
  },
  mouseenter: function () {
    this.stop();
  },
  mouseleave: function () {
    this.start();
  },
  windowResizeInitiate: function () {
    var a = this;
    clearInterval(this.timerWindowResize);
    this.timerWindowResize = setInterval(function () {
      return a.windowResize();
    }, 100);
  },
  windowResize: function () {
    this.width = this.container.clientWidth();
    this.mover.style.left = this.width * this.i * -1;
  },
  windowVisibilityChange: function () {
    document.hidden ? this.stop() : this.start();
  },
};
function TileMapSearch(a) {
  var b = this;
  this.tile = a;
  this.input = this.tile.querySelector("input");
  this.tile.querySelector(".tileBlock").addEventListener("click", function (a) {
    return b.click(a);
  });
  this.input.addEventListener("keydown", function (a) {
    return b.keydown(a);
  });
  this.input.addEventListener("focus", function () {
    return b.focus();
  });
  this.input.addEventListener("blur", function () {
    return b.blur();
  });
}
TileMapSearch.prototype = {
  constructor: TileMapSearch,
  click: function (a) {
    "INPUT" != a.target.nodeName &&
      "LABEL" != a.target.nodeName &&
      this.input.focus();
  },
  keydown: function (a) {
    ("Escape" != a.key && "Esc" != a.key) || this.input.blur();
  },
  focus: function () {
    this.tile.addClass("tileFocussed");
  },
  blur: function () {
    this.tile.removeClass("tileFocussed");
  },
};
function TileForum(a) {
  var b = this;
  this.tileDefault = a.querySelector(".tileDefault");
  this.timeNode = a.querySelector("time");
  a = $jscomp.makeIterator(this.tileDefault.querySelectorAll("a"));
  for (var c = a.next(); !c.done; c = a.next()) {
    c.value
      .addEventListener("mouseenter", function () {
        return b.linkMouseEnter();
      })
      .addEventListener("mouseleave", function () {
        return b.linkMouseLeave();
      });
  }
  this.date = new Date(this.timeNode.dateTime());
  this.dateText =
    this.date.getDate() + "&nbsp;" + this.date.getMonthNameShort();
  a = new Date();
  if (
    this.date.getFullYear() < a.getFullYear() - 1 ||
    (this.date.getFullYear() == a.getFullYear() - 1 &&
      this.date.getMonth() <= a.getMonth())
  ) {
    this.dateText += "&nbsp;" + this.date.getFullYear();
  }
  this.intervalTimer = setInterval(function () {
    return b.updateInterval();
  }, 10000);
  this.updateInterval();
}
TileForum.prototype = {
  constructor: TileForum,
  linkMouseEnter: function () {
    this.tileDefault.addClass("childLinkHover");
  },
  linkMouseLeave: function () {
    this.tileDefault.removeClass("childLinkHover");
  },
  updateInterval: function () {
    var a = interval(this.date);
    "date" == a.unit
      ? ((a = this.dateText), clearInterval(this.intervalTimer))
      : (a = a.time + a.unit);
    this.timeNode.innerHTML(a);
  },
};
function TileNews(a) {
  0 < a.querySelector(".carouselTile:nth-child(2) > ol").childElementCount() &&
    TileNews.parent.constructor.apply(this, arguments);
}
extend(TileNews, Carousel);
function TwitterFeed(a) {
  var b = this;
  this.tweets = [];
  a = $jscomp.makeIterator(a.children);
  for (var c = a.next(); !c.done; c = a.next()) {
    this.tweets.push(new TwitterFeedTweet(new node(c.value)));
  }
  setInterval(function () {
    return b.updateIntervals();
  }, 10000);
  this.updateIntervals();
}
TwitterFeed.prototype = {
  constructor: TwitterFeed,
  updateIntervals: function () {
    for (
      var a = new Date(), b = $jscomp.makeIterator(this.tweets), c = b.next();
      !c.done;
      c = b.next()
    ) {
      c.value.updateInterval(a);
    }
  },
};
function TwitterFeedTweet(a) {
  a = a.querySelector("time");
  this.timeLink = a.firstElementChild();
  this.date = new Date(a.dateTime());
  this.dateText =
    this.date.getDate() + "&nbsp;" + this.date.getMonthNameShort();
}
TwitterFeedTweet.prototype = {
  constructor: TwitterFeedTweet,
  intervals: { minute: 60, hour: 3600, day: 86400 },
  updateInterval: function (a) {
    a = interval(this.date, a);
    this.timeLink.innerHTML("date" == a.unit ? this.dateText : a.time + a.unit);
  },
};
domReady.add(function () {
  if ("home" == page.path) {
    for (
      var a = $jscomp.makeIterator([
          { selector: ".newsCarousel", constructor: TileNews },
          { selector: ".tileMapSearch", constructor: TileMapSearch },
          { selector: ".tileForum", constructor: TileForum },
          { selector: ".tileTwitter .tweets", constructor: TwitterFeed },
        ]),
        b = a.next();
      !b.done;
      b = a.next()
    ) {
      b = b.value;
      var c = node.querySelector(b.selector);
      !1 !== c && new b.constructor(c);
    }
  }
});
function TaggedItemList(a, b) {
  var c = this;
  a = node.querySelector(a);
  this.itemsContainer = a.querySelector(".listItems");
  this.items = [];
  for (
    var d = $jscomp.makeIterator(b.items), e = d.next();
    !e.done;
    e = d.next()
  ) {
    (e = e.value),
      this.items.push(
        new TaggedItemListItem(
          this.itemsContainer.querySelector(
            '.listItem[data-id="' + e.id + '"]'
          ),
          e.tags,
          e.id === b.parameters.resourceID
        )
      );
  }
  this.tags = [];
  d = $jscomp.makeIterator(b.tags);
  for (e = d.next(); !e.done; e = d.next()) {
    (e = e.value),
      this.tags.push(
        new TaggedItemListTag(
          this,
          e,
          a.querySelector('.toggle[data-id="' + e + '"]')
        )
      );
  }
  a = a.querySelector(".toggle.all");
  this.toggleAllInput = a.firstChild();
  this.activeTagIDs = new Set();
  void 0 !== b.parameters.tagID && this.activeTagIDs.add(b.parameters.tagID);
  this.noResults = new node(
    "p",
    null,
    "There are no resources matching all of the selected topics. Try deselecting some of them, or click \u2018All\u2019 to clear your selection."
  );
  this.noResultsAppended = !1;
  a.addEventListener("keydown", function (a) {
    return c.toggleAllKeydown(a);
  });
  this.toggleAllInput.addEventListener("change", function () {
    return c.toggleAllChange();
  });
}
TaggedItemList.prototype = {
  constructor: TaggedItemList,
  tagChange: function (a, b) {
    b ? this.activeTagIDs.add(a) : this.activeTagIDs.delete(a);
    this.toggleAllInput.checked(0 == this.activeTagIDs.size);
    this.checkTags();
    rightPane.resizeCheck();
  },
  toggleAllKeydown: function (a) {
    switch (a.key) {
      case " ":
      case "Spacebar":
      case "Enter":
        a.preventDefault(),
          this.toggleAllInput.checked() ||
            (this.toggleAllInput.checked(!0), this.toggleAllChange());
    }
  },
  toggleAllChange: function () {
    if (this.toggleAllInput.checked()) {
      this.activeTagIDs.clear();
      for (
        var a = $jscomp.makeIterator(this.tags), b = a.next();
        !b.done;
        b = a.next()
      ) {
        b.value.uncheck();
      }
      a = $jscomp.makeIterator(this.items);
      for (b = a.next(); !b.done; b = a.next()) {
        b.value.show();
      }
      rightPane.resizeCheck();
    } else {
      this.toggleAllInput.checked(!0);
    }
  },
  checkTags: function () {
    for (
      var a = !1, b = $jscomp.makeIterator(this.items), c = b.next();
      !c.done;
      c = b.next()
    ) {
      c.value.checkTags(this.activeTagIDs) && (a = !0);
    }
    a
      ? this.noResultsAppended &&
        ((this.noResultsAppended = !1),
        this.itemsContainer.removeChild(this.noResults))
      : ((this.noResultsAppended = !0),
        this.itemsContainer.appendChild(this.noResults));
  },
};
function TaggedItemListItem(a, b, c) {
  this.node = a;
  this.tags = b;
  this.visible = !this.node.hasClass("hidden");
  c && this.highlight();
}
TaggedItemListItem.prototype = {
  constructor: TaggedItemListItem,
  checkTags: function (a) {
    var b = !0;
    a = $jscomp.makeIterator(a);
    for (var c = a.next(); !c.done; c = a.next()) {
      if (!this.tags.includes(c.value)) {
        b = !1;
        break;
      }
    }
    this.changeVisibility(b);
    return b;
  },
  changeVisibility: function (a) {
    this.visible = a;
    this.node.changeClass("hidden", !a);
  },
  show: function () {
    this.changeVisibility(!0);
  },
  highlight: function () {
    this.visible &&
      (window.scrollTo(0, this.node.offset().top - nav.height - 20),
      this.node.pulse("highlight"));
  },
};
function TaggedItemListTag(a, b, c) {
  var d = this;
  this.taggedItemList = a;
  this.id = b;
  this.label = c;
  this.input = c.firstChild();
  this.label.addEventListener("keydown", function (a) {
    return d.keydown(a);
  });
  this.input.addEventListener("change", function () {
    return d.change();
  });
}
TaggedItemListTag.prototype = {
  constructor: TaggedItemListTag,
  keydown: function (a) {
    switch (a.key) {
      case " ":
      case "Spacebar":
      case "Enter":
        a.preventDefault(),
          this.input.checked(!this.input.checked()),
          this.change();
    }
  },
  change: function () {
    var a = this.input.checked();
    this.taggedItemList.tagChange(this.id, a);
    a || this.label.blur();
  },
  uncheck: function () {
    this.input.checked(!1);
  },
};
domReady.add(function () {
  "resources" == page.path &&
    new TaggedItemList(".resourceLibrary", resourceLibrary);
});
function PortraitsList(a, b) {
  this.container = node.querySelector(".portraits");
  this.gallery = new Gallery(
    a,
    this.container.querySelector("figure.gallery"),
    resolutions
  );
  a = $jscomp.makeIterator(a.entries());
  for (var c = a.next(); !c.done; c = a.next()) {
    var d = $jscomp.makeIterator(c.value);
    c = d.next().value;
    d = d.next().value;
    new PortraitsListItem(this, c);
    void 0 !== b &&
      d.pathLower == b &&
      (Modernizr.history &&
        history.replaceState(
          {},
          "",
          location.pathname.match(/^(.*)\/[^/]+$/)[1]
        ),
      this.selectItem(c));
  }
}
PortraitsList.prototype = {
  constructor: PortraitsList,
  selectItem: function (a) {
    this.gallery.set(a);
    this.gallery.fullscreenOn();
  },
};
function PortraitsListItem(a, b) {
  var c = this;
  this.portraitsList = a;
  this.i = b;
  a.container
    .querySelector('.listItem[data-index="' + b + '"]')
    .addEventListener("click", function (a) {
      return c.click(a);
    });
}
PortraitsListItem.prototype = {
  constructor: PortraitsListItem,
  click: function (a) {
    a.stopPropagation();
    a.preventDefault();
    this.portraitsList.selectItem(this.i);
  },
};
function DirectoryMap(a, b, c) {
  var d = this;
  this.urlSearch = "string" == typeof directoryMapSearch;
  var e = "number" == typeof directoryMapServiceID;
  this.canvasNode = b;
  this.narrowMode = !1;
  this.zoomFactor = 250;
  this.hasFocus = this.urlSearch || e;
  void 0 === c &&
    (c = {
      center: new google.maps.LatLng(53.9, -1.8),
      mapTypeControlOptions: {
        position: google.maps.ControlPosition.TOP_RIGHT,
      },
      scrollwheel: !1,
      zoom: 6,
    });
  this.googleMap = new google.maps.Map(b.sourceNode, c);
  this.pathname = location.pathname;
  e && (this.pathname = this.pathname.match(/^(.+)\/\d+$/)[1]);
  this.createElements();
  this.initializePins();
  this.createGoogleObjects();
  this.directory = new Map();
  a = $jscomp.makeIterator(a);
  for (b = a.next(); !b.done; b = a.next()) {
    (b = b.value), this.directory.set(b.id, new DirectoryMapService(this, b));
  }
  this.initialIdle = !1;
  this.googleMap.addListener("idle", function () {
    return (d.initialIdle = !0);
  });
  eventTargets.document
    .addEventListener("mousedown.map", function (a) {
      return d.documentMousedown(a);
    })
    .addEventListener("keydown.map", function (a) {
      return d.documentKeydown(a);
    });
  eventTargets.window.addEventListener("resize.map", function () {
    return d.resize();
  });
  this.resize();
  this.urlSearch
    ? (this.searchForm.search(decodeURI(directoryMapSearch)),
      e && (this.deferredSearchResultID = directoryMapServiceID))
    : e &&
      this.googleMap.addListener("projection_changed", function () {
        return d.deferredServiceSelect(directoryMapServiceID);
      });
}
DirectoryMap.prototype = {
  constructor: DirectoryMap,
  colours: {
    brightBlue: { fill: "#0086CA", stroke: "#00537E" },
    lightBlue: { fill: "#BEE3EE", stroke: "#6DC0D9" },
    darkNavy: "#183264",
    red: { fill: "#F7685C", stroke: "#B83B32" },
    sunYellow: { fill: "#FBB800", stroke: "#BE8B00" },
  },
  pin: {
    path: "M0-3.24C-.524-3.24-.948-2.815-.948-2.291c0 .011 0 .023.001 .034.004 .1.022 .195.054 .285C-.691-1.307 0-.44 0-.44s.691-.867.893-1.533c.032-.09.051-.185.054-.285.001-.012.001-.023.001-.034C.948-2.815.524-3.24 0-3.24z",
  },
  maxSearchDistance: 10000,
  createElements: function () {
    this.searchForm = new DirectoryMapSearchForm(this);
    this.leftPane = new DirectoryMapLeftPane(this);
    this.searchErrorMessage = new node("div", "mapError").append(
      new node("div", "fa fa-exclamation-triangle"),
      new node(
        "p",
        null,
        "Sorry, that search term didn't work. Please try a valid UK address, such as a town name or postcode."
      )
    );
    this.googleMap.controls[google.maps.ControlPosition.LEFT_TOP].push(
      this.searchForm.sourceNode
    );
    this.googleMap.controls[google.maps.ControlPosition.LEFT_TOP].push(
      this.leftPane.sourceNode
    );
  },
  initializePins: function () {
    var a = new google.maps.Point(0, -2.3),
      b = new google.maps.Point(0, -2.2),
      c = { fillOpacity: 1, path: this.pin.path, scale: 10, strokeWeight: 1.5 };
    this.icons = {
      normal: {
        fillColor: this.colours.red.fill,
        labelOrigin: a,
        strokeColor: this.colours.red.stroke,
      },
      searchResult: {
        fillColor: this.colours.lightBlue.fill,
        labelOrigin: b,
        strokeColor: this.colours.lightBlue.stroke,
      },
      searchResultEmphasise: {
        fillColor: this.colours.sunYellow.fill,
        labelOrigin: b,
        strokeColor: this.colours.sunYellow.stroke,
      },
      search: {
        fillColor: this.colours.sunYellow.fill,
        labelOrigin: a,
        strokeColor: this.colours.sunYellow.stroke,
      },
    };
    for (var d in this.icons) {
      this.icons.hasOwnProperty(d) && merge(this.icons[d], c);
    }
    this.labels = {
      normal: {
        color: this.colours.red.stroke,
        fontSize: "26px",
        text: "\u2022",
      },
      selected: {
        color: this.colours.lightBlue.stroke,
        fontSize: "26px",
        text: "\u2022",
      },
      searchResult: { color: this.colours.darkNavy },
      search: {
        color: this.colours.darkNavy,
        fontFamily: "FontAwesome",
        fontSize: "13px",
        text: "\uf002",
      },
    };
  },
  createGoogleObjects: function () {
    this.geocoder = new google.maps.Geocoder();
    this.searchMarker = new google.maps.Marker({
      icon: this.icons.search,
      label: this.labels.search,
      map: this.googleMap,
      position: new google.maps.LatLng(0, 0),
      zIndex: 10020,
      visible: !1,
    });
    this.searchBounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(49.85, -10.75),
      new google.maps.LatLng(61.0, 1.8)
    );
  },
  documentMousedown: function (a) {
    this.canvasNode.containsOrIsSameNode(a.target)
      ? this.toggleFocus(!0)
      : this.toggleFocus(!1);
  },
  documentKeydown: function (a) {
    ("Escape" != a.key && "Esc" != a.key) || this.toggleFocus(!1);
  },
  toggleFocus: function (a) {
    this.hasFocus != a &&
      ((this.hasFocus = a), this.toggleFullscreen(a), this.toggleScroll(a));
  },
  toggleFullscreen: function (a) {
    nodes.body.changeClass("fullscreenMap", a);
    this.canvasNode.changeClass("fullscreen", a);
    this.canvasHeight = this.canvasNode.offsetHeight();
  },
  toggleScroll: function (a) {
    this.googleMap.setOptions({
      gestureHandling: a && this.narrowMode ? "greedy" : "cooperative",
      scrollwheel: a,
    });
  },
  historyReplaceState: function (a) {
    Modernizr.history &&
      location.pathname + location.search != a &&
      history.replaceState({}, "", a);
  },
  search: function (a) {
    var b = this;
    this.urlSearch
      ? (this.urlSearch = !1)
      : this.historyReplaceState(this.pathname + "?s=" + encodeURI(a));
    this.geocoder.geocode(
      { address: a + ", UK", bounds: this.searchBounds, region: "uk" },
      function (c, d) {
        return b.geocodeComplete(c, d, a);
      }
    );
  },
  geocodeComplete: function (a, b, c) {
    b == google.maps.GeocoderStatus.OK
      ? this.searchSuccess(a[0].geometry.location, c)
      : this.searchError();
  },
  searchSuccess: function (a, b) {
    this.searchResultsReset();
    this.serviceDeselect();
    this.leftPane.searchResultDeselect();
    for (
      var c = $jscomp.makeIterator(this.directory.values()), d = c.next();
      !d.done;
      d = c.next()
    ) {
      d.value.computeDistance(a);
    }
    c = [].concat($jscomp.arrayFromIterable(this.directory.values()));
    c.sort(function (a, b) {
      return a.distance - b.distance;
    });
    this.searchResults = [];
    d = new node("ol");
    for (var e = 0; 10 > e; e++) {
      var f = c[e];
      if (2 < e && f.distance > this.maxSearchDistance) {
        break;
      }
      f.drawSearchResult(e);
      this.searchResults.push(f);
      d.appendChild(f.node);
    }
    this.searchMarker.setPosition(a);
    this.searchMarker.setVisible(!0);
    this.searchMarker.setTitle(b);
    this.googleMap.setZoom(
      Math.round(
        Math.log(
          (100000 * this.zoomFactor) /
            this.searchResults[this.searchResults.length - 1].distance
        ) / Math.log(2)
      )
    );
    this.leftPane.show(d);
    this.panTo(a);
    this.deferredSearchResultSelect();
  },
  searchError: function () {
    this.leftPane.show(this.searchErrorMessage);
  },
  searchResultsReset: function () {
    if (void 0 !== this.searchResults) {
      for (
        var a = $jscomp.makeIterator(this.searchResults), b = a.next();
        !b.done;
        b = a.next()
      ) {
        b.value.searchResultReset();
      }
      delete this.searchResults;
    }
  },
  searchReset: function () {
    this.leftPane.hide();
    this.searchMarker.setVisible(!1);
    this.searchResultsReset();
    this.historyReplaceState(this.pathname);
  },
  offsetLatLng: function (a) {
    a = this.googleMap.getProjection().fromLatLngToPoint(a);
    var b = new google.maps.Point(
      this.narrowMode ? 0 : -160 / Math.pow(2, this.googleMap.getZoom()),
      this.narrowMode
        ? (this.leftPane.height(this.canvasHeight) / 2 - 30) /
          Math.pow(2, this.googleMap.getZoom())
        : 0
    );
    return this.googleMap
      .getProjection()
      .fromPointToLatLng(new google.maps.Point(a.x + b.x, a.y + b.y));
  },
  panTo: function (a) {
    var b = this;
    this.initialIdle
      ? this.googleMap.panTo(this.offsetLatLng(a))
      : void 0 === this.idleListener &&
        (this.idleListener = this.googleMap.addListener("idle", function () {
          return b.deferredPanTo(a);
        }));
  },
  deferredPanTo: function (a) {
    this.idleListener.remove();
    this.initialIdle = !0;
    this.panTo(a);
  },
  serviceSelect: function (a) {
    this.searchForm.clear();
    this.searchMarker.setVisible(!1);
    this.searchResultsReset();
    this.serviceDeselect();
    this.selectedService = a;
    this.leftPane.serviceSelect(a.node);
    this.googleMap.setZoom(14);
    this.panTo(a.latLng);
    this.historyReplaceState(this.pathname + "/" + a.data.id);
  },
  deferredServiceSelect: function (a) {
    a = this.directory.get(a);
    void 0 !== a ? a.select() : this.historyReplaceState(this.pathname);
  },
  serviceDeselect: function () {
    void 0 !== this.selectedService && this.selectedService.deselect();
  },
  serviceClose: function () {
    this.leftPane.serviceDeselect();
    this.historyReplaceState(this.pathname);
  },
  searchResultSelect: function (a) {
    this.searchResultDeselect();
    this.selectedSearchResult = a;
    this.searchPath = this.pathname + location.search;
    this.leftPane.searchResultSelect(this.searchPath);
    this.panTo(a.latLng);
    this.historyReplaceState(this.pathname + "/" + a.data.id + location.search);
  },
  deferredSearchResultSelect: function () {
    if (void 0 !== this.deferredSearchResultID) {
      for (
        var a = !1, b = $jscomp.makeIterator(this.searchResults), c = b.next();
        !c.done;
        c = b.next()
      ) {
        if (((c = c.value), c.data.id == this.deferredSearchResultID)) {
          c.searchResultSelect();
          a = !0;
          break;
        }
      }
      a || this.historyReplaceState(this.pathname + location.search);
      delete this.deferredSearchResultID;
    }
  },
  searchResultDeselect: function () {
    void 0 !== this.selectedSearchResult &&
      (this.selectedSearchResult.searchResultDeselect(),
      delete this.selectedSearchResult,
      this.historyReplaceState(this.searchPath));
  },
  leftPaneShow: function () {
    this.canvasNode.addClass("leftPane");
  },
  leftPaneHide: function () {
    this.canvasNode.removeClass("leftPane");
  },
  resize: function () {
    var a = 657 >= windowInnerWidth();
    this.narrowMode != a &&
      ((this.narrowMode = a),
      (this.canvasHeight = this.canvasNode.offsetHeight()),
      (this.zoomFactor = this.narrowMode ? 100 : 250),
      this.googleMap.setOptions({
        gestureHandling:
          this.narrowMode && this.hasFocus ? "greedy" : "cooperative",
        mapTypeControl: !this.narrowMode,
        streetViewControl: !this.narrowMode,
        zoomControl: !this.narrowMode,
      }));
  },
};
function DirectoryMapSearchForm(a) {
  var b = this;
  this.map = a;
  this.container = new node("div", "mapSearchContainer").append(
    (this.form = new node("form", "mapSearch").append(
      new node("span", "fa fa-search"),
      (this.input = new node("input", {
        type: "text",
        placeholder: "Search this map",
      })),
      new node("input", { type: "reset", class: "fa", value: "\uf00d" })
    )),
    (this.fullscreenCloseButton = new node("button", {
      class: "closeFullscreen fa fa-times",
    }))
  );
  this.sourceNode = this.container.sourceNode;
  this.form
    .addEventListener("submit", function (a) {
      return b.submit(a);
    })
    .addEventListener("reset", function () {
      return b.reset();
    })
    .addEventListener("click", function () {
      return b.formClick();
    });
  this.fullscreenCloseButton.addEventListener("click", function () {
    return b.fullscreenCloseButtonClick();
  });
}
DirectoryMapSearchForm.prototype = {
  constructor: DirectoryMapSearchForm,
  search: function (a) {
    this.input.value(a);
    this.map.search(a);
    this.searchSubmitted();
  },
  submit: function (a) {
    a.preventDefault();
    a = this.input.value();
    "" != a
      ? (this.map.search(a),
        this.searchSubmitted(),
        this.map.narrowMode && this.input.blur())
      : this.reset();
  },
  clear: function () {
    this.input.value("");
    this.form.removeClass("submitted");
  },
  reset: function () {
    this.map.searchReset();
    this.form.removeClass("submitted");
  },
  formClick: function () {
    this.input.focus();
  },
  searchSubmitted: function () {
    this.form.addClass("submitted");
  },
  fullscreenCloseButtonClick: function () {
    this.map.toggleFullscreen(!1);
  },
};
function DirectoryMapLeftPane(a) {
  var b = this;
  this.map = a;
  this.hiddenNarrow = this.shown = !1;
  this.node = new node("div", "mapLeftPane empty transparent").append(
    (this.hideNarrowButton = new node(
      "button",
      "hideNarrow fa fa-chevron-down"
    )),
    (this.backToResults = new node("a", null, "back to search results")),
    (this.container = new node("div"))
  );
  this.sourceNode = this.node.sourceNode;
  this.node.addTransitionListener(
    function () {
      return b.hideTransitionComplete();
    },
    "opacity",
    "0"
  );
  this.hideNarrowButton.addEventListener("click", function () {
    return b.hideNarrowButtonClick();
  });
  this.backToResults.addEventListener("click", function (a) {
    return b.backToResultsClick(a);
  });
}
DirectoryMapLeftPane.prototype = {
  constructor: DirectoryMapLeftPane,
  show: function (a) {
    this.container.empty().appendChild(a);
    this.hiddenNarrowToggle(!1);
    this.shown ||
      ((this.shown = !0),
      this.node.removeClass("empty"),
      this.node.offsetHeight(),
      this.node.removeClass("transparent"),
      this.map.leftPaneShow());
  },
  hide: function () {
    this.shown &&
      ((this.shown = !1),
      this.node.addClass("transparent"),
      this.map.leftPaneHide());
  },
  hideTransitionComplete: function () {
    this.node.addClass("empty").removeClass("mapSelected mapSearchResult");
  },
  hideNarrowButtonClick: function () {
    this.hiddenNarrowToggle();
  },
  hiddenNarrowToggle: function (a) {
    void 0 === a && (a = !this.hiddenNarrow);
    this.hiddenNarrow != a &&
      ((this.hiddenNarrow = a),
      this.node.toggleClass("hiddenNarrow"),
      this.hideNarrowButton.toggleClass("fa-chevron-down fa-chevron-up"));
  },
  backToResultsClick: function (a) {
    a.preventDefault();
    this.searchResultDeselect();
  },
  height: function (a) {
    return a * (this.hiddenNarrow ? 0.15 : 0.5);
  },
  serviceSelect: function (a) {
    this.show(a);
    this.node.addClass("mapSelected").removeClass("mapSearchResult");
  },
  serviceDeselect: function () {
    this.node.removeClass("mapSelected");
    this.hide();
  },
  searchResultSelect: function (a) {
    this.backToResults.setAttribute("href", a);
    this.node.addClass("mapSelected mapSearchResult");
    this.hiddenNarrowToggle(!1);
  },
  searchResultDeselect: function () {
    this.node.removeClass("mapSelected mapSearchResult");
    this.map.searchResultDeselect();
  },
};
function initMap() {
  "search-for-local-support" == page.path &&
    domReady.add(function () {
      return new DirectoryMap(
        directory,
        new node(document.getElementById("mapCanvas"))
      );
    });
}
window.initMap = initMap;
function DirectoryMapService(a, b) {
  var c = this;
  this.map = a;
  this.data = b;
  this.state = "normal";
  this.latLng = new google.maps.LatLng(b.latitude, b.longitude);
  this.zIndex = this.statics.zIndex++;
  this.marker = new google.maps.Marker({
    icon: a.icons.normal,
    label: a.labels.normal,
    map: a.googleMap,
    position: this.latLng,
    title: b.name,
    zIndex: this.zIndex,
  });
  this.marker.addListener("click", function () {
    return c.markerClick();
  });
}
DirectoryMapService.prototype = {
  constructor: DirectoryMapService,
  statics: { zIndex: 1 },
  computeDistance: function (a) {
    this.distance = google.maps.geometry.spherical.computeDistanceBetween(
      a,
      this.latLng
    );
  },
  markerClick: function () {
    switch (this.state) {
      case "normal":
        this.select();
        break;
      case "searchResult":
        this.searchResultSelect();
    }
  },
  setSearchResultMarker: function (a) {
    var b = { icon: this.map.icons.searchResult, zIndex: 10000 + this.zIndex };
    void 0 !== a
      ? ((b.label = clone(this.map.labels.searchResult)), (b.label.text = a))
      : (b.label = this.map.labels.selected);
    this.marker.setOptions(b);
  },
  resetMarker: function () {
    this.marker.setOptions({
      icon: this.map.icons.normal,
      label: this.map.labels.normal,
      zIndex: this.zIndex,
    });
  },
  telephoneFields: [
    { fieldName: "helpline", printName: "helpline" },
    { fieldName: "officeTelephone", printName: "office" },
  ],
  addressFields: ["address", "town", "postCode"],
  drawText: function () {
    this.details = this.node.appendNode("div", "details");
    this.details.appendNode("h2", null, this.data.name);
    if (null !== this.data.shortDescription) {
      for (
        var a = $jscomp.makeIterator(
            this.data.shortDescription.split(/[\r\n]+/)
          ),
          b = a.next();
        !b.done;
        b = a.next()
      ) {
        this.details.appendNode("p", "previewOnly", b.value);
      }
    }
    b = new node("ul");
    a = $jscomp.makeIterator(this.telephoneFields);
    for (var c = a.next(); !c.done; c = a.next()) {
      (c = c.value),
        null !== this.data[c.fieldName] &&
          b.appendNode("li").innerHTML(
            c.printName +
              ":&ensp;" +
              this.data[c.fieldName].replace(
                /\(?\+?\d[()\d\s-]+\d/g,
                function (a) {
                  return (
                    '<a href="tel:' +
                    a
                      .replace(/\D/g, "")
                      .replace(/^\(?0(?:(?!044)|044)/, "+44") +
                    '">' +
                    a +
                    "</a>"
                  );
                }
              )
          );
    }
    if (null !== this.data.websites) {
      for (
        a = $jscomp.makeIterator(this.data.websites), c = a.next();
        !c.done;
        c = a.next()
      ) {
        (c = c.value),
          b
            .appendNode("li")
            .appendNode("a", { href: "http://" + c, target: "_blank" }, c);
      }
    }
    b.hasChildNodes() && this.details.appendChild(b);
    b = [];
    a = $jscomp.makeIterator(this.addressFields);
    for (c = a.next(); !c.done; c = a.next()) {
      (c = c.value),
        null !== this.data[c] && merge(b, this.data[c].split(/[\r\n]/));
    }
    if (0 < b.length) {
      a = this.details.appendNode("p", "selectedOnly");
      c = $jscomp.makeIterator(b.entries());
      for (var d = c.next(); !d.done; d = c.next()) {
        var e = $jscomp.makeIterator(d.value);
        d = e.next().value;
        e = e.next().value;
        a.appendChild(e);
        d < b.length - 1 && a.appendNode("br");
      }
    }
    if (null !== this.data.longDescription) {
      for (
        a = $jscomp.makeIterator(this.data.longDescription.split(/[\r\n]+/)),
          b = a.next();
        !b.done;
        b = a.next()
      ) {
        this.details.appendNode("p", "selectedOnly", b.value);
      }
    }
  },
  select: function () {
    var a = this;
    this.state = "selected";
    this.setSearchResultMarker();
    this.node = new node(
      "div",
      "mapService mapServiceSingle mapSelected"
    ).append(
      new node("button", "close fa fa-times").addEventListener(
        "click",
        function () {
          return a.close();
        }
      )
    );
    this.drawText();
    this.map.serviceSelect(this);
  },
  deselect: function () {
    this.state = "normal";
    this.resetMarker();
  },
  close: function () {
    this.deselect();
    this.map.serviceClose();
  },
  drawSearchResult: function (a) {
    var b = this;
    this.state = "searchResult";
    this.selected = !1;
    a = String.fromCharCode(65 + a);
    this.setSearchResultMarker(a);
    this.node = new node("li", "mapService mapSearchResult").append(
      new node("p", "marker", a)
    );
    this.drawText();
    this.details
      .appendNode("p", "serviceLink previewOnly")
      .appendNode(
        "a",
        {
          href:
            "/help-for-families/finding-support/search-for-local-support/" +
            this.data.id,
        },
        "click for more information"
      )
      .addEventListener("click", function (a) {
        return b.moreInformationClick(a);
      });
    this.markerListeners = [
      this.marker.addListener("mouseover", function () {
        return b.markerMouseOver();
      }),
      this.marker.addListener("mouseout", function () {
        return b.markerMouseOut();
      }),
    ];
    this.node
      .addEventListener("mouseenter", function () {
        return b.searchResultMouseEnter();
      })
      .addEventListener("mouseleave", function () {
        return b.searchResultMouseLeave();
      })
      .addEventListener("click", function () {
        return b.searchResultSelect();
      });
  },
  markerEmphasise: function () {
    this.marker.setOptions({ icon: this.map.icons.searchResultEmphasise });
  },
  markerDeemphasise: function () {
    this.marker.setOptions({ icon: this.map.icons.searchResult });
  },
  markerMouseOver: function () {
    this.selected || (this.node.addClass("hover"), this.markerEmphasise());
  },
  markerMouseOut: function () {
    this.selected || (this.node.removeClass("hover"), this.markerDeemphasise());
  },
  searchResultMouseEnter: function () {
    this.selected || this.markerEmphasise();
  },
  searchResultMouseLeave: function () {
    this.selected || this.markerDeemphasise();
  },
  moreInformationClick: function (a) {
    a.preventDefault();
    a.stopPropagation();
    this.searchResultSelect();
  },
  searchResultSelect: function () {
    this.selected = !0;
    this.map.searchResultSelect(this);
    this.node.addClass("mapSelected").removeClass("hover");
    this.markerEmphasise();
  },
  searchResultDeselect: function () {
    this.selected = !1;
    this.node.removeClass("mapSelected");
    this.markerDeemphasise();
  },
  searchResultReset: function () {
    this.state = "normal";
    this.resetMarker();
    for (
      var a = $jscomp.makeIterator(this.markerListeners), b = a.next();
      !b.done;
      b = a.next()
    ) {
      b.value.remove();
    }
  },
};
function ForumUser(a) {
  this.id = a.id;
  this.username = a.username;
  this.userPath = a.username.replace(" ", "-");
  this.superuser = a.superuser;
}
ForumUser.prototype = { constructor: ForumUser };
function ForumModalFormContainer(a) {
  ForumModalFormContainer.parent.constructor.call(this);
  this.forum = a;
}
extend(ForumModalFormContainer, ModalFormContainer, {
  close: function () {
    ForumModalFormContainer.parent.close.call(this);
    this.forum.closeModalForm();
  },
});
function ForumModalForm(a, b) {
  ForumModalForm.parent.constructor.call(this, b);
  this.forum = a;
}
extend(ForumModalForm, ModalForm, {
  handler: "/script/forum.php",
  errorEmail: "forum@adfam.org.uk",
  columnTemplates: {
    username: {
      name: "username",
      type: "varchar",
      nullable: !1,
      default: null,
      minLength: 3,
      patternDescription:
        "Usernames use letters, numbers, space and apostrophe. They start and end with a letter or number.",
    },
    password: {
      name: "password",
      type: "varchar",
      nullable: !1,
      default: null,
      minLength: 6,
      length: 20,
      pattern:
        "^[a-zA-Z0-9`\u00ac\u00a6!\"\u00a3$%^&*()\\-_=+\\[{\\]};:'@#~\\\\|,<.>/?]{6,20}$",
      patternDescription:
        "Passwords use letters, numbers, and the following special characters: ` \u00ac \u00a6 ! \" \u00a3 $ % ^ & * ( ) - _ = + [ ] { } ; : ' @ # ~ \\ / | , . ? < >",
      printName: "Password",
      inputType: "password",
    },
    email: {
      name: "email",
      type: "varchar",
      nullable: !1,
      default: null,
      length: 100,
      printName: "Email",
      inputType: "email",
    },
  },
  createColumns: function (a) {
    if (void 0 === a.prototype.columns) {
      a.prototype.columns = [];
      for (var b in a.prototype.columnTemplates) {
        a.prototype.columnTemplates.hasOwnProperty(b) &&
          a.prototype.columns.push(
            merge(a.prototype.columnTemplates[b], a.parent.columnTemplates[b])
          );
      }
    }
  },
});
function ForumSignInForm(a, b, c) {
  var d = this;
  this.createColumns(ForumSignInForm);
  !0 === c &&
    (this.message = "Password reset successful. Please check your email.");
  ForumSignInForm.parent.constructor.call(this, a, b);
  this.node
    .addClass("forum signIn")
    .appendNode("div", "footer")
    .append(
      new node("p").append(
        "Not registered? ",
        new node("a", null, "Sign up").addEventListener("click", function (a) {
          return d.createRegistrationForm(a);
        })
      ),
      new node("p").append(
        "Forgotten password? ",
        new node("a", null, "Reset it").addEventListener("click", function (a) {
          return d.createResetPasswordForm(a);
        })
      )
    );
}
extend(ForumSignInForm, ForumModalForm, {
  action: "signIn",
  title: "Sign in to the forum",
  submitLabel: "Sign In",
  columnsCreated: !1,
  columnTemplates: {
    username: {
      length: 100,
      lengthDescription: "Usernames are between 3 and 20 characters.",
      pattern:
        '^(?:[a-zA-Z0-9][a-zA-Z0-9 \']{1,18}[a-zA-Z0-9]|(?:(?:[^<>()\\[\\]\\\\.,;:\\s@"]+(?:\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|".+")@(?:(\\[(?:[0-9]{1,3}\\.){3}[0-9]{1,3}\\])|(?:(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,})))$',
      printName: "Username / Email",
    },
    password: {},
  },
  createRegistrationForm: function (a) {
    a.stopPropagation();
    this.container.replace(
      new ForumRegistrationForm(this.forum, this.container)
    );
  },
  createResetPasswordForm: function (a) {
    a.stopPropagation();
    this.container.replace(
      new ForumResetPasswordForm(this.forum, this.container)
    );
  },
  createEmailVerificationForm: function (a) {
    this.container.replace(
      new ForumEmailVerificationForm(this.forum, this.container, a, !1)
    );
  },
  submitSuccess: function (a) {
    if (a.success) {
      this.forum.signIn(a.user);
    } else {
      switch (a.failType) {
        case "user":
          this.displayError("Unknown username / email");
          break;
        case "password":
          this.displayError("Incorrect password");
          break;
        case "emailUnverified":
          this.createEmailVerificationForm(a.user);
          break;
        default:
          this.defaultError("signing in");
      }
    }
    ForumSignInForm.parent.submitSuccess.apply(this, arguments);
  },
});
function ForumRegistrationForm(a, b) {
  var c = this;
  this.createColumns(ForumRegistrationForm);
  ForumRegistrationForm.parent.constructor.apply(this, arguments);
  this.recaptchaReady = !1;
  var d = new node("td", { class: "recaptcha", colspan: 2 });
  this.tbody.insertBefore(new node("tr").append(d), this.submitRow);
  grecaptcha.render(d.sourceNode, {
    sitekey: this.recaptchaSitekey,
    callback: function (a) {
      return c.recaptchaComplete(a);
    },
    "expired-callback": function () {
      return c.recaptchaExpired();
    },
  });
  this.node
    .addClass("forum register")
    .appendNode("p", "footer")
    .append(
      "Already registered? ",
      new node("a", null, "Sign in").addEventListener("click", function (a) {
        return c.createSignInForm(a);
      })
    );
}
extend(ForumRegistrationForm, ForumModalForm, {
  action: "register",
  title: "Register for the forum",
  submitLabel: "Register",
  recaptchaSitekey: "6LeGWzoUAAAAAAfwJhyQ-0dcCY3i6Jslh70LkpDY",
  columnTemplates: {
    username: {
      length: 20,
      pattern: "^[a-zA-Z0-9][a-zA-Z0-9 ']{1,18}[a-zA-Z0-9]$",
      restrictInput: /[a-z0-9 ']/i,
      printName: "Username",
      unique: !0,
      existsMessage: "That username is taken.",
    },
    password: {
      restrictInput:
        /[a-z0-9`\u00ac\u00a6!"\u00a3$%^&*()\-_=+\[{\]};:'@#~,\\|<.>/?]/i,
    },
    email: {
      unique: !0,
      existsMessage: "An account with that email already exists.",
    },
    caseStudies: {
      name: "caseStudies",
      type: "boolean",
      nullable: !1,
      default: !1,
      printName: "Case studies",
      additionalInfo:
        "We are always interested in hearing the stories of families affected by drugs or alcohol. We use these to bring about positive change for families through our media and campaigning work. If you would like to share your story with a wider audience please tick this box so we can contact you.",
    },
    emailNotifications: {
      name: "emailNotifications",
      type: "boolean",
      nullable: !1,
      default: !0,
      printName: "Email notifications",
      additionalInfo:
        "Receive email notifications when someone posts on a thread that you have also posted on.",
    },
  },
  createSignInForm: function (a) {
    a.stopPropagation();
    this.container.replace(new ForumSignInForm(this.forum, this.container));
  },
  createEmailVerificationForm: function (a) {
    this.container.replace(
      new ForumEmailVerificationForm(this.forum, this.container, a, !0)
    );
  },
  recaptchaComplete: function (a) {
    this.data.recaptchaResponse = a;
    this.recaptchaReady = !0;
  },
  recaptchaExpired: function () {
    this.recaptchaReady = !1;
  },
  submit: function (a) {
    if (!this.recaptchaReady) {
      return void 0 !== a && a.preventDefault(), !1;
    }
    for (
      var b = $jscomp.makeIterator(this.unique), c = b.next();
      !c.done;
      c = b.next()
    ) {
      c = $jscomp.makeIterator(c.value);
      var d = c.next().value;
      if (!c.next().value) {
        return this.inputs.get(d).checkExists(!0), !1;
      }
    }
    return ForumRegistrationForm.parent.submit.apply(this, arguments);
  },
  submitSuccess: function (a) {
    if (a.success) {
      this.createEmailVerificationForm(a.user);
    } else {
      switch (a.failType) {
        case "reCAPTCHA":
          this.displayError("reCAPTCHA invalid");
          break;
        default:
          this.defaultError("with your registration");
      }
    }
    ForumRegistrationForm.parent.submitSuccess.call(this, a, !0);
  },
});
function ForumEmailVerificationForm(a, b, c, d) {
  this.message = d ? this.messages.register : this.messages.signIn;
  ForumEmailVerificationForm.parent.constructor.call(this, a, b);
  this.user = c;
  this.data.user = c;
  this.node.addClass("forum emailVerify");
}
extend(ForumEmailVerificationForm, ForumModalForm, {
  action: "verifyEmail",
  title: "Email verification",
  submitLabel: "Submit",
  columns: [
    {
      name: "code",
      type: "varchar",
      nullable: !1,
      minLength: 5,
      length: 5,
      pattern: "^[a-zA-Z0-9]{5}$",
      patternDescription:
        "Your verification code consists of five letters and numbers.",
      restrictInput: /[a-z0-9]/i,
      printName: "Code",
    },
  ],
  messages: {
    register:
      "We've successfully created your account, now we just need to verify your email address. We've sent a code to your email, please enter it below.",
    signIn:
      "Looks like your account's email address isn't verified. We've sent a code to your email, please enter it below.",
  },
  submitSuccess: function (a) {
    if (a.success) {
      this.forum.signIn(this.user);
    } else {
      switch (a.failType) {
        case "codeIncorrect":
          this.displayError("Incorrect code");
          break;
        case "codeReset":
          this.displayError(
            "Too many failed attempts. We have sent you a new verification code."
          );
          break;
        default:
          this.defaultError("with your email verification");
      }
    }
    ForumEmailVerificationForm.parent.submitSuccess.apply(this, arguments);
  },
});
function ForumResetPasswordForm(a, b) {
  var c = this;
  this.createColumns(ForumResetPasswordForm);
  ForumResetPasswordForm.parent.constructor.apply(this, arguments);
  this.node
    .addClass("forum resetPassword")
    .appendNode("p", "footer")
    .append(
      "Know your password? ",
      new node("a", null, "Sign in").addEventListener("click", function (a) {
        return c.signInClick(a);
      })
    );
}
extend(ForumResetPasswordForm, ForumModalForm, {
  action: "resetPassword",
  title: "Reset password",
  submitLabel: "Submit",
  columnTemplates: { email: {} },
  signInClick: function (a) {
    a.stopPropagation();
    this.createSignInForm(!1);
  },
  createSignInForm: function (a) {
    this.container.replace(new ForumSignInForm(this.forum, this.container, a));
  },
  submitSuccess: function (a) {
    if (a.success) {
      this.createSignInForm(!0);
    } else {
      switch (a.failType) {
        case "user":
          this.displayError("Unknown email");
          break;
        default:
          this.defaultError("resetting your password");
      }
    }
    ForumResetPasswordForm.parent.submitSuccess.call(this, a, !0);
  },
});
function ForumExtantForm(a, b) {
  ForumExtantForm.parent.constructor.call(this, b);
  this.forum = a;
}
extend(ForumExtantForm, ExtantForm, {
  handler: "/script/forum.php",
  errorEmail: "forum@adfam.org.uk",
  createColumns: function (a) {
    a.prototype.columns = [];
    for (var b in a.prototype.columnTemplates) {
      a.prototype.columnTemplates.hasOwnProperty(b) &&
        a.prototype.columns.push(this.createColumn(a, b));
    }
  },
  createColumn: function (a, b, c) {
    void 0 === c && (c = b);
    return merge(
      {},
      ForumRegistrationForm.prototype.columnTemplates[c],
      ForumRegistrationForm.parent.columnTemplates[c],
      a.prototype.columnTemplates[b]
    );
  },
});
function ForumUserDetailsForm(a, b) {
  this.createColumns(ForumUserDetailsForm);
  this.node = node.querySelector(".forumSettings form.details");
  ForumUserDetailsForm.parent.constructor.apply(this, arguments);
  this.additionalInfoVisible = !1;
}
extend(ForumUserDetailsForm, ForumExtantForm, {
  action: "settingsDetails",
  columnTemplates: {
    username: {},
    email: {},
    caseStudies: {},
    emailNotifications: {},
  },
  submit: function (a) {
    if (!ForumUserDetailsForm.parent.submit.apply(this, arguments)) {
      return !1;
    }
    void 0 !== this.data.username &&
      this.forum.updateUsername(this.data.username);
    return !0;
  },
  submitSuccess: function (a) {
    a.success || this.defaultError("updating your details");
    ForumUserDetailsForm.parent.submitSuccess.apply(this, arguments);
  },
  sign: function () {
    setTimeout(function () {
      return location.reload();
    }, 10);
  },
});
function ForumUserPasswordForm(a, b) {
  this.createColumns(ForumUserPasswordForm);
  this.node = node.querySelector(".forumSettings form.password");
  ForumUserPasswordForm.parent.constructor.apply(this, arguments);
}
extend(ForumUserPasswordForm, ForumExtantForm, {
  action: "settingsPassword",
  columnTemplates: {
    password: { printName: "Current password" },
    passwordNew: { name: "passwordNew", printName: "New password" },
    passwordConfirmation: {
      name: "passwordConfirmation",
      printName: "Confirm password",
    },
  },
  createColumn: function (a, b) {
    return ForumUserPasswordForm.parent.createColumn.call(
      this,
      a,
      b,
      "password"
    );
  },
  submit: function (a) {
    var b = this.inputs.get("passwordNew").getValue();
    return null !== b &&
      this.inputs.get("passwordConfirmation").getValue() !== b
      ? (a.preventDefault(),
        this.displayError("New passwords do not match"),
        !1)
      : ForumUserPasswordForm.parent.submit.apply(this, arguments);
  },
  submitSuccess: function (a) {
    if (a.success) {
      this.node.reset();
    } else {
      switch (a.failType) {
        case "oldPassword":
          this.displayError("Incorrect current password");
          break;
        case "newPassword":
          this.displayError("New passwords do not match");
          break;
        default:
          this.defaultError("updating your password");
      }
    }
    ForumUserPasswordForm.parent.submitSuccess.apply(this, arguments);
  },
});
function ForumThreadList(a, b) {
  var c = this;
  this.forum = a;
  this.threads = [];
  b = $jscomp.makeIterator(b);
  for (var d = b.next(); !d.done; d = b.next()) {
    this.threads.push(new ForumThreadPreview(a, d.value));
  }
  setInterval(function () {
    return c.updateIntervals();
  }, 10000);
}
ForumThreadList.prototype = {
  constructor: ForumThreadList,
  updateIntervals: function () {
    for (
      var a = $jscomp.makeIterator(this.threads), b = a.next();
      !b.done;
      b = a.next()
    ) {
      b.value.updateInterval();
    }
  },
  sign: function (a) {
    for (
      var b = $jscomp.makeIterator(this.threads), c = b.next();
      !c.done;
      c = b.next()
    ) {
      c.value.sign(a, this.forum.user);
    }
  },
};
function ForumCategory(a, b, c) {
  var d = this;
  ForumCategory.parent.constructor.call(this, a, b);
  c &&
    (this.newThreadButton = node
      .querySelector(".forumButton.newThread")
      .addEventListener("click", function (a) {
        return d.newThreadClick(a);
      }));
}
extend(ForumCategory, ForumThreadList, {
  newThreadClick: function (a) {
    var b = this;
    this.forum.signedIn ||
      (a.preventDefault(),
      this.forum.createSignInForm(function () {
        return b.newThread();
      }));
  },
  newThread: function () {
    location.href = this.newThreadButton.href();
  },
});
function ForumCategories(a, b) {
  this.categories = [];
  b = $jscomp.makeIterator(b);
  for (var c = b.next(); !c.done; c = b.next()) {
    this.categories.push(new ForumCategory(a, c.value.threads, !1));
  }
}
ForumCategories.prototype = {
  constructor: ForumCategories,
  sign: function (a) {
    for (
      var b = $jscomp.makeIterator(this.categories), c = b.next();
      !c.done;
      c = b.next()
    ) {
      c.value.sign(a);
    }
  },
};
function ForumThread(a, b) {
  this.forum = a;
  this.data = b;
  this.id = b.id;
  this.closed = b.closed;
}
ForumThread.prototype = { constructor: ForumThread };
function ForumThreadPreview(a, b) {
  var c = this;
  ForumThreadPreview.parent.constructor.apply(this, arguments);
  this.dates = { visiblePost: new Date(b.visiblePostDate) };
  b.showLatestPost && (this.dates.latestPost = new Date(b.latestPostDate));
  this.forum.superuser && (this.censored = b.censor);
  this.article = node.querySelector(
    '.forumThreadPreview[data-id="' + b.id + '"]'
  );
  this.mainLink = this.article.firstChild();
  this.header = this.article.querySelector("header");
  this.forum.superuser &&
    ((this.pinButton = this.header.querySelector(".pin")),
    (this.closeButton = this.header.querySelector(".close")),
    (this.censorButton = this.header.querySelector(".censor")));
  this.closed && (this.closedLabel = this.header.querySelector(".closedLabel"));
  this.dateVisiblePost = this.article.querySelector(
    ".forumThreadDateVisiblePost time"
  );
  this.dateLatestPost = this.article.querySelector(
    ".forumThreadDateLatestPost time"
  );
  this.userLinks = [];
  for (
    var d = $jscomp.makeIterator(
        this.article.querySelectorAll(".forumUserLink")
      ),
      e = d.next();
    !e.done;
    e = d.next()
  ) {
    this.userLinks.push(
      e.value
        .addEventListener("mouseenter", function () {
          return c.userLinkMouseEnter();
        })
        .addEventListener("mouseleave", function () {
          return c.userLinkMouseLeave();
        })
    );
  }
  this.forum.superuser &&
    (this.pinButton.addEventListener("click", function (a) {
      return c.pin(a);
    }),
    this.closeButton.addEventListener("click", function (a) {
      return c.close(a);
    }),
    this.censorButton.addEventListener("click", function (a) {
      return c.censor(a);
    }));
}
extend(ForumThreadPreview, ForumThread, {
  userLinkMouseEnter: function () {
    this.mainLink.addClass("userLinkHover");
  },
  userLinkMouseLeave: function () {
    this.mainLink.removeClass("userLinkHover");
  },
  updateInterval: function () {
    this.dateVisiblePost.textContent(forumInterval(this.dates.visiblePost));
    this.data.showLatestPost &&
      this.dateLatestPost.textContent(forumInterval(this.dates.latestPost));
  },
  pin: function (a) {
    var b = this;
    a.preventDefault();
    this.forum.superuser &&
      confirm(
        "Are you sure you want to " +
          (this.data.pinned ? "un" : "") +
          "pin this thread?"
      ) &&
      this.forum.executeStatement(
        "pinThread",
        { id: this.id, on: !this.data.pinned },
        function (a) {
          return b.pinSuccess(a);
        }
      );
  },
  pinSuccess: function (a) {
    a.success
      ? location.reload()
      : console.error("pin thread => " + a.errorMessage);
  },
  close: function (a) {
    var b = this;
    a.preventDefault();
    this.forum.superuser &&
      confirm(
        "Are you sure you want to " +
          (this.closed ? "open" : "close") +
          " this thread?"
      ) &&
      this.forum.executeStatement(
        "closeThread",
        { id: this.id, on: !this.closed },
        function (a) {
          return b.closeSuccess(a);
        }
      );
  },
  closeSuccess: function (a) {
    a.success
      ? ((this.closed = !this.closed),
        this.article
          .changeClass("closed", this.closed)
          .title(this.closed ? "This thread is closed" : ""),
        this.closeButton.title(this.closed ? "open" : "close"),
        this.closed
          ? (this.closedLabel = this.header.appendNode(
              "span",
              "closedLabel fa fa-times-circle"
            ))
          : (this.closedLabel.remove(), delete this.closedLabel))
      : console.error("close thread => " + a.errorMessage);
  },
  censor: function (a) {
    var b = this;
    a.preventDefault();
    this.forum.superuser &&
      confirm(
        "Are you sure you want to " +
          (this.censored ? "un" : "") +
          "censor this thread?"
      ) &&
      this.forum.executeStatement(
        "censorThread",
        { id: this.id, on: !this.censored },
        function (a) {
          return b.censorSuccess(a);
        }
      );
  },
  censorSuccess: function (a) {
    a.success
      ? ((this.censored = !this.censored),
        this.article.changeClass("censor", this.censored),
        this.censorButton.title((this.censored ? "un" : "") + "censor"))
      : console.error("censor thread => " + a.errorMessage);
  },
  sign: function (a, b) {
    for (
      var c = $jscomp.makeIterator(this.userLinks), d = c.next();
      !d.done;
      d = c.next()
    ) {
      (d = d.value),
        d.dataset.id == b.id &&
          (a
            ? d.addClass("signedInUser").empty().textContent("You")
            : d
                .removeClass("signedInUser")
                .empty()
                .appendNode("span", { itemprop: "alternateName" }, b.username));
    }
  },
});
function ForumThreadFull(a, b, c) {
  var d = this;
  ForumThreadFull.parent.constructor.call(this, a, b);
  this.originalPostID = b.originalPostID;
  this.originalPostUsername = b.originalPostUsername;
  this.postCount = b.postCount;
  this.page = c;
  this.pageMax = b.pageMax;
  this.container = node.querySelector(".forumThread");
  this.toolbarMode = this.container.querySelector("#forumToolbarMode");
  this.toolbarDescending = this.container.querySelector(
    "#forumToolbarDescending"
  );
  this.toolbarLimit = this.container.querySelector("#forumToolbarLimit");
  this.posts = new Map();
  c = $jscomp.makeIterator(b.posts);
  for (var e = c.next(); !e.done; e = c.next()) {
    this.addPost(e.value);
  }
  "" != location.hash &&
    ((c = location.hash.match(/forumPost(\d+)/)),
    null !== c && this.scrollToPost(parseInt(c[1])));
  this.closed ||
    (this.extantForm = new ForumFormExtant(
      a,
      this,
      b.originalPostID,
      b.originalPostUsername,
      this.posts.get(b.originalPostID)
    ));
  setInterval(function () {
    return d.updateIntervals();
  }, 10000);
  this.toolbarMode.addEventListener("change", function () {
    return d.setMode();
  });
  this.toolbarDescending.addEventListener("change", function () {
    return d.setDescending();
  });
  this.toolbarLimit.addEventListener("change", function () {
    return d.setLimit();
  });
}
extend(ForumThreadFull, ForumThread, {
  addPost: function (a) {
    var b =
      a.parentPostExists && void 0 === a.parentPostPage
        ? this.posts.get(a.replyingTo_id)
        : void 0;
    this.posts.set(a.id, new ForumPostExtant(this.forum, this, a, b));
  },
  reply: function (a) {
    this.closed ||
      (!a.originalPost || 1 < this.posts.size
        ? (this.extantForm.hide(),
          void 0 !== this.replyForm && this.replyForm.close(),
          (this.replyForm = new ForumFormNewReply(this.forum, this, a)))
        : this.extantForm.setFocus());
  },
  insertPost: function (a) {
    this.postCount++;
    this.updatePageMax();
    this.page < this.pageMax || 1 == this.postCount % this.forum.limit
      ? (location.href =
          location.pathname + "?page=" + this.pageMax + "#forumPost" + a.id)
      : this.posts.set(
          a.id,
          new ForumPostNew(this.forum, this, a, this.posts.get(a.replyingTo_id))
        );
  },
  appendPost: function (a) {
    this.forum.descending
      ? this.container.insertAfter(a, this.extantForm.form)
      : this.container.insertBefore(a, this.extantForm.form);
    this.container.offsetHeight();
  },
  reportPost: function (a) {
    this.forum.executeStatement("reportAbuse", { threadID: this.id, post: a });
  },
  scrollToPost: function (a) {
    this.posts.get(a).scrollTo();
  },
  setMode: function () {
    this.forum.setMode(this.toolbarMode.value(), this.id);
  },
  setDescending: function () {
    this.forum.setDescending("true" === this.toolbarDescending.value());
  },
  setLimit: function () {
    var a = this.toolbarLimit.value();
    "all" !== a && (a = +a);
    this.forum.setLimit(a);
  },
  formFocus: function (a) {
    a === this.extantForm
      ? void 0 !== this.replyForm && this.replyForm.hide()
      : a === this.replyForm && this.extantForm.hide();
  },
  updatePageMax: function () {
    this.pageMax = Math.ceil(this.postCount / this.limit);
  },
  updateIntervals: function () {
    for (
      var a = $jscomp.makeIterator(this.posts.values()), b = a.next();
      !b.done;
      b = a.next()
    ) {
      b.value.updateInterval();
    }
  },
  sign: function (a) {
    a || this.signOut();
    for (
      var b = $jscomp.makeIterator(this.posts.values()), c = b.next();
      !c.done;
      c = b.next()
    ) {
      c.value.sign(a);
    }
  },
  signOut: function () {
    this.extantForm.hide();
    void 0 !== this.replyForm && this.replyForm.close();
  },
});
function ForumPost(a, b, c, d) {
  this.forum = a;
  this.thread = b;
  this.data = c;
  this.parentPost = d;
  this.originalPost = null === c.replyingTo_id;
  this.userPost = a.signedIn && c.userID == a.user.id;
}
ForumPost.prototype = {
  constructor: ForumPost,
  addEventListeners: function () {
    var a = this;
    this.thread.closed ||
      (this.userPost && this.addUserPostEventListeners(),
      this.replyButton.addEventListener("click", function () {
        return a.reply();
      }));
    this.forum.superuser
      ? this.addSuperuserEventListeners()
      : this.addReportEventListener();
    this.data.parentPostExists &&
      void 0 === this.data.parentPostPage &&
      this.replyingToLink.addEventListener("click", function (b) {
        return a.scrollToPost(b);
      });
  },
  addUserPostEventListeners: function () {
    var a = this;
    this.editButton.addEventListener("click", function () {
      return a.edit();
    });
  },
  addReportEventListener: function () {
    var a = this;
    this.reportButton.addEventListener("click", function () {
      return a.report();
    });
  },
  addSuperuserEventListeners: function () {
    var a = this;
    this.featureButton.addEventListener("click", function () {
      return a.feature();
    });
    this.censorButton.addEventListener("click", function () {
      return a.censor();
    });
  },
  edit: function () {
    this.thread.closed ||
      void 0 !== this.editForm ||
      (this.editForm = new ForumFormNewEdit(this.forum, this.thread, this));
  },
  closeEditForm: function () {
    delete this.editForm;
  },
  update: function (a) {
    this.data.text = a;
    this.data.isEdited = !0;
    this.dates.dateEdited = new Date();
    this.data.dateEdited = this.dates.dateEdited.toISOString();
    this.article.addClass("forumPostIsEdited");
    this.text.innerHTML("<p>" + a.replace(/[\r\n]+/g, "</p><p>") + "</p>");
    void 0 === this.dateEdited &&
      this.detailsMiddle
        .appendNode("p", {
          title: "edited " + this.forum.dateFormat(this.dates.dateEdited),
        })
        .append(
          new node("span", "fa fa-pencil"),
          " ",
          (this.dateEdited = new node("time", {
            class: "dateEdited",
            itemprop: "dateModified",
          }))
        );
    this.dateEdited.dateTime(this.data.dateEdited);
    this.dateEdited.textContent(forumInterval(this.dates.dateEdited));
  },
  reply: function () {
    var a = this;
    this.forum.signedIn
      ? this.thread.reply(this)
      : this.forum.createSignInForm(function () {
          return a.reply();
        });
  },
  insertForm: function (a) {
    (
      "date" == this.forum.mode || this.originalPost
        ? !this.forum.descending
        : this.forum.descending
    )
      ? this.formContainer.appendChild(a)
      : this.formContainer.prependChild(a);
  },
  appendReply: function (a) {
    this.forum.descending
      ? this.repliesContainer.prependChild(a)
      : this.repliesContainer.appendChild(a);
    this.repliesContainer.offsetHeight();
  },
  report: function () {
    var a = this;
    this.forum.signedIn
      ? confirm("Are you sure you want to report this post?") &&
        this.thread.reportPost(this.data, function (b) {
          return a.reportSuccess(b);
        })
      : this.forum.createSignInForm(function () {
          return a.report();
        });
  },
  reportSuccess: function (a) {
    a.success || console.error("report post => " + a.errorMessage);
  },
  feature: function () {
    var a = this;
    confirm(
      "Are you sure you want to " +
        (this.featured ? "un" : "") +
        "feature this post?"
    ) &&
      this.forum.executeStatement(
        "featurePost",
        { id: this.data.id, on: !this.featured },
        function (b) {
          return a.featureSuccess(b);
        }
      );
  },
  featureSuccess: function (a) {
    a.success
      ? ((this.featured = !this.featured),
        this.article.changeClass("featured", this.featured),
        this.featureButton.title((this.featured ? "un" : "") + "feature"))
      : console.error("feature post => " + a.errorMessage);
  },
  censor: function () {
    var a = this;
    confirm(
      "Are you sure you want to " +
        (this.censored ? "un" : "") +
        "censor this post?"
    ) &&
      this.forum.executeStatement(
        "censorPostFromFrontEnd",
        { id: this.data.id },
        function (b) {
          return a.censorSuccess(b);
        }
      );
  },
  censorSuccess: function (a) {
    a.success
      ? ((this.censored = !this.censored),
        this.article.changeClass("censor", this.censored),
        this.censorButton.title((this.censored ? "un" : "") + "censor"))
      : console.error("censor post => " + a.errorMessage);
  },
  scrollToPost: function (a) {
    a.preventDefault();
    this.thread.scrollToPost(this.data.replyingTo_id);
  },
  scrollTo: function () {
    var a = this;
    setTimeout(function () {
      return a.scrollToExecute();
    }, 10);
  },
  scrollToExecute: function () {
    console.log(nav.height, this.forum.navHeight);
    window.scrollTo(
      0,
      this.article.offset().top - 10 - nav.height - this.forum.navHeight
    );
    this.article.pulse("highlight");
  },
  updateReplyCount: function () {
    this.replyCount
      .empty()
      .append(
        new node("span", { itemprop: "commentCount" }, this.data.replyCount),
        " repl" + (1 != this.data.replyCount ? "ies" : "y")
      );
  },
  bumpReplyCount: function () {
    this.data.replyCount++;
    void 0 === this.replyCount &&
      (this.replyCount = this.details.appendNode("p", "bottom replyCount"));
    this.updateReplyCount();
  },
  updateInterval: function () {
    this.dateCreated.textContent(forumInterval(this.dates.dateCreated));
    this.data.isEdited &&
      this.dateEdited.textContent(forumInterval(this.dates.dateEdited));
  },
  sign: function (a) {
    a ? this.signIn() : this.signOut();
  },
  signIn: function () {
    if ((this.userPost = this.data.userID == this.forum.user.id)) {
      this.userLink.addClass("signedInUser").empty().textContent("You"),
        this.controls.prepend(
          (this.editButton = new node("button", {
            class: "edit fa fa-pencil",
            type: "button",
            title: "edit",
          }))
        ),
        this.addUserPostEventListeners();
    }
    this.forum.superuser &&
      (this.reportButton.remove(),
      delete this.reportButton,
      this.controls.append(
        (this.featureButton = new node("button", {
          class: "feature fa fa-star",
          type: "button",
          title: "feature",
        })),
        (this.censorButton = new node("button", {
          class: "censor fa fa-ban",
          type: "button",
          title: "censor",
        }))
      ),
      this.addSuperuserEventListeners());
    this.data.parentPostExists &&
      this.data.replyingToUserID == this.forum.user.id &&
      this.replyingToLink.textContent("You");
  },
  signOut: function () {
    this.userPost &&
      (this.userLink
        .removeClass("signedInUser")
        .empty()
        .appendNode(
          "span",
          { itemprop: "alternateName" },
          this.forum.user.username
        ),
      this.editButton.remove(),
      delete this.editButton,
      void 0 !== this.editForm && this.editForm.close(),
      (this.userPost = !1));
    this.forum.superuser &&
      (this.featureButton.remove(),
      this.censorButton.remove(),
      delete this.featureButton,
      delete this.censorButton,
      this.controls.appendChild(
        (this.reportButton = new node("button", {
          class: "report fa fa-flag",
          type: "button",
          title: "report abuse",
        }))
      ),
      this.addReportEventListener());
    this.data.parentPostExists &&
      this.data.replyingToUserID == this.forum.user.id &&
      this.replyingToLink.textContent(this.forum.user.username);
  },
};
function ForumPostExtant(a, b, c, d) {
  ForumPostExtant.parent.constructor.apply(this, arguments);
  this.dates = { dateCreated: new Date(this.data.dateCreated) };
  this.data.isEdited &&
    (this.dates.dateEdited = new Date(this.data.dateEdited));
  this.forum.superuser &&
    ((this.featured = c.featured), (this.censored = c.censor));
  this.article = node.querySelector('.forumPost[data-id="' + c.id + '"]');
  b.closed ||
    (this.userPost && (this.editButton = this.article.querySelector(".edit")),
    (this.replyButton = this.article.querySelector(".reply")));
  a.superuser
    ? ((this.featureButton = this.article.querySelector(".feature")),
      (this.censorButton = this.article.querySelector(".censor")))
    : (this.reportButton = this.article.querySelector(".report"));
  this.data.parentPostExists &&
    (this.replyingToLink = this.article.querySelector(".replyingToLink"));
  this.details = this.article.querySelector(".forumPostDetails");
  this.userLink = this.details.querySelector(".forumUserLink");
  this.detailsMiddle = this.details.querySelector(".middle");
  this.dateCreated = this.detailsMiddle.querySelector(".forumPostDateCreated");
  this.data.isEdited &&
    (this.dateEdited = this.detailsMiddle.querySelector(
      ".forumPostDateEdited"
    ));
  0 < this.data.replyCount &&
    (this.replyCount = this.details.querySelector(".replyCount"));
  this.content = this.article.querySelector(".forumPostContent");
  this.controls = this.content.querySelector(".controls");
  this.text = this.content.querySelector(".forumPostText");
  var e = this.article.parentElement();
  if ("reply" != a.mode || this.originalPost) {
    this.formContainer = e;
  } else {
    this.formContainer = this.repliesContainer =
      e.querySelector(".forumPostReplies");
    e = $jscomp.makeIterator(c.replies);
    for (var f = e.next(); !f.done; f = e.next()) {
      b.addPost(f.value);
    }
  }
  this.addEventListeners();
}
extend(ForumPostExtant, ForumPost);
function ForumPostNew(a, b, c, d) {
  c.userID = a.user.id;
  ForumPostNew.parent.constructor.call(this, a, b, c);
  this.data.username = a.user.username;
  this.data.parentPostExists = !0;
  this.data.replyingToUserID = d.data.userID;
  this.data.isEdited = !1;
  this.data.dateEdited = null;
  c.replyingTo_id == b.originalPostID &&
    1 < b.page &&
    (this.data.parentPostPage = 1);
  this.data.replyCount = 0;
  this.dates = { dateCreated: new Date(c.dateCreated) };
  this.text = new node("div", {
    class: "forumPostText",
    itemprop: "articleBody speakable",
  });
  for (
    var e = $jscomp.makeIterator(c.text.split(/[\r\n]+/)), f = e.next();
    !f.done;
    f = e.next()
  ) {
    (f = f.value), this.text.appendNode("p", null).innerHTML(f);
  }
  void 0 !== this.data.parentPostPage
    ? ((e = page.fullPath + "/thread/" + b.id), (b = b.originalPostUsername))
    : ((e = ""), (b = d.data.username));
  c = new node("div", "forumPostContainer").append(
    (this.article = new node("article", {
      id: "forumPost" + c.id,
      class: "forumPost userPost",
      itemscope: null,
      itemtype: "http://schema.org/DiscussionForumPosting",
    }).append(
      (this.details = new node("div", "forumPostDetails").append(
        new node("p", "top").append(
          new node("span", {
            itemprop: "author",
            itemscope: null,
            itemtype: "http://schema.org/Person",
          }).append(
            (this.userLink = new node(
              "a",
              {
                class: "forumUserLink signedInUser",
                href: page.fullPath + "/user/" + a.user.userPath,
                rel: "author",
                itemprop: "url",
              },
              "You"
            ))
          )
        ),
        (this.detailsMiddle = new node("div", "middle").append(
          new node("p", {
            title: "created " + this.forum.dateFormat(this.dates.dateCreated),
          }).append(
            new node("span", "fa fa-clock-o"),
            " ",
            (this.dateCreated = new node(
              "time",
              {
                class: "dateCreated",
                datetime: c.dateCreated,
                itemprop: "dateCreated",
              },
              forumInterval(this.dates.dateCreated)
            ))
          )
        ))
      )),
      (this.content = new node("div", "forumPostContent").append(
        new node("header").append(
          new node("p", "replyingTo").append(
            "replying to ",
            (this.replyingToLink = new node(
              "a",
              {
                href: e + "#forumPost" + c.replyingTo_id,
                class: "replyingToLink",
              },
              b
            ))
          )
        ),
        (this.controls = new node("div", "controls").append(
          (this.editButton = new node("button", {
            class: "edit fa fa-pencil",
            type: "button",
            title: "edit",
          })),
          (this.replyButton = new node("button", {
            class: "reply fa fa-reply",
            type: "button",
            title: "reply",
          }))
        )),
        this.text
      ))
    ))
  );
  a.superuser
    ? this.controls.append(
        (this.featureButton = new node("button", {
          class: "feature fa fa-star",
          type: "button",
          title: "feature",
        })),
        (this.censorButton = new node("button", {
          class: "censor fa fa-ban",
          type: "button",
          title: "censor",
        }))
      )
    : this.controls.appendChild(
        (this.reportButton = new node("button", {
          class: "report fa fa-flag",
          type: "button",
          title: "report abuse",
        }))
      );
  this.addEventListeners();
  this.formContainer =
    "date" == this.forum.mode
      ? c
      : (this.repliesContainer = c.appendNode("div", "forumPostReplies"));
  "date" == this.forum.mode || d.originalPost
    ? this.thread.appendPost(c)
    : d.appendReply(c);
  this.article.pulse("highlight");
}
extend(ForumPostNew, ForumPost);
function ForumForm(a, b, c) {
  var d = this;
  this.forum = a;
  this.thread = b;
  this.parentPost = c;
  this.previewMode = this.submitting = !1;
  this.form
    .addEventListener("submit", function (a) {
      return d.submit(a);
    })
    .addEventListener("reset", function () {
      return d.cancel();
    });
  this.textarea
    .addEventListener("focus", function () {
      return d.focus();
    })
    .addEventListener("keydown", function (a) {
      return d.keydown(a);
    });
  this.submitButton.addEventListener("click", function (a) {
    return d.submitButtonClick(a);
  });
  this.previewButton.addEventListener("click", function () {
    return d.preview();
  });
  this.guidelinesLink.addEventListener("click", function (a) {
    return d.guidelinesLinkClick(a);
  });
  this.form.querySelector("button.bold").addEventListener("click", function () {
    return d.selectionBold();
  });
  this.form
    .querySelector("button.italic")
    .addEventListener("click", function () {
      return d.selectionItalic();
    });
  this.form.querySelector("button.link").addEventListener("click", function () {
    return d.selectionLink();
  });
}
ForumForm.prototype = {
  constructor: ForumForm,
  urlRegex:
    /^(?:https?:\/\/)?(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*\.(?:[a-z\u00a1-\uffff]{2,})\.?(?:[/?#]\S*)?$/i,
  createSignInForm: function () {
    var a = this;
    this.forum.createSignInForm(function () {
      return a.setFocus();
    });
  },
  focus: function () {
    this.forum.signedIn
      ? ((this.active = !0),
        this.form.removeClass("inactive"),
        this.thread.formFocus(this))
      : this.createSignInForm();
  },
  setFocus: function () {
    this.textarea.focus();
  },
  submitButtonClick: function (a) {
    this.forum.signedIn
      ? this.active || (a.preventDefault(), this.setFocus())
      : (a.preventDefault(), this.createSignInForm());
  },
  process: function () {
    return this.textarea
      .value()
      .replace(
        /<((?!(?:\/?b|\/?i|a\s+href="[^"]+"|\/a)>)[^>]*)>/g,
        "&lt;$1&gt;"
      );
  },
  submittingOn: function () {
    this.submitting = !0;
    this.submitButton
      .addClass("submitting")
      .empty()
      .append("Submitting", new node("span", "fa fa-spin fa-circle-o-notch"));
  },
  submittingOff: function () {
    this.submitting = !1;
    this.submitButton.removeClass("submitting").empty().textContent("Submit");
  },
  submit: function (a) {
    void 0 !== a && a.preventDefault();
    if (this.submitting) {
      return !1;
    }
    this.submittingOn();
    this.text = this.process();
    this.submitData();
    return !0;
  },
  submitData: function () {
    var a = this;
    this.forum.insertPost(
      {
        forumThread_id: this.thread.id,
        forumUser_id: this.forum.user.id,
        replyingTo_id: this.parentPostID,
        text: this.text,
      },
      function (b) {
        return a.submitSuccess(b);
      }
    );
  },
  submitSuccess: function (a) {
    this.submittingOff();
    a.success ? this.showOutput(a) : this.submitError(a);
  },
  showOutput: function (a) {
    a.post.replyingTo_id = this.parentPostID;
    a.post.text = this.text;
    this.thread.insertPost(a.post);
    void 0 !== this.parentPost && this.parentPost.bumpReplyCount();
  },
  submitError: function (a) {
    switch (a.failType) {
      case "spam":
        a.discard
          ? this.forum.signOut()
          : this.displayError(
              "Your post was flagged as possible spam by our automated filter. It has been submitted but censored and will be reviewed by a member of our team."
            );
        break;
      case "profanity":
        this.displayError(
          "Our automated filter has detected profanity in your post. It has been submitted but censored and will be reviewed by a member of our team."
        );
        break;
      case "contactDetails":
        this.displayError(
          "Our automated filter has detected contact details in your post. We do not allow any posts containing contact information or other identifying information. It has been submitted but censored and will be reviewed by a member of our team."
        );
        break;
      default:
        this.displayError(
          "There was an error submitting your post. If the problem persists, please contact ",
          new node("a", { href: "forum@adfam.org.uk" }, "forum@adfam.org.uk"),
          "."
        );
    }
  },
  preview: function (a) {
    a = void 0 === a ? !1 : a;
    if (this.previewMode) {
      this.previewClose();
    } else {
      var b = this.process();
      if ("" == b) {
        return !1;
      }
      this.previewMode = !0;
      this.previewButton.textContent("Edit");
      var c = new Date(),
        d = new node("div", "forumPostText");
      d.innerHTML("<p>" + b.replace(/[\r\n]+/g, "</p><p>") + "</p>");
      this.previewNode = new node("div", "preview").append(
        new node("div", "forumPostDetails forumPostDetailsNarrow").append(
          new node("p", "top").append(
            new node("span").append(
              new node(
                "a",
                {
                  class: "forumUserLink signedInUser",
                  href:
                    "/help-for-families/finding-support/forum/user/" +
                    this.forum.user.userPath,
                },
                "You"
              )
            )
          ),
          new node("div", "middle").append(
            new node("p", {
              class: "date",
              title: "created " + this.forum.dateFormat(c),
            }).append(
              new node("span", "fa fa-clock-o"),
              " ",
              new node(
                "time",
                { class: "forumPostDateCreated", datetime: c.toISOString() },
                "0s ago"
              )
            )
          )
        ),
        new node("div", "forumPostContent").append(
          (this.previewHeader = new node("header")),
          d
        )
      );
      a ||
        this.previewHeader.appendNode("p", "replyingTo").append(
          "replying to ",
          new node(
            "a",
            {
              class: "replyingToLink",
              href: "#forumPost" + this.parentPostID,
            },
            this.replyingToUsername
          )
        );
      this.form.addClass("preview");
      this.form.insertAfter(this.previewNode, this.textarea);
    }
    return !0;
  },
  previewClose: function () {
    this.previewMode = !1;
    this.previewButton.textContent("Preview");
    this.previewNode.remove();
    this.form.removeClass("preview");
  },
  cancel: function () {
    this.hide();
  },
  hide: function () {
    this.active = !1;
    this.previewMode && this.previewClose();
    void 0 !== this.errorMessage &&
      (this.errorMessage.remove(), delete this.errorMessage);
    this.form.offsetHeight();
    this.form.addClass("inactive");
  },
  keydown: function (a) {
    if (a.ctrlKey) {
      switch (a.key) {
        case "Enter":
          this.submit();
          break;
        case "b":
          this.selectionBold();
          break;
        case "i":
          this.selectionItalic();
          break;
        case "k":
          a.preventDefault(), this.selectionLink();
      }
    }
  },
  selectionBold: function () {
    this.selectionInsertTags("b");
  },
  selectionItalic: function () {
    this.selectionInsertTags("i");
  },
  selectionLink: function () {
    var a = this.textarea
      .value()
      .slice(this.textarea.selectionStart(), this.textarea.selectionEnd())
      .trim()
      .toLowerCase();
    a = a.match(this.urlRegex) ? prompt("URL:", a) : prompt("URL:");
    null !== a &&
      ((a = a.trim().toLowerCase()),
      null !== a.match(this.urlRegex)
        ? this.selectionInsertTags("a", { href: a })
        : alert("Not a valid URL."));
  },
  selectionInsertTags: function (a, b) {
    var c = this.textarea.selectionStart(),
      d = this.textarea.selectionEnd(),
      e = "";
    if (void 0 !== b) {
      for (var f in b) {
        b.hasOwnProperty(f) && (e += " " + f + '="' + b[f] + '"');
      }
    }
    b = this.textarea.value();
    this.textarea.value(
      b.slice(0, c) +
        "<" +
        a +
        e +
        ">" +
        b.slice(c, d) +
        "</" +
        a +
        ">" +
        b.slice(d)
    );
    this.textarea.focus();
    this.textarea.selectionStart(d + 2 * a.length + e.length + 5);
    this.textarea.selectionEnd(this.textarea.selectionStart());
  },
  guidelinesLinkClick: function (a) {
    var b = this;
    a.preventDefault();
    void 0 === this.guidelines
      ? ((this.guidelines = new node("div", "guidelines hidden")),
        this.guidelines.innerHTML(this.forum.guidelines),
        this.form.insertAfter(this.guidelines, this.notice),
        this.guidelines.offsetHeight(),
        this.guidelines.removeClass("hidden"))
      : this.guidelines.addTransitionListenerOnce("hidden", function () {
          return b.guidelinesRemove();
        });
  },
  guidelinesRemove: function () {
    this.guidelines.remove();
    delete this.guidelines;
  },
  sign: function (a) {},
  displayError: function (a) {
    void 0 === this.errorMessage
      ? (this.errorMessage = this.form.prependNode("p", "error"))
      : this.errorMessage.empty();
    this.errorMessage.append.apply(this.errorMessage, arguments);
  },
};
function ForumFormExtant(a, b, c, d, e) {
  this.active = !1;
  this.parentPostID = c;
  this.replyingToUsername = d;
  this.form = node.querySelector(".forumFormExtant");
  this.notice = this.form.querySelector(".notice");
  this.guidelinesLink = this.notice.querySelector(".guidelinesLink");
  this.textarea = this.form.querySelector("textarea");
  this.submitButton = this.form.querySelector(".submitButton");
  this.previewButton = this.form.querySelector(".previewButton");
  ForumFormExtant.parent.constructor.call(this, a, b, e);
}
extend(ForumFormExtant, ForumForm, {
  submitSuccess: function (a) {
    ForumFormNew.parent.submitSuccess.apply(this, arguments);
    a.success && (this.form.reset(), this.hide());
  },
});
function ForumFormExtantNewThread(a, b) {
  ForumFormExtantNewThread.parent.constructor.call(this, a);
  this.active = !0;
  this.categoryID = b.categoryID;
  this.title = this.form.querySelector(".forumFormTitle");
}
extend(ForumFormExtantNewThread, ForumFormExtant, {
  focus: function () {
    this.forum.signedIn || this.createSignInForm();
  },
  submitData: function () {
    var a = this;
    this.forum.insertThread(
      {
        title: this.title.value(),
        forumCategory_id: this.categoryID,
        forumUser_id: this.forum.user.id,
        text: this.text,
      },
      function (b) {
        return a.submitSuccess(b);
      }
    );
  },
  showOutput: function (a) {
    location.href = page.fullPath + "/thread/" + a.thread.id;
  },
  preview: function () {
    if (!ForumFormExtantNewThread.parent.preview.call(this, !0)) {
      return !1;
    }
    this.previewMode &&
      this.previewHeader.appendNode("h2", null, this.title.value());
    return !0;
  },
  sign: function (a) {
    a || location.assign(location.href.substring(0, location.href.length - 4));
  },
});
function ForumFormNew(a, b, c) {
  var d = this;
  this.active = !0;
  this.form = new node("form", {
    class: "forumForm inactive",
    action: "/script/forum.php",
    method: "post",
  }).append(
    (this.notice = new node("p", "notice").append(
      "Please abide by our ",
      (this.guidelinesLink = new node(
        "a",
        {
          class: "guidelinesLink",
          href: "/help-for-families/finding-support/forum/forum-guidelines",
        },
        "forum guidlines"
      )),
      "."
    )),
    (this.textarea = new node("textarea", {
      placeholder: "reply to " + this.replyingToUsername,
      required: null,
    })),
    (this.closeButton = new node("button", {
      type: "button",
      class: "close fa fa-times",
    })),
    new node("div", "controls").append(
      new node("div", "formatting").append(
        new node("button", { type: "button", class: "bold" }, "B"),
        new node("button", { type: "button", class: "italic" }, "I"),
        new node("button", { type: "button", class: "link" }, "link")
      ),
      new node("div", "submit").append(
        (this.submitButton = new node(
          "button",
          { type: "submit", class: "submitButton" },
          "Submit"
        )),
        (this.previewButton = new node(
          "button",
          { type: "button", class: "previewButton" },
          "Preview"
        )),
        new node("input", { type: "reset", value: "Cancel" })
      )
    ),
    new node("p", "akismetNotice").append(
      "This forum uses Akismet to reduce spam. ",
      new node(
        "a",
        { href: "https://akismet.com/privacy/", target: "_blank" },
        "Learn how your comment data is processed"
      ),
      "."
    )
  );
  ForumFormNew.parent.constructor.apply(this, arguments);
  this.closeButton.addEventListener("click", function () {
    return d.close();
  });
}
extend(ForumFormNew, ForumForm, {
  submitSuccess: function (a) {
    ForumFormNew.parent.submitSuccess.apply(this, arguments);
    a.success && this.close();
  },
});
function ForumFormNewReply(a, b, c) {
  this.parentPostID = c.data.id;
  this.replyingToUsername = c.data.username;
  ForumFormNewReply.parent.constructor.apply(this, arguments);
  "reply" == a.mode &&
    !c.originalPost &&
    0 < c.data.replyCount &&
    this.form.addClass("beforeReplies");
  c.insertForm(this.form);
  this.textarea.focus();
}
extend(ForumFormNewReply, ForumFormNew, {
  close: function () {
    this.form.remove();
  },
});
function ForumFormNewEdit(a, b, c) {
  this.parentPostID = c.data.replyingTo_id;
  this.replyingToUsername = c.data.replyingToUsername;
  ForumFormNewEdit.parent.constructor.call(this, a, b);
  this.post = c;
  this.textarea.value(c.data.text);
  c.content.replace(this.form);
  this.textarea.focus();
}
extend(ForumFormNewEdit, ForumFormNew, {
  cancel: function () {
    this.close();
  },
  close: function () {
    this.post.closeEditForm();
    this.form.replace(this.post.content);
  },
  submitData: function () {
    var a = this;
    this.forum.updatePost(this.post.data.id, this.text, function (b) {
      return a.submitSuccess(b);
    });
  },
  showOutput: function (a) {
    this.post.update(this.text);
  },
});
function forumInterval(a) {
  var b = new Date(),
    c = interval(a, b);
  if ("date" == c.unit) {
    if (
      ((c = a.getDate() + " " + a.getMonthNameShort()),
      a.getFullYear() < b.getFullYear() - 1 ||
        (a.getFullYear() == b.getFullYear() - 1 &&
          a.getMonth() <= b.getMonth()))
    ) {
      c += " " + a.getFullYear();
    }
  } else {
    c = c.time + c.unit + " ago";
  }
  return c;
}
function Forum(a) {
  var b = this;
  if ((this.signedIn = void 0 !== session.forumUser)) {
    this.user = new ForumUser(session.forumUser);
  }
  this.superuser = this.signedIn && this.user.superuser;
  this.mode = a.mode;
  this.page = a.page;
  this.descending = a.descending;
  this.limit = a.limit;
  switch (a.type) {
    case "home":
      this.displayObject = new ForumCategories(this, a.data);
      break;
    case "category":
      this.displayObject = new ForumCategory(this, a.data.threads, !0);
      break;
    case "user":
      this.displayObject = new ForumThreadList(this, a.data.threads);
      break;
    case "thread":
      this.displayObject = new ForumThreadFull(this, a.data, a.page);
      break;
    case "new":
      this.displayObject = new ForumFormExtantNewThread(this, a.data);
      break;
    case "settings":
      (this.displayObject = new ForumUserDetailsForm(this, a.data)),
        new ForumUserPasswordForm(this, a.data);
  }
  if ("thread" == a.type || "new" == a.type) {
    this.guidelines = a.guidelines;
  }
  this.navHeight = node.querySelector(".forumNav").offsetHeight();
  this.userMenu = node.querySelector(".forumUserMenu");
  this.userMenuUsername = this.userMenu.querySelector(".username");
  this.signedIn
    ? this.userMenu
        .querySelector(".signOut")
        .addEventListener("click", function () {
          return b.signOut();
        })
    : (this.userMenu
        .querySelector(".signIn")
        .addEventListener("click", function () {
          return b.createSignInForm();
        }),
      this.userMenu
        .querySelector(".register")
        .addEventListener("click", function () {
          return b.createRegistrationForm();
        }));
}
Forum.prototype = {
  constructor: Forum,
  forumUserSignInColumns: ["username", "password"],
  forumUserRegistrationColumns: [
    "email",
    "username",
    "password",
    "caseStudies",
    "emailNotifications",
  ],
  executeStatement: function (a, b, c) {
    a = { action: a };
    void 0 !== b && (a.data = b);
    b = {
      error: function (a, b, c) {
        console.log(a, b, c);
      },
    };
    void 0 !== c && (b.success = c);
    new AJAX().post("/script/forum.php", a, b);
  },
  insertThread: function (a, b) {
    this.executeStatement("insertThread", a, b);
  },
  insertPost: function (a, b) {
    this.executeStatement("insertPost", a, b);
  },
  updatePost: function (a, b, c) {
    this.executeStatement("updatePost", { text: b, id: a }, c);
  },
  setMode: function (a, b) {
    var c = this;
    this.executeStatement("setMode", { mode: a, threadID: b }, function (a) {
      return c.setModeSuccess(a);
    });
  },
  setModeSuccess: function (a) {
    a.success
      ? ("all" !== this.limit &&
          this.page > a.pageMax &&
          (this.page = a.pageMax),
        location.assign(
          location.pathname + (1 < this.page ? "?page=" + this.page : "")
        ))
      : console.error(a);
  },
  setDescending: function (a) {
    var b = this;
    this.executeStatement("setDescending", { descending: a }, function (a) {
      return b.setDescendingSuccess(a);
    });
  },
  setDescendingSuccess: function (a) {
    a.success
      ? location.assign(location.pathname + location.search)
      : console.error(a);
  },
  setLimit: function (a) {
    var b = this;
    this.executeStatement("setLimit", { limit: a }, function (c) {
      return b.setLimitSuccess(c, a);
    });
  },
  setLimitSuccess: function (a, b) {
    a.success
      ? ((this.page =
          "all" !== b ? Math.ceil(((this.page - 1) * this.limit + 1) / b) : 1),
        location.assign(
          location.pathname + (1 < this.page ? "?page=" + this.page : "")
        ))
      : console.error(a);
  },
  checkUserExists: function (a, b, c) {
    var d = this;
    void 0 !== this.checkUserExistsTimer &&
      clearTimeout(this.checkUserExistsTimer);
    this.checkUserExistsTimer = setTimeout(function () {
      return d.checkUserExistsExecute(a, b, c);
    }, 500);
  },
  checkUserExistsExecute: function (a, b, c) {
    this.executeStatement("checkUserExists", { field: a, value: b }, c);
  },
  createModalForm: function () {
    void 0 === this.modalFormContainer &&
      (this.modalFormContainer = new ForumModalFormContainer(this));
  },
  createSignInForm: function (a) {
    this.signInCallback = a;
    this.createModalForm();
    this.modalFormContainer.appendForm(
      new ForumSignInForm(this, this.modalFormContainer)
    );
  },
  createRegistrationForm: function () {
    this.createModalForm();
    this.modalFormContainer.appendForm(
      new ForumRegistrationForm(this, this.modalFormContainer)
    );
  },
  closeModalForm: function () {
    delete this.modalFormContainer;
  },
  signIn: function (a) {
    var b = this;
    this.user = new ForumUser(a);
    this.signedIn = !0;
    this.superuser = this.user.superuser;
    this.userMenu.empty().append(
      new node("div", "label iconButton").append(
        new node("span", "fa fa-user-circle"),
        a.username
      ),
      new node("div", "subMenu").append(
        new node("button", {
          type: "button",
          class: "forumButton iconButton signOut",
        })
          .append(new node("span", "fa fa-sign-out"), "Sign out")
          .addEventListener("click", function () {
            return b.signOut();
          }),
        new node("a", {
          href: page.fullPath + "/user/" + this.user.userPath,
          class: "forumButton iconButton",
        }).append(new node("span", "fa fa-comment"), "Your posts"),
        new node("a", {
          href: page.fullPath + "/settings",
          class: "forumButton iconButton",
        }).append(new node("span", "fa fa-cog"), "Settings")
      )
    );
    this.displayObject.sign(!0);
    void 0 !== this.signInCallback &&
      (this.signInCallback(), delete this.signInCallback);
  },
  signOut: function () {
    var a = this;
    this.userMenu.empty().append(
      new node("button", {
        type: "button",
        class: "forumButton iconButton signIn",
      })
        .append(new node("span", "fa fa-sign-in"), "Sign in")
        .addEventListener("click", function () {
          return a.createSignInForm();
        }),
      new node("button", {
        type: "button",
        class: "forumButton iconButton register",
      })
        .append(new node("span", "fa fa-user-plus"), "Register")
        .addEventListener("click", function () {
          return a.createRegistrationForm();
        })
    );
    this.displayObject.sign(!1);
    this.executeStatement("signOut");
    delete this.user;
    this.superuser = this.signedIn = !1;
  },
  updateUsername: function (a) {
    this.userMenuUsername.textContent(a);
  },
  dateFormat: function (a) {
    return (
      a.getDate() +
      " " +
      a.getMonthNameShort() +
      " " +
      a.getFullYear() +
      " " +
      a.getHours() +
      ":" +
      this.numberPad(a.getMinutes()) +
      ":" +
      this.numberPad(a.getSeconds())
    );
  },
  numberPad: function (a) {
    return (10 > a ? "0" : "") + a.toString();
  },
};
domReady.add(function () {
  "forum" == page.path &&
    null !== forumParameters &&
    new Forum(forumParameters);
});
function EmailMPForm() {
  var a = this;
  console.log("sdfsd");
  this.node = node.querySelector(this.selector);
  this.tbody = this.node.querySelector("tbody");
  this.input = this.node.querySelector("input#emailMPFormPostcode");
  this.submitButton = this.node.querySelector("button[type=submit]");
  this.node.addEventListener("submit", function (b) {
    console.log("sdfsdf");
    return a.submit(b);
  });
}

EmailMPForm.prototype = {
  constructor: EmailMPForm,
  selector: ".emailMPForm",
  path: "/script/mpLookup.php",
  postcodeRegex:
    /^(([A-Z]{1,2}[0-9][A-Z0-9]?|ASCN|STHL|TDCU|BBND|[BFS]IQQ|PCRN|TKCA) ?[0-9][A-Z]{2}|BFPO ?[0-9]{1,4}|(KY[0-9]|MSR|VG|AI)[ -]?[0-9]{4}|[A-Z]{2} ?[0-9]{2}|GE ?CX|GIR ?0A{2}|SAN ?TA1)$/i,
  email: {
    cc: "admin@adfam.org.uk",
    subject: encodeURIComponent(
      "Act with Adfam to support the Forgotten 5 Million"
    ),
    body: "Dear {mpName} MP,\n\nI am writing to you as my local MP to draw your attention to Adfam\u2019s #Forgotten5Million campaign [https://adfam.org.uk/forgotten5million]. Adfam, the national charity improving life families affected by drugs, alcohol and gambling, estimates that 1 in 10 adults in Great Britain are currently negatively affected by someone else\u2019s substance use, this amounts to 5 million people\u2013 a stark figure demonstrating that anyone could be affected. Yet this group continues to suffer in silence, and remains forgotten in terms of public awareness and policy.\n\nThe effects of substance use on families and friends is profound, and these 5 Million people experience a range of daily challenges including mental ill-health, violence and abuse, relationship difficulties, financial strain, isolation and stigma.\n\nCOVID-19 has certainly exacerbated these situations and evidence from Adfam\u2019s recent Families in Lockdown report [https://adfam.org.uk/files/Families-in-lockdown.pdf] emphasises just how challenging it has been for the Forgotten 5 Million. 88% of respondents said lockdown negatively impacted on their family member\u2019s drug or alcohol problem, 85% said they were finding it harder to cope, and 50% said the lockdown had impacted negatively on their own mental health. As we move into a second national lockdown it is essential these harms are acted upon. It is for this reason that Adfam is launching its #Forgotten5Million campaign to ensure no-one is left behind.\n\nI am therefore asking you to champion for this change on my behalf, and to raise the issue of supporting families affected by substance use with Kit Malthouse MP, the Minister for Crime and Policing, with responsibility for drug and alcohol policy.\n\nAdfam is calling on the Minister to:\n\n1. Increase services to support children and adults affected by a loved one\u2019s drug or alcohol problem\n2. Ensure that family members affected by someone\u2019s drug or alcohol problem are referred to the services that already exist\n3. Safeguard vulnerable children in households where there is a person with a severe drug or alcohol problem and offer specialist support\n\nI look forward to hearing from you.\n\nYours sincerely,\n\nNAME\n\nADDRESS (so that you can be identified as a constituent)\n\n",
  },
  tweetText:
    "I'm supporting @AdfamUK's new campaign and have written to my local MP @{mpTwitterUsername} to ask them how they will better support the 5 million people affected by someone else's drug or alcohol use.",
  setSubmitting: function (a) {
    this.submitting = a;
    this.submitButton.changeClass("submitting", a).empty();
    a
      ? this.submitButton.append(
          "Submitting",
          new node("span", "fa fa-spin fa-circle-o-notch")
        )
      : this.submitButton.textContent("Submit");
  },
  postcodeValid: function (a) {
    return "" != a && this.postcodeRegex.test(a);
  },
  submit: function (a) {
    var b = this;
    a.preventDefault();
    if (this.submitting) {
      return !1;
    }
    a = this.input.value();
    if (!this.postcodeValid(a)) {
      return this.displayError("Invalid Postcode"), !1;
    }
    this.setSubmitting(!0);
    new AJAX().post(
      this.path,
      { postcode: a },
      {
        success: function (a) {
          return b.submitSuccess(a);
        },
      }
    );
    return !0;
  },
  submitSuccess: function (a) {
    this.setSubmitting(!1);
    a.success
      ? (this.clearError(), this.drawMP(a.mp))
      : (this.displayError(
          "There was an error finding your MP. If the problem persists, please contact ",
          new node("a", { href: "admin@adfam.org.uk" }, "admin@adfam.org.uk"),
          "."
        ),
        console.error(a.error));
  },
  drawMP: function (a) {
    void 0 === this.mpNode
      ? this.node
          .parentNode()
          .insertAfter((this.mpNode = new node("div", "mp")), this.node)
      : this.mpNode.empty();
    var b;
    this.mpNode.append(
      new node("h2", null, "Your MP"),
      new node("dl").append(
        new node("div", "dlRow").append(
          new node("dt", null, "Name:"),
          new node("dd", null, a.name)
        ),
        new node("div", "dlRow").append(
          new node("dt", null, "Constituency:"),
          new node("dd", null, a.constituency)
        ),
        new node("div", "dlRow").append(
          new node("dt", null, "Party:"),
          new node("dd", null, a.party)
        )
      ),
      (b = new node("div"))
    );
    null !== a.email &&
      b
        .appendNode("a", {
          class: "iconButton",
          href:
            "mailto:" +
            a.email +
            "?cc=" +
            this.email.cc +
            "&subject=" +
            this.email.subject +
            "&body=" +
            encodeURIComponent(this.email.body.replace("{mpName}", a.name)),
          target: "_blank",
        })
        .append(new node("span", "fa fa-envelope"), "Email");
    null !== a.twitterUsername &&
      b
        .appendNode("a", {
          class: "iconButton",
          href:
            "https://twitter.com/intent/tweet?text=" +
            encodeURIComponent(
              this.tweetText.replace("{mpTwitterUsername}", a.twitterUsername)
            ) +
            "&url=https://adfam.org.uk/influencing-for-change/forgotten5million&hashtags=Forgotten5Million",
          target: "_blank",
        })
        .append(new node("span", "fa fa-twitter"), "Tweet");
    null === a.email &&
      null === a.twitterUsername &&
      b.appendNode("p", null, "No contact details found.");
  },
  displayError: function (a) {
    void 0 === this.errorMessage
      ? (this.errorMessage = this.tbody
          .prependNode("tr", "error")
          .appendNode("td", { colspan: 2 })
          .appendNode("p"))
      : this.errorMessage.empty();
    this.errorMessage.append.apply(this.errorMessage, arguments);
  },
  clearError: function () {
    void 0 !== this.errorMessage &&
      (this.errorMessage.remove(), delete this.errorMessage);
  },
};
domReady.add(function () {
  location.pathname.includes("write-to-mp") && new EmailMPForm();
});
function ReferralForm(a, b) {
  this.columns = b[a];
  this.action = a;
  this.node = node.querySelector(".referralForm");
  ReferralForm.parent.constructor.call(this, {});
}
extend(ReferralForm, ExtantForm, {
  handler: "/script/referralSubmit.php",
  errorEmail: "admin@adfam.org.uk",
});
function ReferralSignForm(a, b) {
  this.columns = (this.signIn = a) ? b : [];
  this.action = a ? "signIn" : "signOut";
  this.node = node.querySelector(".referralSignForm");
  ReferralSignForm.parent.constructor.call(this, {});
  a || (this.data.forceSubmit = !0);
}
extend(ReferralSignForm, ExtantForm, {
  handler: "/script/referralSign.php",
  errorEmail: "admin@adfam.org.uk",
  submitSuccess: function (a) {
    a.success
      ? setTimeout(function () {
          return location.reload();
        }, 1000)
      : this.signIn && this.displayError("Unknown email or password");
    ReferralSignForm.parent.submitSuccess.apply(this, arguments);
  },
});
domReady.add(function () {
  switch (page.path) {
    case "east-sussex":
      new ReferralForm("referralEastSussex", referralColumns);
      break;
    case "big-lottery-referral":
      new ReferralForm("referralBigLottery", referralColumns);
      break;
    case "export-referral":
      new ReferralSignForm(
        !referralSignedIn,
        referralSignedIn ? void 0 : referralColumns.referralUser
      );
  }
});
function CookiePreferenceForm(a) {
  var b = this;
  this.container = a;
  a.querySelector('button[name="accept"]').addEventListener(
    "click",
    function () {
      return b.accept();
    }
  );
  a.querySelector('button[name="reject"]').addEventListener(
    "click",
    function () {
      return b.reject();
    }
  );
}
CookiePreferenceForm.prototype = {
  constructor: CookiePreferenceForm,
  accept: function () {
    this.submit(!0);
  },
  reject: function () {
    window["ga-disable-UA-1300669-1"] = !0;
    this.submit(!1);
  },
  submit: function (a) {
    var b = this;
    new AJAX().post(
      "/script/cookiePreference.php",
      { accept: a },
      {
        success: function () {
          return b.submitSuccess();
        },
      }
    );
  },
  submitSuccess: function () {
    this.container.remove();
  },
};
domReady.add(function () {
  var a = node.querySelector(".cookieNotice");
  !1 !== a && new CookiePreferenceForm(a);
});
